import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import load from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";
import * as api from "../../api_function";
import { colors } from "@mui/material";

const userName2 = "manager1";

const billtypeOpts = [
  { value: "", label: "Select Option" },
  { value: "122050000", label: "Advance" },
  { value: "122050001", label: "Arrear" },
];


const segments = [
  { value: "", label: "Select Option" },
  { value: "Connectivity Solution", label: "Connectivity Solution" },
  { value: "Data Centre Products", label: "Data Centre Products" },
  { value: "Internet Service", label: "Internet Service" },
  { value: "SDWAN", label: "SDWAN" },
  { value: "SIP-Trunk", label: "SIP-Trunk" },
  { value: "VOIP", label: "VOIP" },
  { value: "Video Analytics", label: "Video Analytics" },
];

const CommModeOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "Email" },
  { value: "111260001", label: "SMS" },
];

const MonitorDaysOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "Yes" },
  { value: "111260001", label: "No" },
];

const BusDaysOpts = [
  { value: "", label: "Select Option", isDisabled: false },
  { value: "111260000", label: "MON-SUN" },
  { value: "111260001", label: "MON-SAT" },
  { value: "111260002", label: "MON-FRI" },
];

const optionPayment = [
  { label: "Select Option", value: "0" },
  { label: "Online", value: "Online" },
  { label: "Offline", value: "Offline" },
]
const optionDocument = [
  // { label: "AADHAR", value: "AADHAR" },
  { label: "COI", value: "CIN" },
  { label: "GST", value: "GST" },
  { label: "DL", value: "LICENCE" },
  { label: "PAN", value: "PAN" },
  // { label: "Voter ID", value: "VOTERID" },
];

const PaymentOpts = [
  { value: "0", label: "Select Option" },
  { value: "111260000", label: "Payment Validation Failed" },
  { value: "111260001", label: "Upfront approved amount and Customer Paid Amount Mismatch" },
  { value: "569480002", label: "Pending" },
  { value: "569480000", label: "Payment Not Received" },
  { value: "569480001", label: "Payment Received" },
];

const payslipOpts = [
  { value: "0", label: "Select Option" },
  { value: "5", label: "RTGS" },
  { value: "1", label: "Cheque" },
  { value: "2", label: "Demand draft" },
  // { value: "7", label: "Credit Card" },
  // { value: "4", label: "NEFT" },
  // { value: "8", label: "Debit Card" },
  // { value: "11", label: "Ezetap" },
  // { value: "12", label: "Ezetap-Cheque" },
  { value: "13", label: "Payment Gateway" },
];

const optionCountry = [{ label: "India", value: "10001" }];
const optionNatinality = [
  { label: "Select Option", value: "0" },
  { label: "Indian", value: "1" },
  { label: "Korean", value: "3" },
  { label: "Other", value: "2" }
];

const optionAuthState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];

const custmrworkhrsoptions = [
  { value: "", label: "Select Option" },
  { value: "122050000", label: "10 AM to 6 PM" },
  { value: "122050001", label: "6 PM to 2 AM" },
  { value: "122050002", label: "2 AM to 10 AM" },
];

const voiOpts = [
  { value: "", label: "Select Option" },
  { value: "569480000", label: "Yes" },
  { value: "569480001", label: "No" },
]

const customercatOpts = [
  { value: "", label: "Select Option" },
  { value: "569480000", label: "OSP" },
  { value: "569480001", label: "Non OSP" },
];

const ServiceProviders = [
  { label: "Select Service Provider 1", value: "0" },
  { label: "Jio", value: "111260000" },
  { label: "ACT Fibernet", value: "569480014" },
  { label: "N.A", value: "569480012" },
  { label: "Others", value: "569480013" },
  { label: "Airtel", value: "569480000" },
  { label: "Aircel", value: "569480002" },
  { label: "BSNL", value: "569480003" },
  { label: "Hathway", value: "569480004" },
  { label: "MTNL", value: "569480005" },
  { label: "Nextra", value: "569480006" },
  { label: "Reliance Communications", value: "569480007" },
  { label: "Sify", value: "569480008" },
  { label: "Tata Communications", value: "569480009" },
  { label: "Tata DOCOMO", value: "569480010" },
  { label: "Tikona Infinet", value: "569480011" },
  { label: "Vodafone", value: "569480001" },
];

const firewallOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

const selfpoOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
];

const SecuritypeOpts = [
  { value: "", label: "Select Option" },
  { value: "1", label: "Refundable Security Deposit" },
  { value: "2", label: "Non-Refundable Security Deposit" },
];


const BusinessSAFmanageForm = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const CafId = searchParams.get("CafId");
  const leadId = searchParams.get("LeadId");
  // const OppId = searchParams.get("OppId");
  const SafNo = searchParams.get("SafNo");
  const [workOrderHide, setWorkOrderHide] = useState(false);
  const [workOrderDetails, setWorkOrderDetails] = useState({});

  // sessionStorage.setItem("OppId", OppId);
  // console.log("leadId", leadId);
  // console.log("OppId", OppId);
  // OpportunityId
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [getCafDetails, setCafDetails] = useState();
  const [getBuildingInst, setBuildingInst] = useState();
  const [getBuildingBill, setBuildingBill] = useState();
  const [getAreaBill, setAreaBill] = useState();
  const [getAreaInst, setAreaInst] = useState();
  const [OppId, setOppId] = useState();

  const [activeForm, setActiveForm] = useState("form1");
  const [loading, setLoading] = useState(true);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [getFormInput, setFormInput] = useState([]);
  const [customerWorkingHours, setCustomerWorkingHours] = useState([]);


  const [paymentDetails, setPaymentDetails] = useState({});
  const [customerdropdetails, setCustomerdropdetails] = useState([]);
  const [reldropdetails, setReldropdetails] = useState([]);

  const [statusNoCaf, setStatusNoCaf] = useState(false);
  const [statusCaf, setStatusCaf] = useState(false);
  const [disableFileds, setDisableFields] = useState();
  const [salutate, setSalutate] = useState();
  const [mobileNo, setMobileNo] = useState();

  const [Caflatitude, setCaflatitude] = useState();
  const [Caflongitude, setCaflongitude] = useState();

  const [emailId, setEmailId] = useState();
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectGroup, setSelectGroup] = useState();
  const [selectRelationship, setSelectRelationship] = useState();
  const [compID, setcompID] = useState("");
  const [groupID, setgroupID] = useState("");

  const [customerComp, setcustomerComp] = useState();
  const [customerGroup, setcustomerGroup] = useState();
  const [selectedFirmType, setSelectedFirmType] = useState();
  const [firmTypes, setFirmTypes] = useState([]);
  const [apiProd, setApiProd] = useState();
  const [productdropdetails, setProductdropdetails] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState();
  const [selectedPlanCatType, setSelectedPlanCatType] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [CafNO, setCafNO] = useState();
  const [Voice, setVoice] = useState();
  const [TotalAmt, setTotalAmt] = useState("");
  const [Securitydep, setSecuritydep] = useState("");
  const [Securitydeptype, setSecuritydeptype] = useState("");
  const [transactionrefid, settransactionrefid] = useState("");
  const [approvalCode, setapprovalCode] = useState("");
  const [creditDetails, setcreditDetails] = useState("");
  const [chequeDDNo, setchequeDDNo] = useState("");
  const [branchName, setbranchName] = useState("");
  const [chequeDate, setchequeDate] = useState("");
  const [selectedPaySlipOption, setselectedPaySlipOption] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [BankDropDetails, setBankDropDetails] = useState([]);
  const [selectBank, setselectBank] = useState("");
  const [isGst, setIsGst] = useState();
  const [gst, setgst] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [GstNumber, setGstNumber] = useState("");
  const [apiStateCode, setApiStateCode] = useState("");
  const [apiCityCode, setApiCityCode] = useState("");
  const [apiAreaCode, setApiAreaCode] = useState("");
  const [apiSocietyCode, setApiSocietyCode] = useState("");
  const [apiFloorCode, setApiFloorCode] = useState("");
  const [apipinCode, setApiPinCode] = useState("");
  const [apiblockCode, setApiblockCode] = useState("");
  const [optionState, setOptionState] = useState([]);
  const [optionCity, setOptionCity] = useState([]);
  const [optionArea, setOptionArea] = useState([]);
  const [optionSociety, setOptionSociety] = useState([]);
  const [selectCity, setSelectCity] = useState();
  const [selectArea, setSelectArea] = useState();
  const [selectSociety, setSelectSociety] = useState();
  const [OtpValue, setOtpValue] = useState();
  const [OtpValue2, setOtpValue2] = useState();
  const [showOtpPage, setShowOtpPage] = useState(false);
  const [otpAuthStatus, setotpAuthStatus] = useState();
  const [paymentStatus, setpaymentStatus] = useState(PaymentOpts[0]);
  const [otc, setotc] = useState("");
  const [RCAmount, setRCAmount] = useState("");
  const [tan, setTan] = useState();
  const [pan, setPan] = useState();
  const [BTNSubmit, setBTNSubmit] = useState(false);
  const [BTNCreate, setBTNCreate] = useState(false);
  const [leadDisable, setLeadDisable] = useState(false);
  const [docHide, setdocHide] = useState(false);
  const [selectKycDoc, setSelectKycDoc] = useState("");
  // const [getCafNo,setGetCafNo]= useState("");
  const [customerImg, setCustomerImg] = useState("")
  // const [attachedFile, setAttachedFile] = useState("");
  // const [getRc, setRc] = useState(null);

  const [wcrDetails, setWcrDetails] = useState([]);
  const [npDetails, setNpDetails] = useState([]);
  const [irDetails, setIrDetails] = useState([]);
  const [selectVoip, setSelectVoip] = useState(voiOpts[0]);
  const [cusCategory, setCusCategory] = useState(customercatOpts[0]);
  const [serviceProvider, setServiceProvider] = useState(ServiceProviders[0]);
  const [otherFirewall, setOtherFirewall] = useState(firewallOpts[0]);
  const [selectSelfpo, setSelectSelfpo] = useState(selfpoOpts[0]);
  const [userdata, setUserData] = useState({
    techSupportEmail: "",
    InstPin: "",
    InstBuildingNo: "",
    Remarks: "",
    Redunancy: false,
    Block: "",
    Status: "",
    Statuscode: "",
    OppId: "",
    LeadId: "",
    PriceList: "",
    Topic: "",
    StateId: "",
    CityId: "",
    AreaId: "",
    BuildingId: "",
    BuildingCode: "",
    SpecificArea: "",
    SpecificBuilding: "",
    Building_BuildingStatus: "",
    NoOfUsers: "",
    NoOfBeds: "",
    IndustryId: "",
    ApprovalRequiredFlag: "",
    Reason: "",
    Area: "",

    Businesssegment: "",
    State: "",
    Salutation: "",
    Relationship: "",
    PostalCode: "",
    Mobilephone: "",
    Media: "",
    Lco: null,
    Industry: "",
    Group: "",
    Floor: "",
    TPFeasibilty: "",
    CreateAreaOrBuilding: false,
    Firmtype: "",
    Product: "",
    ProductSegment: "",
    FeasibilityRequired: false,
    Existingprovider: "",
    Emailaddress: "",
    Country: "",
    Companyname: "",
    City: "",
    leadname: "",
    Buildingname: "",
    BuildingNo: "",
    ContactPersonName: "",
    CustomerSegment: "",
    LastMileType: "",
    UpTimesla: "",
    FirewallSetToExpire: "",
    CompanySelf: "",
    PoLock: "",
    Price: "",
    OriginatingLead: "",
    FirewallAwc: "",
    PoNext: "",
    Company: "",
    TotalAmount: "",
    VerticalID: "",
    TypeOfOrder: "",
    PocClosureDate: "",
    TurnOver: "",
    SocietyName: "",
    SocietyId: "",
    SocietyStatus: "",
    HousePlotFlatNo: "",
    BlockTowerNumber: "",
    OTCAmount: "",
    SDAmount: "",
    RCAmount: "",
    IsPaymentLinkSendToCustomer: "",
    UpfrontApprovedSDAmount: "",
    UpfrontApprovedOTCAmount: "",
    UpfrontApprovedRCAmount: "",
    UpfrontReqSDAmount: "",
    UpfrontReqOTCAmount: "",
    UpfrontReqRCAmount: "",
    ApprovedSDAmount: "",
    ApprovedOTCAmount: "",
    ApprovedRCAmount: "",
    totalAmount: "",
    firstName: "",
    otp: "",
    dDupStatus: "",
    paymentDoaStatus: "",
    authorName: "",
    authorFather: "",
    authResidentialAddress: "",
    autherMobile: "",
    autherPhone: "",
    autherEmail: "",
    autherPinCode: "",
    contactName: "",
    billmail: "",
    billPhone: "",
    BillNationality: "",
    billedState: "",
    billCity: "",
    billArea: "",
    billBuildingNo: "",
    billBuildingId: "",
    billPin: "",
    billFloor: "",
    paymentDate: "",
  });
  const [paymentButton, setPaymentButton] = useState("");
  const [paymentLinkSentToCustomer, setPaymentLinkSentToCustomer] = useState("");
  //naveen
  const [companyOptions, setCompanyOptions] = useState([]);
  const [getGroupOptions, setGroupOptions] = useState([]);
  const [relationshipOptions, setRelationOptions] = useState([]);
  const [getCafDigiHome, setCafDigiHome] = useState({});
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [timer, setTimer] = useState(0);
  const [getCodeFlag, setCodeFlag] = useState(false);
  const [getCustomerImageStatus, setCustomerImageStatus] = useState(null);
  const [getCustomerPicture, setCustomerPicture] = useState({});
  const [getSellerPicture, setSellerPicture] = useState({});
  const [getSelectDocumentType, setSelectDocumentType] = useState();
  // const [getCafId, setCafId] = useState();
  const [getLeadId, setLeadId] = useState();
  const [selectDocument, setSelectDocument] = useState();

  const [industrydropdetails, setindustrydropdetails] = useState([]);
  const [selectIndustry, setSelectIndustry] = useState();

  const [isOtpVerified, setOtpVerified] = useState(null);
  const [kycDocStatus, setKycDocStatus] = useState("");
  const [selectPaymentMode, setSelectPaymentMode] = useState(optionPayment[0])
  const [isPaymentLinkSendToCustomer, setIsPaymentLinkSendToCustomer] = useState("")
  // const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [filteredPayslipOpts, setFilteredPayslipOpts] = useState(payslipOpts);
  const [selectState, setSelectState] = useState("");

  const [selectAuthCountry, setSelectAuthCountry] = useState(optionCountry[0]);
  const [selectAuthNatinality, setSelectAuthNatinality] = useState({ label: "Indian", value: "1" });
  const [selectAuthState, setSelectAuthState] = useState("");
  const [selectBillState, setSelectBillState] = useState("");
  const [selectInstState, setSelectInstState] = useState("");
  const [cityAuthOption, setCityAuthOption] = useState([]);
  const [selectAuthCity, setSelectAuthCity] = useState("");
  const [selectBillCity, setSelectBillCity] = useState("");
  const [selectInstCity, setSelectInstCity] = useState("");
  const [useSameData, setUseSameData] = useState(false);
  const [getNewCafUpdateRequestBody, setNewCafUpdateRequestBody] = useState({
    customerKYCdocument: {
      customerKYCfileNameWithExtension: "",
      customerKYCAddress: "",
      customerKYCfileContent: "",
    },
  });

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
  };

  const handleVoipPort = (selectedState) => {
    setSelectVoip(selectedState);
  };

  const handleServiceProviderChange = (selected) => {
    setServiceProvider(selected);
  }

  const handleFirewall = (selected) => {
    setOtherFirewall(selected);
  }

  const handleSelfPo = (selected) => {
    setSelectSelfpo(selected);
  }

  const handleCustomerCategoryChange = (selected) => {
    setCusCategory(selected);
  }

  const handleSelectAuthCountry = (selectCountry) => {
    setSelectAuthCountry(selectCountry);
  };

  const handleSelectAuthNatinality = (selected) => {
    setSelectAuthNatinality(selected);
  };

  const handleSelectAuthState = (selectedState) => {
    setSelectAuthState(selectedState);
    setSelectAuthCity("");
  };

  const handleSelectAuthCity = (selectedOption) => {
    setSelectAuthCity(selectedOption);
  };


  const handleCheckboxChange = () => {
    // console.log("checked")
    const newValue = !useSameData;
    setUseSameData(newValue);

    if (newValue) {
      // setSelectCountryOne(selectCountry);
      // setSelectStateOne(selectState);
      // setSelectCityOne(selectCity);
      // setSelectAreaOne(selectArea);
      // setSelectBuildingOne(selectBuilding);
      setBuildingBill((prevData) => ({
        ...prevData,
        BuildingName: getBuildingInst?.BuildingName
      }));
      setUserData((prevData) => ({
        ...prevData,
        contactName: userdata.ContactPersonName,
        billmail: userdata.Emailaddress,
        billPhone: userdata.Mobilephone,
        BillNationality: "",
        billedState: userdata.State,
        billCity: userdata.City,
        billArea: userdata.Area,
        billBuildingNo: userdata.BuildingNo,
        billBuildingId: userdata.BuildingId,
        billPin: userdata.InstPin,
        billFloor: userdata.Floor,
        BillBuildingname: userdata.Buildingname,
      }));
    } else {

      // Optionally reset the "One" states if needed when unchecked
      // setSelectCountryOne('');
      // setSelectStateOne('');
      // setSelectCityOne('');
      // setSelectAreaOne('');
      // setSelectBuildingOne('');
      setBuildingBill((prevData) => ({
        ...prevData,
        BuildingName: ""
      }));
      setUserData((prevData) => ({
        ...prevData,
        contactName: "",
        billmail: "",
        billPhone: "",
        BillNationality: "",
        billedState: "",
        billCity: "",
        billArea: "",
        billBuildingNo: "",
        billBuildingId: "",
        billPin: "",
        billFloor: "",
      }));
    }
  };


  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectAuthState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();
        // console.log(cityData);


        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          // console.log(cityData.Response.Data);

          const transformedOptions = cityData.Response.Data.map(
            (option) => ({
              label: option.CityName,
              value: option.CityCode,
            })
          );
          // console.log(transformedOptions);

          setCityAuthOption(transformedOptions);

          let selectedCity = transformedOptions.find((data) => data.value == getCafDetails?.billingAddressSAF.Bill_City)
          // console.log(cityAuthOption, { cityCode: selectedCity?.value, cityName: selectedCity?.label });

          let getAreaList = await api.getArea({ cityCode: selectedCity?.value, cityName: selectedCity?.label });
          // console.log(getAreaList);

        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );
          setCityAuthOption([]);

        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch cities only if a state is selected
    if (selectAuthState) {
      fetchCities();
    }
  }, [selectAuthState]);

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };



  const handlePaymentMode = (selectedOption) => {
    setSelectPaymentMode(selectedOption); // Update selected payment mode
    setselectedPaySlipOption("0")
    if (selectedOption?.value === "Offline") {
      // Show only Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter((option) =>
          ["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else if (selectedOption?.value === "Online") {
      // Show all options except Cheque, DD, NEFT, RTGS
      setFilteredPayslipOpts(
        payslipOpts.filter(
          (option) => !["1", "2", "4", "5"].includes(option.value)
        )
      );
    } else {
      // Reset to show all options if no valid payment mode is selected
      setFilteredPayslipOpts(payslipOpts);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(name, value);
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    // Get the current URL's query parameters
    const params = new URLSearchParams(window.location.search);
    const CafId = params.get("CafId");
    const LeadId = params.get("LeadId");
    const SafNo = searchParams.get("SafNo");

    // console.log("CafId", CafId, LeadId);
    // setCafId(CafId)
    setLeadId(LeadId)
  }, []);

  useEffect(() => {
    const fetchGetIndustry = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        if (result.Status == "Success") {
          const industryType = result.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          // console.log(industryType);
          setindustrydropdetails(industryType);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {

      }
    };

    fetchGetIndustry();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const firmTypeApiUrl = process.env.REACT_APP_API_URL;
        const firmTypeRequestBody = {
          Action: "firmTypeList",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          userName: sessionStorage.getItem("userName"),
          password: sessionStorage.getItem("password")
        }
        const firmTypeResponse = await fetch(firmTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(firmTypeRequestBody),
        });
        const firmTypeData = await firmTypeResponse.json();
        // console.log("firmTypeData.Response.Data", firmTypeData.Response.Data);

        if (firmTypeData.Response.Data) {

          const transformedOptions = firmTypeData.Response.Data.map(
            (option) => ({
              label: option.Text,
              value: option.Value,
            })
          );
          setFirmTypes(transformedOptions);
          // console.log("transformedOptions", transformedOptions.find((data) => data.value == getCafDetails?.companyDetailSAF?.FirmType))
          // console.log("FirmType", getCafDetails?.companyDetailSAF?.FirmType)
          setSelectedFirmType(transformedOptions.find((data) => data.label == getCafDetails?.companyDetailSAF?.FirmType))
        } else {
          setFirmTypes([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [getCafDetails]);





  const manageDocClick = () => {
    navigate(`/businessSAFmanageFormDOC?SafNo=${SafNo}&OppId=${OppId}`);
  };

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // Remove box shadow
      boxShadow: "none",
      backgroundColor: "transparent",
      color: "black",
    }),
  };

  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };



  const downloadPdfFromBase64 = (base64String, fileName) => {
    const binaryString = atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const redirectBroadbandCafPage = () => {
    navigate("/saf");
  };

  const SalutationOpts = [
    { value: "0", label: "Select Option", isDisabled: false },
    { value: "1", label: "Mr." },
    { value: "2", label: "Mrs." },
    { value: "3", label: "Miss." },
  ];

  const handleSAlutation = (selectedOption) => {
    // console.log("salutate", selectedOption.value);
    setSalutate(selectedOption.value);
  };






  const formInputData = (event) => {
    const { name, value } = event.target;
    setFormInput((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    setUserData((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  }


  //naveen
  const handleCustomerdetailChange = (event) => {
    const { name, value } = event.target;
    // console.log(name, " - ", value);


    if (name == 'firstName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          FirstName: "", // Update the name property
        },
      }));
      setFirstName(value);
    } else if (name == 'lastName') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          LastName: "", // Update the name property
        },
      }));
      setLastName(value);
    } else if (name == 'mobileNo') {
      setCafDigiHome((prevState) => ({
        ...prevState, // Copy the previous state
        accountDetail: {
          ...prevState.accountDetail, // Copy the existing detail object
          MobileNo: "", // Update the name property
        },
      }));
      setMobileNo(value);
    } else if (name == 'emailId') {
      setCafDigiHome((prevState) => ({
        ...prevState,
        accountDetail: {
          ...prevState.accountDetail,
          EmailId: "",
        },
      }));
      setEmailId(value);
    } else if (name == 'cafNo') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setCafNO(value);
    } else if (name == 'voice') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    } else if (name == 'livePicture') {
      // setCafDigiHome((prevState) => ({
      //   ...prevState,
      //   accountDetail: {
      //     ...prevState.accountDetail,
      //     EmailId: "",
      //   },
      // }));
      // setVoice(value);
    }
  };




  const handleIndustryChnage = (selected) => {
    setSelectIndustry(selected);
  };
  //naveen


  const compOptions = customerdropdetails?.map((company) => ({
    value: company.Company_ID,
    label: company.Company_Name,
  }));
  useEffect(() => {
    // Set the initial value when customerDetails.Company is available
    if (customerComp) {
      // console.log("customerComp", customerComp);
      const Cid = customerdropdetails.find(
        (company) => company.Company_ID === customerComp
      );
      // console.log("ID", Cid);
      if (Cid) {
        const Company_ID = Cid.Company_Name;
        // console.log("Company_ID:", Company_ID);
        setcompID(Cid.Company_ID);
        setSelectedCompany(customerComp);
        // Call fetchGetRelation after updating state with selected company
        fetchGetRelation(Cid.Company_ID);
      } else {
        // console.log("Company not found in customerdropdetails:", customerComp);
      }
      // console.log("id", customerComp);

      setSelectedCompany(customerComp);
    }
  }, [customerComp, customerdropdetails]);

  const groupOptions = customerdropdetails?.map((group) => ({
    value: group.Group_ID,
    label: group.Group_Name,
  }));

  useEffect(() => {
    // Set the initial value when customerDetails.group is available
    if (customerGroup) {
      const Gid = customerdropdetails.find(
        (group) => group.Group_ID === customerGroup
      );
      // console.log("ID", Gid);
      if (Gid) {
        const Group_ID = Gid.Group_ID;
        setgroupID(Group_ID);
        setSelectGroup(customerGroup);
      } else {
        // console.log("group not found in customerdropdetails:", customerGroup);
      }
      // console.log("id", customerGroup);

      setSelectGroup(customerGroup);
    }
  }, [customerGroup, customerdropdetails]);

  const relationOptions = reldropdetails.map((relationship) => ({
    value: relationship.Relationship_ID,
    label: relationship.Relationship_Name,
  }));
  // console.log("Selected Product Type:", selectedProductType);
  const handleProductTypeChange = (selected) => {
    setSelectedProductType(selected);
  };
  const handlePlanCategory = (selection) => {
    setSelectedPlanCatType(selection);
  };


  const handleFirmTypeChange = (selection) => {
    setSelectedFirmType(selection);
  };
  // const openCamera = () => {
  //   document.getElementById("cameraFileInput").click();
  // };

  const OpenCameraCustomer = (e) => {
    if (window.innerWidth >= 1024) {
      e.preventDefault();
      e.stopPropagation();
      Swal.fire({
        html: '<div style="font-size: 15px;">Customer live picture is not allowed on desktop.</div>',
      })
      return;
    }
    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputCustomer").click();
      }
    });
  };

  const OpenCameraSeller = () => {
    if (!isOtpVerified) { return; }

    Swal.fire({
      html: '<div style="font-size: 20px;">Select Option</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Take Photo</span>',
      cancelButtonText:
        '<span style="font-size: 15px;color:rgb(148,101,170);">Cancel</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // openCamera();
        document.getElementById("cameraFileInputSeller").click();
      }
    });
  };


  const [fileName, setFileName] = useState("");

  const handleFileChangeCustomer = async (event) => {
    // alert(userName?.toLowerCase())
    const file = event.target.files[0];

    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    setLoading(true)

    // console.log("handleFileChangeCustomer: ", file.name);
    const extension = (file?.name).substring((file?.name).lastIndexOf("."));
    let fileName = 'customer_live_picture' + extension;

    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = async (e) => {
        let base64StringBasic = e.target.result.split(";base64,")[1];
        let base64String = "";

        // ============ Validate Live Picture =============
        if (userName2?.toLowerCase() == "manager1") {
          try {
            setLoading(true)
            const validateImageReq = {
              "oppID": OppId || "",
              "cafID": CafId || "",
              "latitude": Caflatitude || "",
              "longitude": Caflongitude || "",
              "emp_code": sessionStorage.getItem("empId"),
              "image_base64": base64StringBasic
            }
            const imagevalidateResult = await api.validateImage(validateImageReq)
            const imagevalidate = imagevalidateResult?.data?.result;
            // console.log("imagevalidate: ", imagevalidate);

            if (imagevalidate?.code == 200 || imagevalidate?.code == 203) {
              setCustomerImageStatus(imagevalidate)
              if (imagevalidate?.code == 200) {
                base64String = imagevalidate?.data?.watermarked_image
              } else {
                return
              }
            } else {
              setCustomerImageStatus(null)
            }

          } catch (err) {
            console.error(err);
            setCustomerImageStatus(null)
          } finally { setLoading(false) }
        }

        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setCustomerPicture({ fileNameWithExtension: fileName, fileContent: base64String });
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          customerImage: { fileNameWithExtension: fileName, fileContent: base64String }
        }));

        // console.log({ fileNameWithExtension: fileName, fileContent: base64String });


        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    finally {
      setLoading(false)
    }
  };

  // const handleFileChangeCustomer = async (event) => {
  //   setLoading(true)
  //   const file = event.target.files[0];
  //   // console.log("handleFileChangeCustomer: ", file.name);
  //   const extension = (file.name).substring((file.name).lastIndexOf("."));
  //   let fileName = 'customer_live_picture' + extension;


  //   if (!file) {
  //     toast.warning("Please Capture Live Picture", {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 1500,
  //     });
  //     return;
  //   }
  //   // Set compression options
  //   const options = {
  //     maxSizeMB: 1, // Maximum file size in MB
  //     maxWidthOrHeight: 1920, // Max width or height
  //     useWebWorker: true, // Use web worker for faster compression
  //   };
  //   try {
  //     // Compress the image file
  //     const compressedFile = await imageCompression(file, options);
  //     // Create a FileReader instance
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const base64String = e.target.result.split(";base64,")[1];
  //       // console.log("Compressed file content:", base64String); // Log base64 content
  //       const inputText = "Picture Captured";
  //       setCustomerPicture({ fileNameWithExtension: fileName, fileContent: base64String });
  //       setNewCafUpdateRequestBody((prevData) => ({
  //         ...prevData,
  //         customerImage: { fileNameWithExtension: fileName, fileContent: base64String }
  //       }));

  //       // console.log({ fileNameWithExtension: fileName, fileContent: base64String });


  //       setFileName(inputText); // Set the input text
  //       // setBase64Content(base64String); // Set the base64 content
  //     };
  //     reader.readAsDataURL(compressedFile);
  //   } catch (error) {
  //     console.error("Error compressing the image:", error);
  //     toast.error("Error compressing the image. Please try again.", {
  //       position: toast.POSITION.BOTTOM_CENTER,
  //       autoClose: 1500,
  //     });
  //   } finally {
  //     setLoading(false)
  //   }
  // };


  const SendLinkForCustomerLivePicture = async () => {
    try {
      // console.log("btoa(OppId)",btoa("O-11-2025-151984"));
      
      let CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?OppId=" + btoa(OppId);
      // if (SafNo) {
      //   CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?OppId=" + btoa(OppId);
      // } else {
      //   CustomerLink = window.location.origin + "/crm/businessCustomerLivePhoto/?OppId=" + btoa(OppId);
      // }
      // console.log(CustomerLink);

      const req = { OppId: OppId || "", CafID: "", CustomerLink: CustomerLink }
      const sendlink = await api.sendCustomerLiveImageURL(req);
      // console.log(sendlink);
      if (sendlink.Status == "Success") {
        toast.success("Link Sent to customer!")
      } else {
        toast.warning("Faild to send link!")
      }

    } catch (err) {
      console.error(err);
    }
  }


  const handleFileChangeSeller = async (event) => {
    const file = event.target.files[0];
    // console.log("handleFileChange: ", file);
    const extension = (file.name).substring((file.name).lastIndexOf("."));
    let fileName = 'seller_live_picture' + extension;

    if (!file) {
      toast.warning("Please Capture Live Picture", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      return;
    }
    // Set compression options
    const options = {
      maxSizeMB: 1, // Maximum file size in MB
      maxWidthOrHeight: 1920, // Max width or height
      useWebWorker: true, // Use web worker for faster compression
    };
    try {
      const now = new Date();
      const extraSeconds = Math.floor(Math.random() * (100 - 50 + 1)) + 50;

      now.setSeconds(now.getSeconds() + extraSeconds);

      const formattedDateTime =
        now.getFullYear() + '-' +
        String(now.getMonth() + 1).padStart(2, '0') + '-' +
        String(now.getDate()).padStart(2, '0') + ' ' +
        String(now.getHours()).padStart(2, '0') + ':' +
        String(now.getMinutes()).padStart(2, '0') + ':' +
        String(now.getSeconds()).padStart(2, '0');

      console.log("formattedDateTime", formattedDateTime);
      // Compress the image file
      const compressedFile = await imageCompression(file, options);
      // Create a FileReader instance
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(";base64,")[1];
        // console.log("Compressed file content:", base64String); // Log base64 content
        const inputText = "Picture Captured";
        setSellerPicture({ sellerFileNameWithExtension: fileName, sellerFileContent: base64String });
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          sellerImage: {
            sellerFileNameWithExtension: fileName,
            sellerFileContent: base64String,
            sellerOTPAuthDate: formattedDateTime,
            sellerOTP: userdata.otp
          }
        }));
        // console.log({ fileName: fileName, docBase64: base64String });


        setFileName(inputText); // Set the input text
        // setBase64Content(base64String); // Set the base64 content
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.error("Error compressing the image:", error);
      toast.error("Error compressing the image. Please try again.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
  };

  const firmtypeOpts = [
    { value: "0", label: "Select Firm Type" },
    { value: "1", label: "Proprietorship" },
    { value: "2", label: "Partnership" },
    { value: "3", label: "Pvt Ltd" },
    { value: "4", label: "LLP" },
    { value: "5", label: "Trust" },
    { value: "6", label: "Individual" },
  ];

  useEffect(() => {
    // Assuming customerDetails.BusinessDays comes from your API response
    // Update the state when the API data changes
    // console.log("paymentMethod", paymentMethod);
    setselectedPaySlipOption(paymentMethod || "");
  }, [paymentMethod]);

  const handlePaySlipChange = (selected) => {
    const selectedPayin = selected;
    // console.log("selectedPayin", selected);
    setselectedPaySlipOption(selectedPayin.value);
  };



  const handleBankChange = (selected) => {
    const selectOption = selected;
    // console.log("setselectBank", selectOption);
    setselectBank(selectOption);
  };
  const bankOpts = BankDropDetails.map((bank) => ({
    value: bank.BankId, // The value of the option
    label: bank.Bankname, // The label displayed in the dropdown
  }));

  const handleBranchChange = (e) => {
    const selectOption = e.target.value;
    // console.log("setbranchName", selectOption);
    setbranchName(selectOption);
  };

  const handleChequeNo = (e) => {
    const selectOption = e.target.value;
    // console.log("setchequeDDNo", selectOption);
    setchequeDDNo(selectOption);
  };

  const handleChequeDate = (e) => {
    const selectOption = e.target.value;
    // console.log("setchequeDate", selectOption);
    setchequeDate(selectOption);
  };

  useEffect(() => {
    // Assuming paymentDetails.TotalAmount comes from your API response
    // Update the state when the API data changes
    setTotalAmt(paymentDetails.Amount || "");
  }, [paymentDetails.Amount]);
  const handleTotalAmt = (e) => {
    const selection = e.target.value;
    setTotalAmt(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.TotalAmount comes from your API response
    // Update the state when the API data changes
    setSecuritydep(paymentDetails.SecurityDeposit || "");
  }, [paymentDetails.SecurityDeposit]);
  const handleSecurityDepo = (e) => {
    const selection = e.target.value;
    setSecuritydep(selection);
  };



  const handleSecType = (selected) => {
    const selection = selected;
    setSecuritydeptype(selection.value);
  };

  const [otp, setOtp] = useState("");
  // const [customerData, setCustomerData] = useState({
  //   otp: "",
  // })

  useEffect(() => {
    // Assuming paymentDetails.TransactionReferenceId  comes from your API response
    // Update the state when the API data changes
    settransactionrefid(paymentDetails.TransactionId || "");
  }, [paymentDetails.TransactionId]);
  const handleTransactionRefID = (e) => {
    const selection = e.target.value;
    settransactionrefid(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.ApprovalCode  comes from your API response
    // Update the state when the API data changes
    setapprovalCode(paymentDetails.ApprovalCode || "");
  }, [paymentDetails.ApprovalCode]);
  const handleApprovalCode = (e) => {
    const selection = e.target.value;
    setapprovalCode(selection);
  };

  useEffect(() => {
    // Assuming paymentDetails.CreditCard4Digit  comes from your API response
    // Update the state when the API data changes
    setcreditDetails(paymentDetails.CreditCard4Digit || "");
  }, [paymentDetails.CreditCard4Digit]);
  const handleCreditdetails = (e) => {
    const selection = e.target.value;
    setcreditDetails(selection);
  };


  const handleIsGst = (selectedOption) => {
    // console.log("selectedOption", selectedOption);
    const gst = selectedOption;
    // setgst(gst);
    setIsGst(gst);
  };
  const GstOpts = [
    { value: "0", label: "Select Option" },
    { value: "569480000", label: "Yes" },
    { value: "569480001", label: "No" },
  ];



  const handlePaymentStatus = (selection) => {
    setpaymentStatus(selection);
  };

  const handleSelectFile = (selectDocument) => {

    // console.log(selectDocument);
    setSelectDocumentType(selectDocument.label);
    setSelectDocument(selectDocument)
  }



  const handleOTCChange = (e) => {
    const value = e.target.value;
    setotc(value);
  };

  const handlePAN = (e) => {
    const value = e.target.value.toUpperCase(); // Convert input to uppercase
    setPan(value);

    if (value.length === 10) {
      // Trigger validation only when input length is 10
      const regexPAN = /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/;
      const isValid1 = regexPAN.test(value);

      if (!isValid1) {
        toast.warning(
          "Please Enter PAN in CAPITAL Letters and correct format (ABCDE1234A)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("PAN entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };
  // const handleChange = (e) => {
  //   // console.log(e.target.name);
  //   // console.log(e.target.value);
  //   setCustomerData({ ...customerData, [e.target.name]: e.target.value });
  // };

  const handleGstNumber = (e) => {
    const gstNo = e.target.value.toUpperCase(); // Convert input to uppercase
    setGstNumber(gstNo);

    if (gstNo.length === 15) {
      // Trigger validation only when input length is 15
      const regexGST = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{3}$/;
      const isValid2 = regexGST.test(gstNo);

      if (!isValid2) {
        toast.warning(
          "Please Enter GST in CAPITAL Letters and correct format (12ABCDE1234A1A1 or 12ABCDE1234A1AA)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("GST entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };

  const handleTAN = (e) => {
    const value = e.target.value.toUpperCase(); // Convert input to uppercase
    setTan(value);

    if (value.length === 10) {
      // Trigger validation only when input length is 10
      const regexTAN = /^([A-Z]){4}([0-9]){5}([A-Z]){1}?$/;
      const isValid3 = regexTAN.test(value);

      if (!isValid3) {
        toast.warning(
          "Please Enter TAN in CAPITAL Letters and correct format (ABCD12345A)",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
      } else {
        toast.success("TAN entered successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    }
  };
  const fetchLatLong = async (address) => {
    try {
      // Prepare API payload
      const payload = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "getLatLong",
        address: address
      };

      // Send API request
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.Status === "Success") {
        // console.log("Latitude and Longitude fetched successfully:", result);
        setCaflatitude(result.Response.latitude);
        setCaflongitude(result.Response.longitude);
        // You can handle the successful response here
      } else {
        console.error("Failed to fetch Latitude and Longitude:", result);
        // Handle failure here
      }
    } catch (error) {
      console.error("Error fetching Latitude and Longitude:", error);
      // Handle error here
    }
  };




  const handleSendOtp = async () => {
    setCodeFlag(true)
    if (!isTimerActive) {
      // console.log("Code Sent!");
      startTimer(30); // Start a 30-second timer
    }
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const otpRequestBody = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "generateOTPforSel",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        GenerateOTP: "Yes",
      };

      const otpResponse = await fetch(apiUrl, {
        method: "POST", headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(otpRequestBody),
      });

      const sendOtpData = await otpResponse.json();
      // console.log("send otp :", sendOtpData)
      if (sendOtpData.Status === "Success") {
        // console.log("send otp :", sendOtpData.Status)
        toast.success("OTP sent successfully")
        // setOtpSent(true);
        setOtp(sendOtpData.Response.OTP);
        // console.log("sendOtpData.Response :", sendOtpData.Response);
      } else {
        console.error('Failed to send OTP:', otpResponse.statusText);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }

  };


  const startTimer = (seconds) => {
    setIsTimerActive(true);
    setTimer(seconds);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsTimerActive(false); // Enable the resend button
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };



  const handleFileChangekycDocOCR = async (event) => {
    try {
      const file = event.target.files[0];
      const file1 = event.target.files[0].name;
      // console.log("file1",file1);
      setSelectKycDoc(file1);
      if (!file) {
        toast.warning("Select KYC Document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      setLoading(true);
      // console.log("handleFileChange: ", file);
      const extension = file.name.substring(file.name.lastIndexOf("."));
      const fileType = file.type; // MIME type of the file
      let fileName = getSelectDocumentType + extension;

      // Check if the file is an image
      if (fileType.startsWith("image/")) {
        // Set compression options for images
        const options = {
          maxSizeMB: 1, // Maximum file size in MB
          maxWidthOrHeight: 1920, // Max width or height
          useWebWorker: true, // Use web worker for faster compression
        };

        const compressedFile = await imageCompression(file, options);

        // Read the compressed file as Base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(compressedFile);
      } else if (fileType === "application/pdf") {
        // Read the PDF file as Base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64String = e.target.result.split(";base64,")[1];
          await processKYCFile(fileName, base64String);
        };
        reader.readAsDataURL(file);
      } else {
        toast.warning("Unsupported file type. Please upload an image or PDF", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
    } catch (error) {
      console.error("Error processing file:", error);
      // toast.error("Error uploading document.");
    } finally {
      // setLoading(false);
      setLoading(false);
    }
  };



  const processKYCFile = async (fileName, base64String) => {
    try {
      setLoading(true);
      const payload = {
        Action: "kycDocOCR",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        type: selectDocument.value, // Adjust type based on context
        userName: sessionStorage.getItem("userName"),
        password: sessionStorage.getItem("password"),
        filename: fileName,
        filecontent: base64String,
        back: "both",
      };

      // console.log(payload);


      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      let addressValue = null;

      if (Array.isArray(result?.Response?.data)) {
        addressValue = result.Response.data.find(
          (item) => item.document_type === "aadhaar_front_top" && item.address
        )?.address?.value;
      } else {
        console.error("Error: result.Response.data is not an array", result?.Response?.data);
      }

      if (result?.Status === "Success") {
        // console.log("KYC document processed successfully:", result);
        const documentData = result.Response?.data[0];
        const possibleKeys = {
          cin: "cin",
          gstin: "gstin",
          pan: "pan_number",
          aadhar: "aadhar",
          voterId: "voterId",
          DL: "DL",
        };

        let documentValue = null;
        for (const [key, actualKey] of Object.entries(possibleKeys)) {
          if (documentData?.[actualKey]?.value) {
            documentValue = documentData[actualKey].value;
            break;
          }
        }

        // console.log("documentValue:", documentValue);



        if (["aadhaar_front_bottom", "aadhaar_front_top"].includes(documentData?.document_type)) {

          const adharName = documentData.full_name.value;
          // const adharName = "Nitin Chhabbra";
          // console.log("adharName", adharName);

          //  const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          //  const fullName = "Nitin Chhabbra";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedadharName = adharName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedadharName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(adharName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: addressValue || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        } else if (documentData?.document_type === "pan") {

          const panName = documentData.full_name.value;
          // const panName = "Seoperation Marketing Private Limited";
          // const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          // const fullName = "Seoperation Marketing Private Limited";
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedPanName = panName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedPanName) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(panName);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
        else if (result.Response.data.client_id) {
          const lienceIdNum = result.Response.data.license_number.value;
          const liecenceDOB = result.Response.data.dob.value;
          // const cName = name;
          // setKycDocStatus(result.Status);

          await handleGetCustomerDocDetailDigi(result, documentValue, liecenceDOB, lienceIdNum);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
        else {
          const customerDocDetail = await handleGetCustomerDocDetailDigi(result, documentValue);
          setNewCafUpdateRequestBody((prevData) => ({
            ...prevData,
            customerKYCdocument: {
              customerKYCAddress:
                customerDocDetail?.Response?.data?.details?.company_info?.registered_address || "",
              customerKYCfileNameWithExtension: fileName,
              customerKYCfileContent: base64String,
            },
          }));
        }
      } else {
        console.error("Failed to process KYC document:", result);
        toast.warning("Please select a valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error in KYC processing API:", error);
      toast.warning("Error processing the document", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } finally {
      setLoading(false);
    }
  };



  const handleGetCustomerDocDetailDigi = async (data, docNumber, liecenceDOB, lienceIdNum) => {
    // console.log("setDocnumber", docNumber)
    try {
      let docType = selectDocument.value;
      if (docType === 'CIN') {
        docType = "COI"
      }

      const apiUrl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCustomerDocDetailDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        type: docType,
        refid: data.Response?.reference_id,
        id_number: docNumber || lienceIdNum,
        filing_status: "true",
        dob: liecenceDOB ? liecenceDOB : null,
        client_id: ""
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result?.Status === "Success") {

        // console.log("getCustomerDocDetailDigi", result);

        // const coiCompany = result.Response?.data?.company_name;
        const liecenCompany = result?.Response?.data.license_number;
        // console.log("coiCompany", coiCompany);
        // console.log("liecenCompany", liecenCompany);


        if (liecenCompany) {
          const liecenName = result?.Response?.data.name;
          // const liecenName = "MADHUSUDHAN  R"
          // const fullName = "MADHUSUDHAn  R"
          // const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedliecenCompany = liecenName.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedliecenCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }

          handleGetCompanyGroupDigi(liecenName);
        }
        else {
          if (docType == "GST") {
            // console.log("busiName", result?.Response?.data.business_name)
            const busiName = result?.Response?.data.business_name;
            // console.log("busiName", busiName);
            // const fullName = firstName +" "+ lastName;
            const fullName = firstName;
            // const fullName = "DEV IT SERV PRIVATE LIMITED";
            // console.log("fullName", fullName);
            const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
            const normalizedbusiName = busiName.replace(/\s+/g, "").toLowerCase();
            if (normalizedFullName == normalizedbusiName) {
              setKycDocStatus(result.Status);
              toast.success("Document details validated successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            } else {
              toast.warning("Customer name on KYC document is not matching, please upload valid document", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
              });
            }

            handleGetCompanyGroupDigi(busiName);
          }
          const coiCompany = result.Response?.data?.company_name;
          // const coiCompany = "SHYAM SPECTRA PRIVATE LIMITED";
          // console.log("coiCompany", coiCompany);
          //  const fullName = firstName +" "+ lastName;
          const fullName = firstName;
          //  const fullName = "DEV IT SERV PRIVATE LIMITED"
          // console.log("fullName", fullName);
          const normalizedFullName = fullName.replace(/\s+/g, "").toLowerCase();
          const normalizedCoiCompany = coiCompany.replace(/\s+/g, "").toLowerCase();
          if (normalizedFullName == normalizedCoiCompany) {
            setKycDocStatus(result.Status);
            toast.success("Document details validated successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } else {
            toast.warning("Customer name on KYC document is not matching, please upload valid document", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 2000,
            });
          }

          const companyName = result.Response?.data?.company_name;
          handleGetCompanyGroupDigi(companyName);

        }


        // toast.success("Document details validated successfully", {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
        // console.log("result?.Response?.data.company_name", result?.Response?.data.company_name);
        // if (result.Response.data.license_number) {
        //   const companyName = result?.Response?.data.name;
        //   handleGetCompanyGroupDigi(companyName);
        // } else {
        //   if (docType == "GST") {
        //     console.log("gstDoctype", result?.Response?.data.business_name)
        //     const companyName = result?.Response?.data.business_name;
        //     handleGetCompanyGroupDigi(companyName);
        //   }
        //   else {
        //     // console.log("companyName",companyName)
        //     const companyName = result.Response?.data?.company_name;
        //     handleGetCompanyGroupDigi(companyName);

        //   }
        // }
      } else {
        console.error("Failed to retrieve customer document details:", result);
        toast.warning("please Select valid document", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving customer document details:", error);
      // toast.warning("Error retrieving document details", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });

    }
  };


  const handleGetCompanyGroupDigi = async (customerName) => {
    try {
      // Prepare API payload
      const apiurl = process.env.REACT_APP_API_URL
      const payload = {
        Action: "getCompanyGroupDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        customerName: customerName,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName')
      };

      // Send API request
      const response = await fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.Status === "Success") {
        // toast.success(result?.Response.Message, {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      } else {
        toast.warning(result?.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
    } catch (error) {
      console.error("Error retrieving company group data:", error);
      // toast.success("Error retrieving data", {
      //   position: toast.POSITION.BOTTOM_CENTER,
      //   autoClose: 1500,
      // });
    }
  };


  const handleVerifyOtp = () => {
    const otpValue = String(otp).trim();
    const customerOtpValue = userdata.otp.trim();
    // console.log("userData.otp :", userdata.otp);
    // console.log("otp :", otp);
    if (otpValue === customerOtpValue) {
      setOtpVerified(true)
      toast.success("OTP verified Successfully", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260000");
    } else {
      setOtpVerified(false)
      toast.error("Incorrect OTP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // setOtpContactStatus("111260001");
    }
  };




  const SendOtpresotp = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_2;

      const requestData = {
        Action: "resendOTP",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CAFNumber: SafNo,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();



      if (result.Response.OTPStatus === "OTP Sent") {
        toast.success("OTP Sent Succesfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        setOtpValue2(result.Response.OTPCode);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };



  // Handle city change
  const handleCityChange = async (selectedOption) => {
    try {
      console.log("Selected City:", selectedOption);
      setSelectCity(selectedOption);

      // const apiUrl = process.env.REACT_APP_API_URL_1;
      // const requestData = {
      //     Action: 'getArea',
      //     Authkey: 'ac7b51de9d888e1458dd53d8aJAN3ba6f',
      //     cafNo: 'CAF_113258',
      //     cityCode: selectedOption.value,
      //     cityName: selectedOption.label,
      //     restrictedarea: false,
      //     stateCode: "",
      //     // password: 'Target@2021#@',
      //     // userName: 'manager1',
      //     password: sessionStorage.getItem('password'),
      //     userName: sessionStorage.getItem('userName')

      // };

      // const response = await fetch(apiUrl, {
      //     method: 'POST',
      //     headers: {
      //         'Content-Type': 'application/json',
      //     },
      //     body: JSON.stringify(requestData),
      // });

      // if (!response.ok) {
      //     throw new Error(`HTTP error! Status: ${response.status}`);
      // }

      // const result = await response.json();
      // console.log('API Response area:', result.Response.Data);
      // setbillingAreaDrop(result.Response.Data)

      // const selectedOptionValue = selectedOption.value
      // const selectedOptionLabel = selectedOption.label;
      // console.log("selectedOptionValue", selectedOptionValue);
      // console.log("selectedOptionLabel", selectedOptionLabel);
      // setCityCode(selectedOptionValue)
      // setCityName(selectedOptionLabel)
      // setupdateCityCode(selectedOptionValue)
      // setbillingBuildingDrop('')
      // setbilledarea('')
      // setbilledbuilding('')

    } catch (error) {
      console.error(error);
    }
  };

  // Handle area change
  const HandleAreaChange = async (selectedOption) => {
    try {
      if (!selectCity) {
        // Dependencies not selected, show error or handle validation
        console.error("Please select state and city first");
        return;
      }
      // console.log("Selected Area:", selectedOption);
      const areaCode = selectedOption.value;
      setSelectArea(selectedOption);
      // setupdateAreaCode(selectedOption.value)
      const apiUrl = process.env.REACT_APP_API_URL_1;
      const requestData = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: areaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      // console.log("API Response society on handle:", result.Response);
      setOptionSociety(result.Response);

      if (result.Message === "Society is not mapped.") {
        toast.warning(
          result.statusText || "Society is not Mapped ,Choose Another Area",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          }
        );
        setSelectSociety("");
      } else {
        setSelectSociety("");
      }
    } catch (error) {
      console.error(error);
    }
  };




  //Main Create Button
  const handleSave = async () => {
    try {
      // Check if essential fields are empty
      // if (!userdata.ContactPersonName) {
      //   toast.error("Please Enter Customer Name", {
      //     position: toast.POSITION.BOTTOM_CENTER,
      //     autoClose: 1500,
      //   });
      //   return;
      // }
      if (!userdata.autherEmail) {
        toast.error("Please Enter Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.BuildingNo) {
        toast.error("Please Enter Installation Building/Plot No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.Floor) {
        toast.error("Please Enter Installation Floor No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.InstPin) {
        toast.error("Please Enter Installation Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.contactName) {
        toast.error("Please Enter Contact Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billmail) {
        toast.error("Please Enter Billing Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billPhone) {
        toast.error("Please Enter Billing Phone No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billBuildingNo) {
        toast.error("Please Enter Billing Building/Plot No", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billFloor) {
        toast.error("Please Enter Billing Floor No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billPin) {
        toast.error("Please Enter Billing Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.authorName) {
        toast.error("Please Enter Author Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.authorFather) {
        toast.error("Please Enter Auth Father's/Husband's  Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.authResidentialAddress) {
        toast.error("Please Enter Auth Residential Address", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.autherEmail) {
        toast.error("Please Enter Authorized Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.autherMobile) {
        toast.error("Please Enter Authorized Mobile No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.autherPinCode) {
        toast.error("Please Enter Authorized Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.techSupportEmail) {
        toast.error("Please Enter Technical Support Email.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (isGst === '569480000' && !GstNumber) {
        toast.error("Please enter Gst Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      const requiredField = {
        AuthSigDetailsSAF: {
          "Auth EmailID": userdata.autherEmail,
          "Auth Father OR Husband Name": userdata.authorFather,
          "Auth Mobile Number": userdata.autherMobile,
          "Auth Name": userdata.authorName,
          "Auth Residential Address": userdata.authResidentialAddress,
          "Auth city": selectAuthCity?.value,
          "Auth country": selectAuthCountry?.value,
          "Auth postal Code": userdata.autherPinCode,
          "Auth state": selectAuthState?.value
        },
        BillingAddressSAF: {
          "Bill Building Plot/Flat Number": userdata.billBuildingNo,
          "Bill Contact Name": userdata.contactName,
          "Bill EmailId": userdata.billmail,
          "Bill Floor": userdata.billFloor,
          "Bill area": userdata.AreaId,
          "Bill building": userdata.billBuildingId,
          "Bill city": userdata.CityId,
          "Bill mobileNo": userdata.billPhone,
          "Bill postalCode": userdata.billPin,
          "Bill state": userdata.StateId
        },
        // cafDetail: {
        // "Busines Days": businessDays?.value,
        // "Customer Category": cusCategory?.value,
        // "Customer Name": userdata.ContactPersonName,
        "Customer Working Hours": customerWorkingHours?.value,
        "Existing Provider": serviceProvider?.value,
        "FireWall": otherFirewall?.value,
        "PO Lock": yyyymmddFormat(userdata.PoLock),
        "PO Next": yyyymmddFormat(userdata.PoNext),
        // "Prefer Communication Mode": selectedCommMode?.value,
        "Sub Business Segment": selectedSubSegment?.value,
        "Phone No": userdata.Mobilephone,
        // "VOIP": selectVoip?.value,

        // },
        // companyId: compID,
        // groupId: selectGroup?.value,
        InstallationAddressesSAF: {
          "billType": billType?.value,
          // "cpeContactPersonName": userdata.leadname,
          "Lead name": userdata.leadname,
          "Contact Person Phone": userdata.Mobilephone,
          "Installation Building Plot/Flat Number": userdata.BuildingNo,
          "Installation EmailId": userdata.Emailaddress,
          "Installation Floor": userdata.Floor,
          "Installation MobileNo": userdata.Mobilephone,
          "Installation area": userdata.AreaId,
          "Installation building": userdata.BuildingId,
          "Installation city": userdata.CityId,
          "Installation postalCode": userdata.PostalCode,
          "Installation state": userdata.StateId,
          // "Product": userdata.Product,
          "Product Segment": userdata.ProductSegment
        },
        PaymentsSAF: {
          "OTC": userdata.UpfrontReqOTCAmount,
          "Amount": userdata.totalAmount,
          "RC": userdata.UpfrontReqRCAmount
        },

        // "Relationship": selectRelationship?.value,
        customerImage: getNewCafUpdateRequestBody.customerImage,
        sellerImage: getNewCafUpdateRequestBody.sellerImage,
      };

      // console.log(requiredField);

      if (!checkRequiredFields(requiredField)) { return }





      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const postData = {
        "Action": "createDigitSaf",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "AuthSigDetailsSAF": {
          "auth_emailId": userdata.autherEmail ? userdata.autherEmail : "",
          "auth_father": userdata.authorFather ? userdata.authorFather : "",
          "authLandmark": "0",
          "auth_mobileNo": userdata.autherMobile ? userdata.autherMobile : "",
          "auth_name": userdata.authorName ? userdata.authorName : "",
          "authResidentialAddress": userdata.authResidentialAddress ? userdata.authResidentialAddress : "",
          "auth_city": selectAuthCity ? selectAuthCity.value : "",
          "auth_country": selectAuthCountry ? selectAuthCountry.value : "",
          "auth_pinCode": userdata.autherPinCode ? userdata.autherPinCode : "",
          "auth_state": selectAuthState ? selectAuthState.value : "",
        },
        "CompanyDetailsSAF": {
          "company_Name": compID ? compID : selectedCompany?.label,
          "firmType": selectedFirmType?.label || "",
          "industryType": "",
        },
        "BillingAddressSAF": {
          "billBuildingPlotFlatNumber": userdata.billBuildingNo ? userdata.billBuildingNo : "",
          "billBuildingType": "",
          "bill_conatctName": userdata.contactName ? userdata.contactName : "",
          "bill_emailId": userdata.billmail ? userdata.billmail : "",
          "bill_floor": userdata.billFloor ? userdata.billFloor : "",
          "billLandmark": "0",
          "billLocality": "0",
          "billStreet": "0",
          "bill_area": userdata.AreaId ? userdata.AreaId : "",
          "bill_buildingName": userdata.billBuildingId ? userdata.billBuildingId : "",
          "bill_city": userdata.CityId ? userdata.CityId : "",
          "bill_country": "10001",
          "bill_phoneNo": userdata.billPhone ? userdata.billPhone : "",
          "bill_pinCode": userdata.billPin ? userdata.billPin : "",
          "bill_state": userdata.StateId ? userdata.StateId : ""
        },
        // "cafDetail": {
        "TechnicalSupportEmailID": userdata.techSupportEmail || "",
        "businesDays": businessDays ? businessDays.value : "",
        "businessSegment": "Business",
        "compSelfPO": "2",
        "customerCategory": cusCategory ? cusCategory.value : "",
        "contactPersonName": userdata.ContactPersonName ? userdata.ContactPersonName : "",
        "customerWorkingHours": customerWorkingHours.value ? customerWorkingHours.value : "",
        "existSircProvider": serviceProvider ? serviceProvider.value : "",
        "fireWall": otherFirewall ? otherFirewall.value : "",
        "gstNumber": null,
        "isGST": "569480001",
        "networkMonitorAlert": montiorDays ? montiorDays.value : "",
        "panNo": "",
        "phoneNo": userdata.Mobilephone ? userdata.Mobilephone : "",
        "poLock": yyyymmddFormat(userdata.PoLock) ? yyyymmddFormat(userdata.PoLock) : "",
        "poNext": yyyymmddFormat(userdata.PoNext) ? yyyymmddFormat(userdata.PoNext) : "",
        "preferCommMode": selectedCommMode ? selectedCommMode.value : "",
        "subBussinessSegment": selectedSubSegment ? selectedSubSegment.value : "",
        "tanNo": "",
        "vOIP": selectVoip ? selectVoip.value : "",
        "latitude": String(Caflatitude) || "",
        "longitude": String(Caflongitude) || "",
        // },
        "company": compID ? compID : selectedCompany?.value || "",
        "group": selectGroup ? selectGroup.value : "",
        "InstallationAddressesSAF": {
          "inst_billType": billType ? billType.value : "",
          "cpeContactPersonName": userdata.leadname ? userdata.leadname : "",
          "cpeContactPersonPhone": userdata.Mobilephone ? userdata.Mobilephone : "",
          "cpeDisSameInsta": "false",
          "cpeDispatchAddress": "",
          "instalBlock": "0",
          "instalBuildingPlotFlatNumber": userdata.BuildingNo ? userdata.BuildingNo : "",
          "instalBuildingType": "",
          "inst_emailId": userdata.Emailaddress ? userdata.Emailaddress : "",
          "inst_installationFloor": userdata.Floor ? userdata.Floor : "",
          "instalLandmark": "0",
          "instalLocality": "0",
          "inst_mobileNo": userdata.Mobilephone ? userdata.Mobilephone : "",
          "instalStreet": "0",
          "inst_area": userdata.AreaId ? userdata.AreaId : "",
          "instalbuilding": userdata.BuildingId ? userdata.BuildingId : "",
          "inst_city": userdata.CityId ? userdata.CityId : "",
          "inst_country": "10001",
          "inst_pinCode": userdata.PostalCode ? userdata.PostalCode : "",
          "inst_state": userdata.StateId ? userdata.StateId : "",
          "product": userdata.Product ? userdata.Product : "",
          "inst_buildingName": "",

          "inst_specifyBuilding": "",

          "inst_specifyArea": "",

          "inst_buildingNo": userdata.BuildingNo ? userdata.BuildingNo : "",

          "inst_installationBlock": "",

          "inst_installationFloor": "",

          "inst_pinCode": "",

          "inst_leadname": "",

          "inst_leadId": "",
          "productSegment": userdata.ProductSegment ? userdata.ProductSegment : "",
          "remarkCPE": ""
        },
        "productSegment": userdata.ProductSegment ? userdata.ProductSegment : "",
        "serviceId": "",
        "vertical": userdata.VerticalID ? userdata.VerticalID : "",
        "oppId": searchParams.get("OppId"),
        "oppurtunityID": searchParams.get("OppId"),
        "password": sessionStorage.getItem('password'),
        "PaymentsSAF": {
          "otc": userdata.UpfrontReqOTCAmount ? userdata.UpfrontReqOTCAmount : "",
          "totalAmount": userdata.totalAmount ? userdata.totalAmount : "",
          "approvalCode": "0",
          "bankName": "0",
          "branch": "0",
          "chequeDDNo": "0",
          "creditCard4Digit": "0",
          "debitCard4Digit": "0",
          "paymentSlip": "",
          "paymentDate": "",
          "paymentStatus": "",
          "securityDeposit": "",
          "securityDepositType": "",
          "transactionReferenceId": "0",
          "rc": userdata.UpfrontReqRCAmount ? userdata.UpfrontReqRCAmount : ""
        },
        "documentRequired": {
          "aadharCard": false,
          "aadharCardPhotoId": false,
          "AadharNo": "",
          "bankPassbook": false,
          "centralStateGovtId": false,
          "centralStateGovtIdPhotoId": false,
          "CompanyId": compID ? compID : selectedCompany?.value || "",
          "creditCardStatement": false,
          "documentData": null,
          "drivingLicense": false,
          "drivingLicenseNo": "",
          "drivingLicensePhotoId": false,
          "electricityBill": false,
          "electricityIssueDate": "",
          // "FirmType": selectedFirmType?.value || "",
          "gasConnection": false,
          "gasConnectionIssueDate": "",
          "GroupId": selectGroup ? selectGroup.value : "",
          "panCardPhotoId": false,
          "passport": false,
          "PassportNo": "",
          "passportPhotoId": false,
          "rationCardPhotoId": false,
          "RelationshipId": selectRelationship ? selectRelationship.value : "",
          "rentAgreement": false,
          "telephoneBill": false,
          "telephoneIssueDate": "",
          "votercard": false,
          "votercardPhotoId": false,
          "VoterNo": "",
          "waterBill": false,
          "waterBillIssueDate": ""
        },
        "relationshipId": selectRelationship ? selectRelationship.value : "",
        customerImage: getNewCafUpdateRequestBody.customerImage,
        sellerImage: getNewCafUpdateRequestBody.sellerImage,
        customerKYCdocument: getNewCafUpdateRequestBody.customerKYCdocument,
        "TechnicalSupportEmailID": userdata.techSupportEmail || "",
        "userName": sessionStorage.getItem('userName')
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      };
      // console.log("API Response:", postData);

      const response = await fetch(apiUrl, requestOptions);

      const data = await response.json();

      // console.log("API Response:", data);
      if (data.Status == "Success") {
        toast.success("SAF Created Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

        navigate("/saf");
        return;
      } else {
        toast.error(data?.Response?.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });

        // navigate("/businessCaf");
        return;
      }
    } catch (error) {
      console.error("Error sending data:", error.message);
    } finally {
      setLoading(false);
    }
  };


  const checkRequiredFields = (payload) => {
    const checkFields = (obj) => {
      for (const key in obj) {
        // console.log(key, ":", obj[key]);

        if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
          toast.error(`Please Enter ${key}`, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          return false; // Stop execution if any field is empty
        }

        if (typeof obj[key] === "object" && obj[key] !== null) {
          if (!checkFields(obj[key])) return false;
        }
      }
      return true;
    };

    return checkFields(payload);
  };

  // {MAIN UPDATE BUTTON}
  const handleUpdate = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;


      // Check if essential fields are empty
      // if (!userdata.ContactPersonName) {
      //   toast.error("Please Enter Customer Name", {
      //     position: toast.POSITION.BOTTOM_CENTER,
      //     autoClose: 1500,
      //   });
      //   return;
      // }
      if (!userdata.autherEmail) {
        toast.error("Please Enter Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.BuildingNo) {
        toast.error("Please Enter Installation Building/Plot No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.Floor) {
        toast.error("Please Enter Installation Floor No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.InstPin) {
        toast.error("Please Enter Installation Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.contactName) {
        toast.error("Please Enter Contact Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billmail) {
        toast.error("Please Enter Billing Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billPhone) {
        toast.error("Please Enter Billing Phone No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billBuildingNo) {
        toast.error("Please Enter Billing Building/Plot No", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billFloor) {
        toast.error("Please Enter Billing Floor No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.billPin) {
        toast.error("Please Enter Billing Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.authorName) {
        toast.error("Please Enter Author Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.authorFather) {
        toast.error("Please Enter Auth Father's/Husband's  Name", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.authResidentialAddress) {
        toast.error("Please Enter Auth Residential Address", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.autherEmail) {
        toast.error("Please Enter Authorized Email ID", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }
      if (!userdata.autherMobile) {
        toast.error("Please Enter Authorized Mobile No.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.autherPinCode) {
        toast.error("Please Enter Authorized Pincode.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (!userdata.techSupportEmail) {
        toast.error("Please Enter Technical Support Email.", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }

      if (isGst === '569480000' && !GstNumber) {
        toast.error("Please enter Gst Number", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        return;
      }



      const postData = {
        "Action": "updateDigitSaf",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "CompanyDetailsSAF": {
          // "company_Name": "DEV IT SERV PRIVATE LIMITED",
          // "firmType": "Pvt Ltd",
          "company_Name": compID ? compID : selectedCompany?.label,
          "firmType": selectedFirmType?.label || "",
          "industryType": "",
        },
        "AuthSigDetailsSAF": {
          "auth_emailId": userdata.autherEmail ? userdata.autherEmail : getCafDetails?.authSigDetailsSAF.Auth_EmailId,
          "auth_father": userdata.authorFather ? userdata.authorFather : getCafDetails?.authSigDetailsSAF.Auth_Father,
          "authLandmark": "0",
          "auth_mobileNo": userdata.autherMobile ? userdata.autherMobile : getCafDetails?.authSigDetailsSAF.Auth_MobileNo,
          "auth_name": userdata.authorName ? userdata.authorName : getCafDetails?.authSigDetailsSAF.Auth_Name,
          "authResidentialAddress": userdata.authResidentialAddress ? userdata.authResidentialAddress : getCafDetails?.authSigDetailsSAF.Auth_Resadd,
          "auth_city": selectAuthCity ? selectAuthCity.value : selectBillCity?.value,
          "auth_country": selectAuthCountry ? selectAuthCountry.value : "10004",
          "auth_phoneNo": "",
          "auth_pinCode": userdata.autherPinCode ? userdata.autherPinCode : getCafDetails?.authSigDetailsSAF.Auth_PinCode,
          "auth_state": selectAuthState ? selectAuthState.value : getCafDetails?.authSigDetailsSAF.Auth_State,
        },
        "BillingAddressSAF": {
          "billBuildingPlotFlatNumber": userdata.billBuildingNo ? userdata.billBuildingNo : getCafDetails?.billingAddressSAF?.Bill_BuildingNo,
          "billBuildingType": "",
          "bill_conatctName": userdata.contactName ? userdata.contactName : getCafDetails?.billingAddressSAF?.Bill_ConatctName,
          "bill_emailId": userdata.billmail ? userdata.billmail : getCafDetails?.billingAddressSAF?.Bill_EmailId,
          "bill_floor": userdata.billFloor ? userdata.billFloor : getCafDetails?.billingAddressSAF?.Bill_Floor,
          "billLandmark": "0",
          "billLocality": "0",
          "billStreet": "0",
          "bill_area": userdata.AreaId ? userdata.AreaId : getCafDetails?.billingAddressSAF?.Bill_Area,
          "bill_buildingName": userdata.billBuildingId ? userdata.billBuildingId : getCafDetails?.billingAddressSAF?.Bill_BuildingName,
          "bill_city": userdata.CityId ? userdata.CityId : getCafDetails?.billingAddressSAF?.Bill_City,
          "bill_country": "10001",
          "bill_phoneNo": userdata.billPhone ? userdata.billPhone : getCafDetails?.billingAddressSAF?.Bill_MobileNo,
          "bill_pinCode": userdata.billPin ? userdata.billPin : getCafDetails?.billingAddressSAF?.Bill_PinCode,
          "bill_specifyBuilding": "",
          "bill_specifyArea": "",
          "bill_state": userdata.StateId ? userdata.StateId : getCafDetails?.billingAddressSAF?.Bill_State
        },
        // "cafDetail": {
        "TechnicalSupportEmailID": userdata.techSupportEmail || "",
        "FirmType": selectedFirmType?.value || "",
        "safNo": SafNo,
        "businesDays": businessDays ? businessDays.value : "",
        "businessSegment": "Business",
        "compSelfPO": "2",
        "customerCategory": cusCategory ? cusCategory.value : "",
        "customerName": userdata.ContactPersonName ? userdata.ContactPersonName : "",
        "customerWorkingHours": customerWorkingHours.value ? customerWorkingHours.value : "",
        "existSircProvider": serviceProvider ? serviceProvider.value : "",
        "fireWall": otherFirewall ? otherFirewall.value : "",
        "gstNo": "null",
        "isGST": "569480001",
        "networkMonitorAlert": montiorDays ? montiorDays.value : "",
        "panNo": "",
        "phoneNo": userdata.Mobilephone ? userdata.Mobilephone : "",
        "poLock": yyyymmddFormat(userdata.PoLock) ? yyyymmddFormat(userdata.PoLock) : "",
        "poNext": yyyymmddFormat(userdata.PoNext) ? yyyymmddFormat(userdata.PoNext) : "",
        "preferCommMode": selectedCommMode ? selectedCommMode.value : "",
        "subBusinessSegment": selectedSubSegment ? selectedSubSegment.value : "",
        "tanNo": "",
        "vOIP": selectVoip ? selectVoip.value : "",
        "latitude": String(Caflatitude) || "",
        "longitude": String(Caflongitude) || "",
        // },
        "company": compID ? compID : selectedCompany?.value || "",
        "group": selectGroup ? selectGroup.value : "",
        "InstallationAddressesSAF": {
          "inst_billType": billType ? billType.value : "",
          "cpeContactPersonName": userdata.leadname ? userdata.leadname : "",
          "cpeContactPersonPhone": userdata.Mobilephone ? userdata.Mobilephone : "",
          "cpeDisSameInsta": "false",
          "cpeDispatchAddress": "",
          "instalBlock": "",
          "instalBuildingPlotFlatNumber": userdata.BuildingNo ? userdata.BuildingNo : "",
          "instalBuildingType": "",
          "inst_emailId": userdata.Emailaddress ? userdata.Emailaddress : getCafDetails?.installationAddressesSAF?.Inst_EmailId,
          "inst_installationFloor": userdata.Floor ? userdata.Floor : "",
          "instalLandmark": "",
          "instalLocality": "",
          "inst_mobileNo": userdata.Mobilephone ? userdata.Mobilephone : getCafDetails?.installationAddressesSAF?.Inst_MobileNo,
          "instalStreet": "",
          "inst_area": userdata.AreaId ? userdata.AreaId : "",
          "instalbuilding": userdata.BuildingId ? userdata.BuildingId : "",
          "inst_city": userdata.CityId ? userdata.CityId : "",
          "inst_country": "10001",
          "inst_pinCode": userdata.InstPin ? userdata.InstPin : "",
          "inst_state": userdata.StateId ? userdata.StateId : "",
          "product": userdata.Product ? userdata.Product : "",
          "productSegment": userdata.ProductSegment ? userdata.ProductSegment : "",
          "remarkCPE": "",
          "inst_buildingName": "",

          "inst_specifyBuilding": "",

          "inst_specifyArea": "",

          "inst_buildingNo": userdata.BuildingNo ? userdata.BuildingNo : "",

          "inst_installationBlock": "",

          "inst_installationFloor": "",

          "inst_pinCode": "",

          "inst_leadname": "",

          "inst_leadId": ""
        },
        "oppurtunityID": OppId ? OppId : "",
        "password": sessionStorage.getItem('password'),
        "PaymentsSAF": {
          "paymentId": getCafDetails?.paymentsSAF?.PaymentId,

          "otc": userdata.UpfrontReqOTCAmount ? userdata.UpfrontReqOTCAmount : getCafDetails?.paymentsSAF?.UpfrontRequestedOTCAmountIncTax,
          "totalAmount": userdata.TotalAmount ? userdata.TotalAmount : "",
          "modeOfPayment": selectPaymentMode?.value ? selectPaymentMode?.value : "", //selectedPaySlipOption || getCafDetails?.payments.PayInSlip || "Online",
          "approvalCode": "0",
          // "bankName": selectBank?.value || getCafDetails?.payments?.BankName || "",
          "bankName": selectBank?.value || (bankOpts.find((option) => option?.label == getCafDetails?.paymentsSAF?.BankName))?.value,
          "branch": branchName || getCafDetails?.paymentsSAF?.Branch || "",
          "chequeDDNo": chequeDDNo || getCafDetails?.paymentsSAF?.ChequeDDNo || "",
          "chequeDDDate": chequeDate || yyyymmddFormat(getCafDetails?.paymentsSAF?.ChequeDDDate) || "",
          "creditCardDigits": "0",
          "debitCardDigits": "0",
          "payInSlip": selectedPaySlipOption ? selectedPaySlipOption : "",
          "paymentDate": userdata.paymentDate ? userdata.paymentDate : "",
          "paymentStatus": "1",
          "securityDeposit": "0",
          "securityDepositType": "0",
          "transactionReferenceId": transactionrefid ? transactionrefid : "",
          "rc": userdata.UpfrontReqRCAmount ? userdata.UpfrontReqRCAmount : getCafDetails.paymentsSAF?.UpfrontRequestedRCAmountIncTax,
        },
        "documentRequired": {
          "aadharCard": false,
          "aadharCardPhotoId": false,
          "AadharNo": "",
          "bankPassbook": false,
          "centralStateGovtId": false,
          "centralStateGovtIdPhotoId": false,
          "CompanyId": compID ? compID : selectedCompany?.value || "",
          "creditCardStatement": false,
          "documentData": null,
          "drivingLicense": false,
          "drivingLicenseNo": "",
          "drivingLicensePhotoId": false,
          "electricityBill": false,
          "electricityIssueDate": "",
          "FirmType": selectedFirmType?.value || "",
          "gasConnection": false,
          "gasConnectionIssueDate": "",
          "GroupId": selectGroup ? selectGroup.value : "",
          "panCardPhotoId": false,
          "passport": false,
          "PassportNo": "",
          "passportPhotoId": false,
          "rationCardPhotoId": false,
          "RelationshipId": selectRelationship ? selectRelationship.value : "",
          "rentAgreement": false,
          "telephoneBill": false,
          "telephoneIssueDate": "",
          "votercard": false,
          "votercardPhotoId": false,
          "VoterNo": "",
          "waterBill": false,
          "waterBillIssueDate": ""
        },
        "relationshipId": selectRelationship ? selectRelationship.value : "",
        customerImage: getNewCafUpdateRequestBody.customerImage,
        sellerImage: getNewCafUpdateRequestBody.sellerImage,
        customerKYCdocument: getNewCafUpdateRequestBody.customerKYCdocument,

        "userName": sessionStorage.getItem('userName')
      }

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(postData),
      };

      const response = await fetch(apiUrl, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      // console.log("API Response of Update:", data);
      if (data.Status === "Success") {
        // console.log("sucnc");
        toast.success("SAF Updated Successfully", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
        navigate('/saf')
        setTimeout(() => {
          // window.location.reload()
        }, 2000);


      } else {
        toast.error(data.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }
      // Handle the API response here
    } catch (error) {
      console.error("Error sending data:", error);
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    const fetchPaymentAlert = async () => {
      // console.log("getCafNo", CafId);
      try {
        const apiUrl = process.env.REACT_APP_API_URL_3;
        const requestData = {
          "Action": "getPaymentAlertDigi",
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "userName": sessionStorage.getItem('userName'),
          "password": sessionStorage.getItem('password'),
          "CafSafNo": SafNo ? SafNo : ""
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const data = await response.json();
        // console.log("response", data.Response);
        // const datafetch = {
        //     "CafSafNo": "CAF_77820",
        //     "PaymentDOAFlag": "Yes",
        //     "StatusCode": 200,
        //     "Message": "Submit for approval as discount waiver added in the payment record."
        // }
        if (data.Response.PaymentDOAFlag == "Yes") {
          Swal.fire({
            // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
            html: `<div style="font-size: 15px;">Submit for Appoval as Upfront Discount added</div>`,
            showCancelButton: true,
            confirmButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">Yes</span>',
            cancelButtonText:
              '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
              popup: "custom-popup",
              confirmButton: "custom-confirm-button",
              cancelButton: "custom-cancel-button",
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              const { value: formValues } = await Swal.fire({
                title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Upfront Discount</div>`,
                // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                html: `
                                    <input id="swal-input1" class="swal2-input">  `,
                focusConfirm: false,
                preConfirm: () => {
                  // return [document.getElementById("swal-input1").value];
                  const reason = document.getElementById("swal-input1").value.trim();
                  if (!reason) {
                    Swal.showValidationMessage("Reason is required.");
                    return;
                  }
                  return reason;
                }
              });
              if (formValues) {
                // Swal.fire(JSON.stringify(formValues));
                // console.log("formValues", formValues);
                try {
                  const apiUrl = process.env.REACT_APP_API_URL_3;
                  const requestData = {
                    "Action": "DOAForPaymentDigi",
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),
                    "CafSafNo": SafNo,
                    "IsDOARequired": "Yes",
                    "ReasonForPaymentDOA": formValues
                  }
                  const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                  });
                  const data = await response.json();
                  if (data.Status == "Success") {
                    try {
                      const apiUrl = process.env.REACT_APP_API_URL_3;
                      const requestData = {
                        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        "Action": "getDedupeAlert",
                        "userName": sessionStorage.getItem('userName'),
                        "password": sessionStorage.getItem('password'),
                        "CafSafNo": SafNo
                      }
                      const response = await fetch(apiUrl, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                        },
                        body: JSON.stringify(requestData),
                      });
                      const data = await response.json();
                      if (data.Response.DedupeDOAFlag == "Yes") {
                        Swal.fire({
                          // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
                          html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                          showCancelButton: true,
                          confirmButtonText:
                            '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
                          cancelButtonText:
                            '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
                          confirmButtonColor: "white",
                          cancelButtonColor: "white",
                          customClass: {
                            popup: "custom-popup",
                            confirmButton: "custom-confirm-button",
                            cancelButton: "custom-cancel-button",
                          },
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            try {
                              const apiUrl = process.env.REACT_APP_API_URL_3;
                              const requestData = {
                                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                Action: "DOAForDedupeAlert",
                                userName: sessionStorage.getItem('userName'),
                                password: sessionStorage.getItem('password'),
                                CafSafNo: SafNo,
                                IsDOARequired: "Yes",
                              };

                              const response = await fetch(apiUrl, {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                                body: JSON.stringify(requestData),
                              });

                              if (!response.ok) {
                                throw new Error(`HTTP error! status: ${response.status}`);
                              }

                              const data = await response.json();
                              // console.log("API Response:", data);

                            } catch (error) {
                              console.error("Error during API call:", error.message);
                            }
                          }
                          else if ((result.dismiss === Swal.DismissReason.cancel)) {
                            Swal.fire({
                              html: '<div style="font-size: 15px;">Are you sure?</div>',
                              // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
                              showCancelButton: true,
                              confirmButtonText:
                                '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
                              cancelButtonText:
                                '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
                              confirmButtonColor: "white",
                              cancelButtonColor: "white",
                              customClass: {
                                popup: "custom-popup",
                                confirmButton: "custom-confirm-button",
                                cancelButton: "custom-cancel-button",
                              },
                            }).then(async (result) => {
                              if (result.isConfirmed) {
                                try {
                                  const apiUrl = process.env.REACT_APP_API_URL_3;
                                  const requestData = {
                                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                                    Action: "DOAForDedupeAlert",
                                    userName: sessionStorage.getItem('userName'),
                                    password: sessionStorage.getItem('password'),
                                    CafSafNo: SafNo,
                                    IsDOARequired: "No",
                                  };

                                  const response = await fetch(apiUrl, {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                    },
                                    body: JSON.stringify(requestData),
                                  });

                                  if (!response.ok) {
                                    throw new Error(`HTTP error! status: ${response.status}`);
                                  }
                                  const data = await response.json();
                                  // console.log("API Response:", data);

                                  if (data.Response.StatusCode == "200") {
                                    navigate("/saf");
                                  }
                                } catch (error) {
                                  console.error("Error during API call:", error.message);
                                }
                              }
                            });
                            // try {
                            //   const apiUrl = process.env.REACT_APP_API_URL_3;
                            //   const requestData = {
                            //     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            //     Action: "DOAForDedupeAlert",
                            //     userName: sessionStorage.getItem('userName'),
                            //     password: sessionStorage.getItem('password'),
                            //     CafSafNo: CafId,
                            //     IsDOARequired: "No",
                            //   };

                            //   const response = await fetch(apiUrl, {
                            //     method: "POST",
                            //     headers: {
                            //       "Content-Type": "application/json",
                            //     },
                            //     body: JSON.stringify(requestData),
                            //   });

                            //   if (!response.ok) {
                            //     throw new Error(`HTTP error! status: ${response.status}`);
                            //   }
                            //   const data = await response.json();
                            //   console.log("API Response:", data);

                            //   if (data.Response.StatusCode == "200") {
                            //     navigate("/broadbandCAF");
                            //   }
                            // } catch (error) {
                            //   console.error("Error during API call:", error.message);
                            // }
                          }
                        })
                      }
                    } catch (error) {
                      console.error("Error fetching data:", error.message);
                    }
                  }
                } catch (error) {
                  console.error("Error fetching data:", error.message);
                }
              }
            } else if ((result.dismiss === Swal.DismissReason.cancel)) {
              try {
                const apiUrl = process.env.REACT_APP_API_URL_3;
                const requestData = {
                  "Action": "DOAForPaymentDigi",
                  "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                  "userName": sessionStorage.getItem('userName'),
                  "password": sessionStorage.getItem('password'),
                  "CafSafNo": SafNo,
                  "IsDOARequired": "No",
                  "ReasonForPaymentDOA": ""
                }
                const response = await fetch(apiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                });
                const data = await response.json();
                if (data.Status == "Success") {
                  navigate("/saf");
                }
              } catch (error) {
                console.error("Error fetching data:", error.message);
              }
            }
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    fetchPaymentAlert();
  }, []);


  useEffect(() => {
    const fetchGetWorkOrder = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getAllWorkOrder",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppId: OppId ? OppId : searchParams.get("OppId"),
          password: sessionStorage.getItem("password"),
          safNo: SafNo,
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();
        if (result.Response.Message == `${SafNo} have no work orders.`) {
          toast.warning(`${result.Response.Message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
            className: "",
          });
          setWorkOrderHide(true);
        } else {
          // console.log("API Response Work Order:", result);
          setWorkOrderDetails(result.Response.Data);
          // console.log("WorkOrder", result.Response);
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetWorkOrder();
  }, []);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         "Action": "getDedupeAlert",
  //         "userName": sessionStorage.getItem('userName'),
  //         "password": sessionStorage.getItem('password'),
  //         "CafSafNo": CafId ? CafId : ""
  //       }
  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           // "token": "e7e916c2e449f6306b27dea2fb2dde46",
  //         },
  //         body: JSON.stringify(requestData),
  //       });
  //       const data = await response.json();
  //       if (data.Response.DedupeDOAFlag == "Yes") {
  //         Swal.fire({
  //           // html: '<div style="font-size: 15px;">De-dupe case , Do you want to procced ?</div>',
  //           html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //           showCancelButton: true,
  //           confirmButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">Procced</span>',
  //           cancelButtonText:
  //             '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
  //           confirmButtonColor: "white",
  //           cancelButtonColor: "white",
  //           customClass: {
  //             popup: "custom-popup",
  //             confirmButton: "custom-confirm-button",
  //             cancelButton: "custom-cancel-button",
  //           },
  //         }).then(async (result) => {
  //           if (result.isConfirmed) {
  //             try {
  //               const apiUrl = process.env.REACT_APP_API_URL;
  //               const requestData = {
  //                 Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                 Action: "DOAForDedupeAlert",
  //                 userName: sessionStorage.getItem('userName'),
  //                 password: sessionStorage.getItem('password'),
  //                 CafSafNo: CafId ? CafId : "",
  //                 IsDOARequired: "Yes",
  //               };

  //               const response = await fetch(apiUrl, {
  //                 method: "POST",
  //                 headers: {
  //                   "Content-Type": "application/json",
  //                 },
  //                 body: JSON.stringify(requestData),
  //               });

  //               if (!response.ok) {
  //                 throw new Error(`HTTP error! status: ${response.status}`);
  //               }

  //               const data = await response.json();
  //               console.log("API Response:", data);

  //             } catch (error) {
  //               console.error("Error during API call:", error.message);
  //             }
  //           }
  //           else if ((result.dismiss === Swal.DismissReason.cancel)) {
  //             Swal.fire({
  //               html: '<div style="font-size: 15px;">Are You Sure?</div>',
  //               // html: `<div style="font-size: 15px;">${data.Response.Message}</div>`,
  //               showCancelButton: true,
  //               confirmButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">yes</span>',
  //               cancelButtonText:
  //                 '<span style="font-size: 12px;color:rgb(148,101,170);">No</span>',
  //               confirmButtonColor: "white",
  //               cancelButtonColor: "white",
  //               customClass: {
  //                 popup: "custom-popup",
  //                 confirmButton: "custom-confirm-button",
  //                 cancelButton: "custom-cancel-button",
  //               },
  //             }).then(async (result) => {
  //               if (result.isConfirmed) {
  //                 try {
  //                   const apiUrl = process.env.REACT_APP_API_URL_3;
  //                   const requestData = {
  //                     Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //                     Action: "DOAForDedupeAlert",
  //                     userName: sessionStorage.getItem('userName'),
  //                     password: sessionStorage.getItem('password'),
  //                     CafSafNo: CafId ? CafId : "",
  //                     IsDOARequired: "No",
  //                   };

  //                   const response = await fetch(apiUrl, {
  //                     method: "POST",
  //                     headers: {
  //                       "Content-Type": "application/json",
  //                     },
  //                     body: JSON.stringify(requestData),
  //                   });

  //                   if (!response.ok) {
  //                     throw new Error(`HTTP error! status: ${response.status}`);
  //                   }
  //                   const data = await response.json();
  //                   console.log("API Response:", data);

  //                   if (data.Response.StatusCode == "200") {
  //                     navigate("/broadbandCAF");
  //                   }
  //                 } catch (error) {
  //                   console.error("Error during API call:", error.message);
  //                 }
  //               }
  //             });

  //           }
  //         })
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     }
  //   };
  //   fetchData();
  // }, []);


  // ****************API'S****************//




  // {/* ***********for getCaf data API ********* */ }
  // useEffect(() => {
  //   const fetchBussinessCAF = async () => {
  //     // console.log("CafId", CafId);
  //     try {
  //       const apiUrl = process.env.REACT_APP_API_URL;

  //       const requestData = {
  //         Action: "getCafDigiHome",
  //         Authkey: "AdgT6SnjAkeLqlkE4",
  //         CAFId: CafId,
  //         password: sessionStorage.getItem('password'),
  //         userName: sessionStorage.getItem('userName'),
  //       };

  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! Status: ${response.status}`);
  //       }
  //       setLoading(false);
  //       const result = await response.json();
  //       console.log("API Response broadcaf:", result.Response);
  //       sessionStorage.setItem("firmType", result.Response.documentRequired.FirmType);
  //       // sessionStorage.setItem("userName", user);
  //       // console.log("result.Response.documentRequired.FirmType", result.Response.documentRequired.FirmType)
  //       if (result.Status === "Success") {
  //         setSalutate(result.Response.accountDetail.SalutationId);
  //         setFirstName(result.Response.accountDetail.FirstName);
  //         setLastName(result.Response.accountDetail.LastName);
  //         setIsPaymentLinkSendToCustomer(result.Response.paymentDetail.IsPaymentLinkSendToCustomer);
  //         setSelectPaymentMode({
  //           value: result.Response.paymentDetail.ModeOfPayment,
  //           label: result.Response.paymentDetail.ModeOfPayment,
  //         });
  //         const filterpaymentStatus = PaymentOpts.find((item) => item.value === String(result.Response.paymentDetail.PaymentStatus)).label;
  //         setpaymentStatus({
  //           label: filterpaymentStatus,
  //           value: result.Response.paymentDetail.PaymentStatus,
  //         })
  //         // const filterPaySlip = payslipOpts.find((item) => item.value === String(result.Response.paymentDetail.PayInSlip)).label;
  //         // setselectedPaySlipOption({
  //         //   label: filterPaySlip,
  //         //   value: result.Response.paymentDetail.PayInSlip,
  //         // })
  //         const filterfirmType = firmtypeOpts.find((item) => item.value === String(result.Response.documentRequired.FirmType)).label;
  //         setSelectedFirmType({
  //           value: result.Response.documentRequired.FirmType,
  //           label: filterfirmType
  //         });

  //         setPaymentButton(result.Response.paymentDetail.IsPaymentLinkSendToCustomer);
  //         setPaymentLinkSentToCustomer(result.Response.paymentDetail.IsPaymentLinkSendToCustomer)
  //         setCafDigiHome(result.Response);
  //         setVoice(result.Response.cafDetail.Voice);
  //         //  alert('hlo1')
  //         // const filterProduct = productdropdetails.find((item) => item.value === String(result.Response.cafDetail.Product)).label;
  //         setSelectedProductType({
  //           value: result.Response.cafDetail.Product,
  //           label: result.Response.cafDetail.Product,
  //         })
  //         setSelectIndustry({
  //           value: result.Response.cafDetail.IndustryId,
  //           label: result.Response.cafDetail.IndustryId,
  //         })

  //         setUserData({
  //           OTCAmount: result.Response.paymentDetail.OTCAmount || "",
  //           SDAmount: result.Response.paymentDetail.SDAmount || "",
  //           RCAmount: result.Response.paymentDetail.RCAmount || "",
  //           IsPaymentLinkSendToCustomer: result.Response.paymentDetail.IsPaymentLinkSendToCustomer || "",
  //           UpfrontApprovedSDAmount: result.Response.paymentDetail.UpfrontApprovedSDAmount || "",
  //           UpfrontApprovedOTCAmount: result.Response.paymentDetail.UpfrontApprovedOTCAmount || "",
  //           UpfrontApprovedRCAmount: result.Response.paymentDetail.UpfrontApprovedRCAmount || "",
  //           UpfrontReqSDAmount: result.Response.paymentDetail.UpfrontRequestedSDAmount || "",
  //           UpfrontReqOTCAmount: result.Response.paymentDetail.UpfrontRequestedOTCAmountIncTax || "",
  //           UpfrontReqRCAmount: result.Response.paymentDetail.UpfrontRequestedRCAmountIncTax || "",
  //           ApprovedSDAmount: result.Response.paymentDetail.ApprovedSDAmount || "",
  //           ApprovedOTCAmount: result.Response.paymentDetail.ApprovedOTCAmountIncTax || "",
  //           ApprovedRCAmount: result.Response.paymentDetail.ApprovedRCAmountIncTax || "",
  //         })
  //         // setSelectIndustry({
  //         //   value: result.Response.cafDetail.IndustryId,
  //         //   label: result.Response.cafDetail.Industry,
  //         // })
  //         if ( !result.Response.cafDetail.CafNo || result.Response.cafDetail.CafNo === ""
  //         ) {
  //           setCustomerDetails(result.Response.cafDetail);
  //           setcustomerGroup(result.Response.cafDetail.GroupId);
  //           // console.log("firest:", result.Response.cafDetail.CompanyId);
  //           setcustomerComp(result.Response.cafDetail.CompanyId);

  //           setMobileNo(result.Response.accountDetail.MobileNo);
  //           // setCafNO(result.Response.CAFId);
  //           setSelectRelationship(result.Response.cafDetail.RelationshipId);
  //           setApiStateCode(result.Response.cafDetail.State);
  //           setApiCityCode(result.Response.cafDetail.City);
  //           setApiAreaCode(result.Response.cafDetail.Area);
  //           setApiSocietyCode(result.Response.cafDetail.Society);
  //           // fetchGetProduct(result.Response.cafDetail.Society);
  //           setApiFloorCode(result.Response.cafDetail.HousePlotFlatNumber);
  //           setApiPinCode(result.Response.cafDetail.PostalCode);
  //           setApiblockCode(result.Response.accountDetail.BlockTower);
  //           setApiProd(result.Response.cafDetail.Product);
  //           const OtpAuthStaus = result.Response.OTPAuthStatsu;
  //           const boolean = OtpAuthStaus.toString();
  //           setotpAuthStatus(boolean);
  //           setCheckboxes(result.Response.documentRequired);
  //           setotc(result.Response.paymentDetail.OTC);
  //           setTan(result.Response.cafDetail.TANNo);
  //           setPan(result.Response.cafDetail.PANNo);
  //           setIsGst(result.Response.cafDetail.IsGST);
  //           setGstNumber(result.Response.cafDetail.GSTNo);
  //           setPaymentDetails(result.Response.paymentDetail);
  //           setPaymentMethod(result.Response.paymentDetail.PayInSlip);
  //           // console.log("paty", result.Response.paymentDetail.PayInSlip);
  //           // console.log("wqeqw", result.Response);
  //         } else if (
  //           result.Response.Status === "Document Verification Pending" ||
  //           result.Response.Status === "Installation Completed" ||
  //           result.Response.Status === "Payment Verification Rejected" ||
  //           result.Response.Status === "Installation Pending" ||
  //           result.Response.Status === "Payment Verification Pending" ||
  //           result.Response.Status === "Installation Not Done" ||
  //           result.Response.Status === "Document Verification Rejected" ||
  //           result.Response.Status === ""
  //         ) {
  //           setBTNSubmit(true);
  //           setBTNCreate(false);
  //           if (
  //             result.Response.Status === "Installation Completed" ||
  //             result.Response.Status === "Installation Pending"
  //           ) {
  //             setdocHide(true);
  //           }
  //           setStatusNoCaf(false);
  //           setStatusCaf(true);
  //           setDisableFields(false);

  //           setCustomerDetails(result.Response.cafDetail);
  //           setcustomerGroup(result.Response.cafDetail.GroupId);
  //           // console.log("firest:", result.Response.cafDetail.CompanyId);
  //           setcustomerComp(result.Response.cafDetail.CompanyId);
  //           // console.log('firest:', result.Response.accountDetail.FirstName);


  //           // setFirstName(result.Response.accountDetail.FirstName);
  //           setLastName(result.Response.accountDetail.LastName);
  //           setMobileNo(result.Response.accountDetail.MobileNo);
  //           setEmailId(result.Response.accountDetail.EmailId);
  //           setCafNO(result.Response.CAFId);
  //           // console.log(
  //           //   "result.Response.documentRequired.FirmType",
  //           //   result.Response.documentRequired.FirmType
  //           // );
  //           setSelectRelationship(result.Response.cafDetail.RelationshipId);
  //           // console.log(
  //           //   "result.Response.cafDetail.State",
  //           //   result.Response.cafDetail.State
  //           // );
  //           setApiStateCode(result.Response.cafDetail.State);
  //           setApiCityCode(result.Response.cafDetail.City);
  //           setApiAreaCode(result.Response.cafDetail.Area);
  //           setApiSocietyCode(result.Response.cafDetail.Society);
  //           // fetchGetProduct(result.Response.cafDetail.Society);
  //           setApiFloorCode(result.Response.cafDetail.HousePlotFlatNumber);
  //           setApiPinCode(result.Response.cafDetail.PostalCode);
  //           setApiblockCode(result.Response.accountDetail.BlockTower);
  //           const concatenatedValue =
  //             `${result.Response.cafDetail.State}, ` +
  //             `${result.Response.cafDetail.City}, ` +
  //             `${result.Response.cafDetail.Area}, ` +
  //             `${result.Response.cafDetail.Society}, ` +
  //             `${result.Response.cafDetail.HousePlotFlatNumber}, ` +
  //             `${result.Response.cafDetail.PostalCode}, ` +
  //             `${result.Response.accountDetail.BlockTower}`;

  //           setApiProd(result.Response.cafDetail.Product);
  //           const OtpAuthStaus = result.Response.OTPAuthStatsu;
  //           const boolean = OtpAuthStaus.toString();
  //           setotpAuthStatus(boolean);
  //           setCheckboxes(result.Response.documentRequired);
  //           setotc(result.Response.paymentDetail.OTC);
  //           setTan(result.Response.cafDetail.TANNo);
  //           setPan(result.Response.cafDetail.PANNo);
  //           setIsGst(result.Response.cafDetail.IsGST);
  //           setGstNumber(result.Response.cafDetail.GSTNo);

  //           setPaymentDetails(result.Response.paymentDetail);
  //           setPaymentMethod(result.Response.paymentDetail.PayInSlip);
  //           // console.log("paty", result.Response.paymentDetail.PayInSlip);
  //           // console.log("wqeqw", result.Response);
  //         }
  //       } else {
  //         setBTNSubmit(true);
  //         setBTNCreate(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error.message);
  //     } finally {
  //       setLoading(false)
  //     }
  //   };
  //   if (!leadId) {
  //     fetchBussinessCAF();
  //   }
  // }, []);


  useEffect(() => {
    const fetchBroadBandLead = async () => {
      // console.log("leadId", leadId);
      try {
        // const apiUrl = process.env.REACT_APP_API_URL_1;
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getLeads",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: leadId,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setLoading(false);
        const result = await response.json();
        // console.log("API Response LeadCaf:", result);

        // alert('hlo2')
        // console.log("Lead res", result);

        // setCustomerDetails(result.Response);
        setcustomerGroup(result.Response[0].GroupId);
        // console.log("firest:", result.Response[0].CompanyId);
        setcustomerComp(result.Response[0].CompanyId);
        // console.log('firest:', result.Response.accountDetail.FirstName);
        setIsGst('0');
        setSalutate(result.Response[0].SalutationId);
        setFirstName(result.Response[0].Companyname);
        // console.log("result.Response.FirstName", result.Response[0].FirstName);
        // setLastName(result.Response[0].Companyname);
        setMobileNo(result.Response[0].MobileNo);
        setEmailId(result.Response[0].EmailId);
        setCafNO(result.Response[0].CAFId);
        const filterfirmType = firmtypeOpts.find((item) => item.value === String(result.Response[0].companyDetailSAF.FirmType)).label;
        // setSelectedFirmType({
        //   label: filterfirmType,
        //   value: result.Response[0].companyDetail.FirmType,
        // });
        setSelectRelationship(result.Response[0].RelationshipId);
        // console.log(
        //   "result.Response[0].cafDetail.State",
        //   result.Response[0].installationAddress.InstallState
        // );
        setApiStateCode(result.Response[0].installationAddress.InstallState);
        setApiCityCode(result.Response[0].installationAddress.InstallCity);
        // console.log(
        //   "result.Response[0].installationAddress.InstallArea",
        //   result.Response[0].installationAddress.InstallArea
        // );
        setApiAreaCode(result.Response[0].installationAddress.InstallArea);
        // console.log(
        //   "result.Response[0].installationAddress.InstallSociety",
        //   result.Response[0].installationAddress.InstallSociety
        // );
        setApiSocietyCode(
          result.Response[0].installationAddress.InstallSociety
        );
        // fetchGetProduct(result.Response[0].installationAddress.InstallSociety);
        setApiFloorCode(result.Response[0].installationAddress.InstallFloor);
        setApiPinCode(result.Response[0].installationAddress.InstallPincode);
        setApiblockCode(result.Response[0].installationAddress.InstallPlotNo);
        // console.log("PRODNFDJD", result.Response[0].ProductName)
        // setApiProd(result.Response[0].ProductName)
        const OtpAuthStaus = result.Response[0].OTPAuthStatsu;
        const boolean = OtpAuthStaus.toString();
        setotpAuthStatus(boolean);
        // setCheckboxes(result.Response[0].documentRequired);
        // setpaymentStatus(result.Response[0].paymentDetail.PaymentStatus);
        setotc(result.Response[0].paymentDetail.OTC);
        setTan(result.Response[0].cafDetail.TANNo);
        setPan(result.Response[0].cafDetail.PANNo);

        setPaymentDetails(result.Response[0].paymentDetail);
        setPaymentMethod(result.Response[0].paymentDetail.PaymentSlip);
        // console.log("paty", result.Response[0].paymentDetail.PayInSlip);
        // console.log("wqeqw", result.Response[0]);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    };
    if (!SafNo) {
      fetchBroadBandLead();
    }
  }, []);



  const fetchCompanyData = async () => {
    try {
      setLoader(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      // console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((company) => ({
          label: `${company.Company_Name} (${company.Company_ID})`,
          value: company.Company_ID,
          group: `${company.Group_Name} (${company.Group_ID})`,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoader(false);
    }
    return [];
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        if (SafNo) return;
        setLoading(true);
        // console.log(searchParams.get("LeadId"));
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getopportunity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          LeadId: "",
          OppId: OppId ? OppId : searchParams.get("OppId"),
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const responsedata = await response.json();
        // console.log("responsedata: ", responsedata);
        const responseData = responsedata?.Response?.Data?.[0];
        // console.log("getLeads", responseData);
        // console.log("getLeads1" ,responsedata1);
        if (responsedata?.Status === "Success" && responseData) {

          ////////////////
          const options = await fetchCompanyData("");
          // console.log(options);
          let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
          // console.log(defaultCompanyGroupObj);
          let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
          // console.log(defaultRelationship);

          setSelectedCompany({
            value: defaultCompanyGroupObj?.value,
            label: defaultCompanyGroupObj?.label,
          });

          setSelectGroup({
            value: defaultCompanyGroupObj?.groupId,
            label: defaultCompanyGroupObj?.group,
          });

          // console.log(defaultRelationship);

          if (defaultRelationship.Response?.Data) {
            let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
            // console.log(defaultRelationshipObj);
            setSelectRelationship({
              value: defaultRelationshipObj?.Relationship_ID,
              label: defaultRelationshipObj?.Relationship_Name
            });
          }
          setCompanyOptions(options);

          setSelectedSubSegment({
            value: responseData?.Subbusinesssegment,
            label: responseData?.Subbusinesssegment
          })
          const filterfirmType = firmtypeOpts.find((item) => item.value === String(responseData?.Firmtype)).label;
          !SafNo && setSelectedFirmType({
            label: filterfirmType,
            value: responseData?.Firmtype,
          });
          const filterOtherServiceProvider = ServiceProviders.find((item) => item.value === String(responseData?.Existingprovider)).label;
          setServiceProvider(
            {
              label: filterOtherServiceProvider,
              value: responseData?.Existingprovider,
            }
          )
          const filterOtherFirewall = firewallOpts.find((item) => item.value === String(responseData?.Firewall)).label;
          setOtherFirewall(
            {
              label: filterOtherFirewall,
              value: responseData?.Firewall,
            }
          )
          const filterOtherSelfpo = selfpoOpts.find((item) => item.value === String(responseData?.CompanySelf)).label;
          setSelectSelfpo({
            label: filterOtherSelfpo,
            value: responseData?.CompanySelf,
          })

          ///////////////////////////////////



          const concatenatedAddress = `${responseData.BlockTowerNumber || ''} ${responseData.HousePlotFlatNo || ''} ${responseData.SocietyName || ''} ${responseData.Area || ''} ${responseData.City || ''} ${responseData.State || ''} ${responseData.Country || ''}`;
          // console.log("Concatenated Address:", concatenatedAddress);


          // console.log("responseData.Product", responseData.Product)
          let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })
          let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
          // console.log("getBuilding?.Response?.Data", getBuilding?.Response?.Data);

          setUserData({
            Remarks: responseData?.Remarks || "",
            Redunancy: responseData?.Redunancy || false,
            Block: responseData?.Block || "",
            Status: responseData?.Status || "",
            Statuscode: responseData?.Statuscode || "",
            OppId: responseData?.OppId || "",
            LeadId: responseData?.LeadId || "",
            PriceList: responseData?.PriceList || "",
            Topic: responseData?.Topic || "",
            StateId: responseData?.StateId || "",
            CityId: responseData?.CityId || "",
            AreaId: responseData?.AreaId || "",
            BuildingId: responseData.BuildingId ? responseData.BuildingId : "",
            BuildingCode: "",
            SpecificArea: responseData?.SpecificArea || "",
            SpecificBuilding: responseData?.SpecificBuilding || "",
            Building_BuildingStatus: responseData ? responseData?.Building_BuildingStatus : "",
            NoOfUsers: responseData?.NoOfUsers || "",
            NoOfBeds: responseData?.NoOfBeds || "",
            // IndustryId: responseData?.IndustryId || "",
            ApprovalRequiredFlag: responseData?.ApprovalRequiredFlag || "",
            Reason: responseData?.Reason || "",
            Area: responseData?.Area || "",
            Businesssegment: responseData?.Businesssegment || "",
            State: responseData?.State || "",
            Salutation: responseData?.Salutation || "",

            PostalCode: responseData?.PostalCode || "",
            InstPin: responseData?.PostalCode || "",
            Mobilephone: responseData?.Mobilephone || "",
            Media: responseData?.Media || "",
            Lco: responseData?.Lco || null,
            // Industry: responseData?.Industry || "",
            Group: responseData?.Group || "",
            Floor: responseData?.Floor || "",
            TPFeasibilty: responseData?.TPFeasibilty || "",
            CreateAreaOrBuilding: responseData?.CreateAreaOrBuilding || false,

            Product: responseData?.Product || "",
            ProductSegment: responseData?.ProductSegment || "",
            FeasibilityRequired: responseData?.FeasibilityRequired || false,
            Existingprovider: responseData?.Existingprovider || "",
            Emailaddress: responseData?.Emailaddress || "",
            Country: responseData?.Country || "",
            Companyname: responseData?.Companyname || "",
            City: responseData?.City || "",
            leadname: responseData?.leadname || "",
            Buildingname: responseData?.Buildingname || "",
            BuildingNo: responseData?.BuildingNo || "",
            ContactPersonName: responseData?.ContactPersonName || "",
            CustomerSegment: responseData?.CustomerSegment || "",
            LastMileType: responseData?.LastMileType || "",
            UpTimesla: responseData?.UpTimesla || "",
            FirewallSetToExpire: responseData?.FirewallSetToExpire || "",
            CompanySelf: responseData?.CompanySelf || "",
            PoLock: yyyymmddFormat(responseData?.PoLock) || "",
            Price: responseData?.Price || "",
            OriginatingLead: responseData?.OriginatingLead || "",
            FirewallAwc: responseData?.FirewallAwc || "",
            PoNext: yyyymmddFormat(responseData?.PoNext) || "",
            Company: responseData?.Company || "",
            TotalAmount: responseData?.TotalAmount || "",
            VerticalID: responseData?.VerticalID || "",
            TypeOfOrder: responseData?.TypeOfOrder || "",
            PocClosureDate: responseData?.PocClosureDate || "",
            TurnOver: responseData?.TurnOver || "",
            SocietyName: responseData?.SocietyName || "",
            SocietyId: responseData?.SocietyId || "",
            SocietyStatus: responseData?.SocietyStatus || "",
            HousePlotFlatNo: responseData?.HousePlotFlatNo || "",
            BlockTowerNumber: responseData?.BlockTowerNumber || "",
            OTCAmount: responseData?.OTCAmount || "",
            SDAmount: responseData?.SDAmount || "",
            RCAmount: responseData?.RCAmount || "",
            IsPaymentLinkSendToCustomer: "",
            UpfrontApprovedSDAmount: "",
            UpfrontApprovedOTCAmount: "",
            UpfrontApprovedRCAmount: "",
            UpfrontReqSDAmount: SafNo ? "" : responseData?.UpfrontRequestedSDAmount,
            UpfrontReqOTCAmount: SafNo ? "" : responseData?.UpfrontRequestedOTCAmountIncTax,
            UpfrontReqRCAmount: SafNo ? "" : responseData?.UpfrontRequestedRCAmountIncTax,
            ApprovedSDAmount: responseData?.ApprovedSDAmount || "",
            ApprovedOTCAmount: responseData?.ApprovedOTCAmountIncTax || "",
            ApprovedRCAmount: responseData?.ApprovedRCAmountIncTax || "",
            totalAmount: responseData?.TotalAmount || "",
          });

          fetchLatLong(concatenatedAddress);
          setFirstName(responseData.Companyname);
          setSelectIndustry({
            value: responseData.IndustryId,
            label: responseData.Industry,
          })
          setSelectedProductType({
            value: responseData.Product,
            label: responseData.Product,
          })

          const filterProductType = productdropdetails?.find((item) =>
            item.label === String(responseData.Product)
          ).value;

          // console.log("filterProductType", filterProductType)
          // console.log("responseData.Product", responseData)

          // setSelectState({
          //   value: responseData.StateId,
          //   label: responseData.State,
          // })
          // setLastName(responseData.Companyname);

        } else {
          // Handle unsuccessful response
          console.error("Error fetching opportunity data:", responseData?.Message);
        }
      } catch (error) {
        // Handle fetch error
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [getLeadId]);


  const yyyymmddFormat = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return "";
    if (parts[0].length === 4) {
      return dateStr; // Already in YYYY-MM-DD format
    } else {
      // Convert from DD-MM-YYYY to YYYY-MM-DD
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
  };



  // useEffect(() => {
  //   const fetchBussinessCAF = async () => {
  //     setLoading(true)
  //     try {
  //       if (!SafNo) return;

  //       const apiUrl = process.env.REACT_APP_API_URL;

  //       const requestData = {
  //         Action: "getDigitSaf",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         cafNo: "",
  //         oppid: "",
  //         safNo: SafNo,
  //         password: sessionStorage.getItem("password"),
  //         userName: sessionStorage.getItem("userName"),
  //       };

  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });

  //       const result = await response.json();
  //       console.log("firmtype:", result?.Response?.Data?.companyDetailSAF.FirmType);
  //       sessionStorage.setItem("firmtype", result?.Response?.Data?.companyDetailSAF?.FirmType || "");
  //       // setGetCafNo(result.Response.cafDetail.CafNo); sellerImage customerKYCdocument

  //       //  console.log({
  //       //     customerImage: { fileNameWithExtension: result.Response.Data.customerImage.FileNameWithExtension, fileContent: result.Response.Data.customerImage.FileContent },
  //       //     sellerImage: { fileNameWithExtension: result.Response.Data.sellerImage.SellerFileNameWithExtension, fileContent: result.Response.Data.sellerImage.SellerFileContent },
  //       //     customerKYCdocument: { fileNameWithExtension: result.Response.Data.customerKYCdocument.CustomerKYCfileNameWithExtension, fileContent: result.Response.Data.customerKYCdocument.CustomerKYCfileContent },
  //       //   });

  //       let KycDocName = (result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileNameWithExtension).split("_").pop().split(".")[0];
  //       // console.log(KycDocName);        
  //       setSelectDocument(optionDocument.find((data) => data.label == KycDocName))

  //       setNewCafUpdateRequestBody((prevData) => ({
  //         ...prevData,
  //         customerImage: { fileNameWithExtension: result?.Response?.Data?.customerImage?.FileNameWithExtension, fileContent: result?.Response?.Data?.customerImage?.FileContent },
  //         sellerImage: { sellerOTPAuthDate: "", sellerFileNameWithExtension: result?.Response?.Data?.sellerImage?.SellerFileNameWithExtension, sellerFileContent: result?.Response?.Data?.sellerImage?.SellerFileContent },
  //         customerKYCdocument: { customerKYCAddress: "", customerKYCfileNameWithExtension: result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileNameWithExtension, customerKYCfileContent: result?.Response?.Data?.customerKYCdocument?.CustomerKYCfileContent },
  //       }));

  //       console.log(cityAuthOption, result?.Response?.Data?.billingAddressSAF.Bill_City);


  //       //////nnnnnnnnnnnn        
  //       // setSelectedFirmType(firmTypes.find((data) => data.value == result?.Response?.Data?.companyDetail?.FirmType))
  //       setCustomerWorkingHours(custmrworkhrsoptions.find((data) => data.value == result?.Response?.Data?.CustomerWorkingHours));
  //       setSelectedCommMode(CommModeOpts.find((data) => data.value == result?.Response?.Data?.PreferredCommMode));
  //       setMonitorDays(MonitorDaysOpts.find((data) => data.value == result?.Response?.Data?.NtwMonitAlert));
  //       setBusinessDays(BusDaysOpts.find((data) => data.value == result?.Response?.Data?.BusinessDays));
  //       setBillType(billtypeOpts.find((data) => data.value == result?.Response?.Data?.installationAddressesSAF.Inst_BillType));
  //       setSelectVoip(voiOpts.find((data) => data.value == result?.Response?.Data?.installationAddressesSAF.Inst_VoidPort));
  //       setCusCategory(customercatOpts.find((data) => data.value == result?.Response?.Data?.installationAddressesSAF.Inst_CategoryofCustomer));
  //       setSelectAuthCity(cityAuthOption.find((data) => data.value == result?.Response?.Data?.authSigDetailsSAF.Auth_City));
  //       setSelectBillCity(cityAuthOption.find((data) => data.value == (result?.Response?.Data.billingAddressSAF.Bill_City)));
  //       setSelectInstCity(cityAuthOption.find((data) => data.value == (result?.Response?.Data.installationAddressesSAF.Inst_City)));
  //       setpaymentStatus(PaymentOpts.find((data) => data.value == result?.Response?.Data?.paymentsSAF.PaymentStatus));
  //       let stateOpt = optionAuthState?.map((data) => ({
  //         value: data.code,
  //         label: data.name,
  //       }))
  //       setSelectAuthState(stateOpt?.find((data) => data.value == result?.Response?.Data?.authSigDetailsSAF.Auth_State));
  //       setSelectBillState(stateOpt?.find((data) => data.value == result?.Response?.Data?.billingAddressSAF.Bill_State));
  //       setSelectInstState(stateOpt?.find((data) => data.value == result?.Response?.Data?.installationAddressesSAF.Inst_State));
  //       setSelectPaymentMode(optionPayment?.find((data) => data.value == result?.Response?.Data?.paymentsSAF.ModeOfPayment));
  //       setselectedPaySlipOption(filteredPayslipOpts?.find((data) => data.value == result?.Response?.Data?.paymentsSAF.PayInSlip).value);
  //       console.log(filteredPayslipOpts, result?.Response?.Data?.paymentsSAF.PayInSlip);

  //       if (result?.Response?.Data?.paymentsSAF.ModeOfPayment === "Offline") {
  //         // Show only Cheque, DD, NEFT, RTGS
  //         setFilteredPayslipOpts(
  //           payslipOpts.filter((option) =>
  //             ["1", "2", "4", "5"].includes(option.value)
  //           )
  //         );
  //       } else if (result?.Response?.Data?.paymentsSAF.ModeOfPayment === "Online") {
  //         // Show all options except Cheque, DD, NEFT, RTGS
  //         setFilteredPayslipOpts(
  //           payslipOpts.filter(
  //             (option) => !["1", "2", "4", "5"].includes(option.value)
  //           )
  //         );
  //       } else {
  //         // Reset to show all options if no valid payment mode is selected
  //         setFilteredPayslipOpts(payslipOpts);
  //       }

  //       // console.log(stateOpt.find((data) => data.value == result?.Response?.Data?.billingAddress.Bill_State));

  //       // let selectedCity = cityAuthOption?.find((data) => data.value == result?.Response?.Data?.billingAddress.Bill_City )
  //       // console.log(cityAuthOption,{cityCode: selectedCity?.value, cityName: selectedCity?.label});

  //       // let getAreaList = await api.getArea({cityCode: selectedCity?.value, cityName: selectedCity?.label});
  //       // let areaOpt = getAreaList?.map((data) => ({
  //       //   value: data.AreaCode,
  //       //   label: data.AreaName,
  //       // }))
  //       // setSelectArea(areaOpt.find((data) => data.value == result?.Response?.Data?.billingAddress.Bill_City))


  //       // console.log(stateOpt.find((data) => data.value == result?.Response?.Data?.authSigDetails.Auth_State));
  //       // console.log(cityAuthOption.find((data) => data.value == result?.Response?.Data?.authSigDetails.Auth_City ));



  //       // console.log(result);

  //       setCustomerDetails(result?.Response?.Data?.NetworkTechnology);
  //       setCafDetails(result?.Response?.Data)
  //       // console.log("paymentDetail?.ApprovedRCAmount", result?.Response?.Data?.payments.ApprovedOTCAmountIncTax);
  //       console.log("UpfrontRequestedOTCAmountIncTax", result?.Response?.Data?.paymentsSAF.UpfrontRequestedOTCAmountIncTax);
  //       let getAreaBill = await api.getArea({ cityName: "", cityCode: result?.Response?.Data.billingAddressSAF?.Bill_City })
  //       let getAreaInst = await api.getArea({ cityName: "", cityCode: result?.Response?.Data.installationAddressesSAF?.Inst_City })
  //       let getBuildingBill = await api.getBuilding({ areaName: "", areaCode: result?.Response?.Data.billingAddressSAF?.Bill_Area })
  //       let getBuildingInst = await api.getBuilding({ areaName: "", areaCode: result?.Response?.Data.installationAddressesSAF?.Inst_Area })

  //       let defaultBuildingBill = getBuildingBill?.Response?.Data?.find((building) => building.BuildingCode == result?.Response?.Data.billingAddressSAF?.Bill_BuildingName)
  //       let defaultBuildingInst = getBuildingInst?.Response?.Data?.find((building) => building.BuildingCode == result?.Response?.Data.installationAddressesSAF?.Inst_BuildingName)
  //       let defaultAreaBill = getAreaBill?.Response?.Data?.find((area) => area.AreaCode == result?.Response?.Data.installationAddressesSAF?.Bill_Area)
  //       let defaultAreaInst = getAreaInst?.Response?.Data?.find((area) => area.AreaCode == result?.Response?.Data.installationAddressesSAF?.Inst_Area)
  //       console.log(defaultAreaInst);
  //       setBuildingBill(defaultBuildingBill)
  //       setAreaBill(defaultAreaBill)
  //       setAreaInst(defaultAreaInst)
  //       setBuildingInst(defaultBuildingInst)
  //       // console.log("getBuildingInst", getBuildingInst);
  //       // console.log("getBuilding", defaultBuildingBill, defaultBuildingInst);

  //       if (result.Status == "Success" && result.Response) {
  //         // console.log(result.Response.Data.billingAddress);          

  //         const { accountDetail, paymentDetail, documentRequired, cafDetail, billingAddressSAF, paymentsSAF } = result.Response.Data;
  //         console.log(result?.Response?.Data);
  //         const responseData = result?.Response?.Data;

  //         setUserData({
  //           authorName: responseData?.authSigDetailsSAF?.Auth_Name,
  //           authorFather: responseData?.authSigDetailsSAF?.Auth_Father,
  //           authResidentialAddress: responseData?.authSigDetailsSAF?.Auth_Resadd,
  //           autherMobile: responseData?.authSigDetailsSAF?.Auth_MobileNo,
  //           autherEmail: responseData?.authSigDetailsSAF?.Auth_EmailId,
  //           autherPinCode: responseData?.authSigDetailsSAF?.Auth_PinCode,
  //           LastMileType: responseData?.LastMileType,
  //           BuildingNo: responseData?.installationAddressesSAF?.Inst_BuildingNo,
  //           InstPin: responseData?.installationAddressesSAF?.Inst_PinCode,
  //           // InstFloor: responseData?.installationAddresses?.Inst_InstallationFloor,
  //           // Remarks: responseData?.Remarks || "",
  //           // Redunancy: responseData?.Redunancy || false,
  //           // Block: responseData?.Block || "",
  //           // Status: responseData?.Status || "",
  //           // Statuscode: responseData?.Statuscode || "",
  //           // OppId: responseData?.OppId || "",
  //           // LeadId: responseData?.LeadId || "",
  //           // PriceList: responseData?.PriceList || "",
  //           // Topic: responseData?.Topic || "",
  //           StateId: responseData?.installationAddressesSAF?.Inst_State || "",
  //           CityId: responseData?.installationAddressesSAF?.Inst_City || "",
  //           AreaId: responseData?.installationAddressesSAF?.Inst_Area || "",
  //           BuildingId: responseData?.installationAddressesSAF?.Inst_BuildingName || "",
  //           BuildingNo: responseData?.installationAddressesSAF?.Inst_BuildingNo || "0",
  //           Emailaddress: responseData?.installationAddressesSAF?.Inst_EmailId || "",
  //           // BuildingCode: "",
  //           // SpecificArea: responseData?.SpecificArea || "",
  //           // SpecificBuilding: responseData?.SpecificBuilding || "",
  //           // Building_BuildingStatus: responseData ? responseData?.Building_BuildingStatus : "",
  //           // NoOfUsers: responseData?.NoOfUsers || "",
  //           // NoOfBeds: responseData?.NoOfBeds || "",
  //           // // IndustryId: responseData?.IndustryId || "",
  //           // ApprovalRequiredFlag: responseData?.ApprovalRequiredFlag || "",
  //           // Reason: responseData?.Reason || "",
  //           // Area: responseData?.Area || "",
  //           // Businesssegment: responseData?.Businesssegment || "",
  //           // State: responseData?.State || "",
  //           // Salutation: responseData?.Salutation || "",

  //           // PostalCode: responseData?.PostalCode || "",
  //           Mobilephone: responseData?.authSigDetailsSAF?.Auth_MobileNo || "",
  //           // Media: responseData?.Media || "",
  //           // Lco: responseData?.Lco || null,
  //           // // Industry: responseData?.Industry || "",
  //           // Group: responseData?.Group || "",
  //           Floor: responseData?.installationAddressesSAF?.Inst_InstallationFloor || "",
  //           // TPFeasibilty: responseData?.TPFeasibilty || "",
  //           // CreateAreaOrBuilding: responseData?.CreateAreaOrBuilding || false,

  //           Product: responseData?.Product || "",
  //           ProductSegment: responseData?.installationAddressesSAF?.ProductSegment || "" || "",
  //           // FeasibilityRequired: responseData?.FeasibilityRequired || false,
  //           // Existingprovider: responseData?.Existingprovider || "",
  //           // Emailaddress: responseData?.Emailaddress || "",
  //           // Country: responseData?.Country || "",
  //           Companyname: responseData?.CompanyName || "",
  //           // City: responseData?.City || "",
  //           // leadname: responseData?.leadname || "",
  //           // Buildingname: responseData?.Buildingname || "",
  //           // BuildingNo: responseData?.BuildingNo || "",
  //           ContactPerson: responseData?.CustomerName || "",
  //           contactName: responseData?.billingAddressSAF?.Bill_ConatctName || "",
  //           billmail: responseData?.billingAddressSAF?.Bill_EmailId || "",
  //           billPhone: responseData?.billingAddressSAF?.Bill_MobileNo || "",
  //           billBuildingNo: responseData?.billingAddressSAF?.Bill_BuildingNo || "",
  //           billFloor: responseData?.billingAddressSAF?.Bill_Floor || "",
  //           billPin: responseData?.billingAddressSAF?.Bill_PinCode || "",
  //           techSupportEmail: responseData?.TechnicalSupportEmailID || "",
  //           // CustomerSegment: responseData?.CustomerSegment || "",
  //           // LastMileType: responseData?.LastMileType || "",
  //           UpTimesla: responseData?.otherinformations?.UptimeSLA || "",
  //           // FirewallSetToExpire: responseData?.FirewallSetToExpire || "",
  //           // CompanySelf: responseData?.CompanySelf || "",
  //           PoLock: yyyymmddFormat(responseData?.otherinformations?.PoLock) || "",
  //           PoNext: yyyymmddFormat(responseData?.otherinformations?.PoNext) || "",
  //           // Price: responseData?.Price || "",
  //           // OriginatingLead: responseData?.OriginatingLead || "",
  //           // FirewallAwc: responseData?.FirewallAwc || "",
  //           // PoNext: yyyymmddFormat(responseData?.PoNext) || "",
  //           // Company: responseData?.Company || "",
  //           // TotalAmount: responseData?.TotalAmount || "",
  //           // VerticalID: responseData?.VerticalID || "",
  //           // TypeOfOrder: responseData?.TypeOfOrder || "",
  //           // PocClosureDate: responseData?.PocClosureDate || "",
  //           // TurnOver: responseData?.TurnOver || "",
  //           // SocietyName: responseData?.SocietyName || "",
  //           // SocietyId: responseData?.SocietyId || "",
  //           // SocietyStatus: responseData?.SocietyStatus || "",
  //           // HousePlotFlatNo: responseData?.HousePlotFlatNo || "",
  //           // BlockTowerNumber: responseData?.BlockTowerNumber || "",
  //           // OTCAmount: responseData?.OTCAmount || "",
  //           // SDAmount: responseData?.SDAmount || "",
  //           // RCAmount: responseData?.RCAmount || "",
  //           // IsPaymentLinkSendToCustomer: "",
  //           // UpfrontApprovedSDAmount: "",
  //           // UpfrontApprovedOTCAmount: "",
  //           // UpfrontApprovedRCAmount: "",
  //           // UpfrontReqSDAmount: CafId ? "" : responseData?.UpfrontRequestedSDAmount,
  //           // UpfrontReqOTCAmount: CafId ? "" : responseData?.UpfrontRequestedOTCAmountIncTax,
  //           // UpfrontReqRCAmount: CafId ? "" : responseData?.UpfrontRequestedRCAmountIncTax,
  //           // ApprovedSDAmount: responseData?.ApprovedSDAmount || "",
  //           // ApprovedOTCAmount: responseData?.ApprovedOTCAmountIncTax || "",
  //           // ApprovedRCAmount: responseData?.ApprovedRCAmountIncTax || "",
  //           // totalAmount: responseData?.TotalAmount || "",
  //         });

  //         const options = await fetchCompanyData("");
  //         console.log(options);
  //         let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
  //         console.log(defaultCompanyGroupObj);
  //         let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
  //         console.log(defaultRelationship);

  //         setSelectedCompany({
  //           value: defaultCompanyGroupObj?.value,
  //           label: defaultCompanyGroupObj?.label,
  //         });

  //         setSelectGroup({
  //           value: defaultCompanyGroupObj?.groupId,
  //           label: defaultCompanyGroupObj?.group,
  //         });

  //         // console.log(defaultRelationship);

  //         if (defaultRelationship.Response?.length > 0) {
  //           let defaultRelationshipObj = defaultRelationship.Response?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
  //           console.log(defaultRelationshipObj);
  //           setSelectRelationship({
  //             value: defaultRelationshipObj?.Relationship_ID,
  //             label: defaultRelationshipObj?.Relationship_Name
  //           });
  //         }

  //         setCompanyOptions(options);

  //         setSelectedSubSegment({
  //           value: responseData?.SubBussinessSegment,
  //           label: responseData?.SubBussinessSegment
  //         })

  //         // setSelectIndustry({
  //         //   value: responseData?.companyDetail?.IndustryType,
  //         //   label: responseData?.companyDetail?.IndustryType,
  //         // })
  //         console.log(responseData?.companyDetailSAF?.IndustryType, industrydropdetails, industrydropdetails.find((data) => data.value == responseData?.companyDetailSAF?.IndustryType));

  //         setSelectIndustry(industrydropdetails.find((data) => data.value == responseData?.companyDetailSAF?.IndustryType))
  //         setSelectedProductType({
  //           value: responseData.Product,
  //           label: responseData.Product,
  //         })

  //         // const filterOtherFirewall = firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall));
  //         // console.log(filterOtherFirewall);

  //         setOtherFirewall(firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall)))
  //         // const filterOtherServiceProvider = ServiceProviders.find((item) => item.value === String(responseData?.Existingprovider)).label;
  //         setServiceProvider(ServiceProviders.find((item) => item.value == String(responseData?.otherinformations?.ExistingServiceProvider)))

  //         const concatenatedAddress = `${responseData?.installationAddressesSAF?.Inst_BuildingNo || ''} ${responseData?.installationAddressesSAF?.Inst_InstallationFloor || ''} ${defaultAreaInst?.AreaName || ''} ${cityAuthOption?.find((data) => data.value == (responseData.installationAddressesSAF.Inst_City))?.label || ''} ${stateOpt?.find((data) => data.value == result?.Response?.Data?.installationAddressesSAF.Inst_State)?.label || ''} ${'India'}`;
  //         console.log(concatenatedAddress);
  //         fetchLatLong(concatenatedAddress);

  //         const filterOtherSelfpo = selfpoOpts.find((item) => item.value === String(responseData?.otherinformations?.CompanySelfPo)).label;
  //         setSelectSelfpo({
  //           label: filterOtherSelfpo,
  //           value: responseData?.CompanySelf,
  //         })
  //         setPaymentButton(result?.Response?.Data?.paymentsSAF?.IsPaymentLinkSendToCustomer);

  //         return;
  //         // setUserData({
  //         //   UpfrontReqOTCAmount: result?.Response?.Data?.payments?.UpfrontRequestedOTCAmountIncTax,
  //         //   UpfrontReqRCAmount: result?.Response?.Data?.payments?.UpfrontRequestedRCAmountIncTax,
  //         //   billingAddress: billingAddress,
  //         //   totalAmount: result?.Response?.Data?.payments?.TotalAmount || "",
  //         //   OTCAmount: result?.Response?.Data?.payments?.OTCAmount || "",
  //         //   SDAmount: result?.Response?.Data?.payments?.SDAmount || "",
  //         //   RCAmount: result?.Response?.Data?.payments?.RCAmount || "",
  //         //   IsPaymentLinkSendToCustomer: result?.Response?.Data?.payments?.IsPaymentLinkSendToCustomer ,
  //         //   UpfrontApprovedSDAmount: result?.Response?.Data?.payments?.UpfrontApprovedSDAmount,
  //         //   UpfrontApprovedOTCAmount: result?.Response?.Data?.payments?.UpfrontApprovedOTCAmount,
  //         //   UpfrontApprovedRCAmount: result?.Response?.Data?.payments?.UpfrontApprovedRCAmount,
  //         //   UpfrontReqSDAmount: result?.Response?.Data?.payments?.UpfrontRequestedSDAmount,
  //         //   UpfrontReqOTCAmount: result?.Response?.Data?.payments?.UpfrontRequestedOTCAmountIncTax,
  //         //   UpfrontReqRCAmount: result?.Response?.Data?.payments?.UpfrontRequestedRCAmountIncTax,
  //         //   ApprovedSDAmount: result?.Response?.Data?.payments?.ApprovedSDAmount,
  //         //   ApprovedOTCAmount: result?.Response?.Data?.payments?.ApprovedOTCAmountIncTax ,
  //         //   ApprovedRCAmount: result?.Response?.Data?.payments?.ApprovedRCAmountIncTax,
  //         //   dDupStatus: cafDetail?.DedupeDOAstatus ? cafDetail?.DedupeDOAstatus : "",
  //         //   paymentDoaStatus: cafDetail?.paymentDOAstatus ? cafDetail?.paymentDOAstatus : "",
  //         // });
  //         // alert()
  //         // setGetCafNo(cafDetail?.CafNo);
  //         // setPaymentButton(result?.Response?.Data?.payments?.IsPaymentLinkSendToCustomer);
  //         // console.log("FileNameWithExtension",result.Response.customerImage.FileNameWithExtension);
  //         setCustomerImg(result.Response.customerImage?.FileContent);

  //         setSalutate(accountDetail?.SalutationId || "");
  //         setFirstName(accountDetail?.Companyname || "");
  //         setLastName(accountDetail?.LastName || "");
  //         setMobileNo(cafDetail?.MobileNo);
  //         setEmailId(result.Response.accountDetail?.EmailId);
  //         setVoice(result.Response.cafDetail.Voice);
  //         // setCustomerPicture({ fileNameWithExtension: result.Response.customerImage.FileNameWithExtension });
  //         setcustomerComp(result.Response.cafDetail.CompanyId);
  //         setcustomerGroup(result.Response.cafDetail.GroupId);
  //         setSelectRelationship(result.Response.cafDetail.RelationshipId);
  //         setApiStateCode(result.Response.cafDetail.State);
  //         setApiCityCode(result.Response.cafDetail.City);
  //         setApiAreaCode(result.Response.cafDetail.Area);
  //         setApiSocietyCode(result.Response.cafDetail.Society);
  //         setApiFloorCode(result.Response.cafDetail.HousePlotFlatNumber);
  //         setApiPinCode(result.Response.cafDetail.PostalCode);
  //         setApiblockCode(result.Response.accountDetail.BlockTower);
  //         setSelectIndustry({
  //           value: cafDetail?.IndustryId || "",
  //           label: cafDetail?.IndustryId || "",
  //         });

  //         const filterFirmType = firmtypeOpts.find((item) => item.value === String(documentRequired?.FirmType));
  //         // setSelectedFirmType(filterFirmType ? { value: documentRequired?.FirmType, label: filterFirmType.label } : null);
  //         setSelectedProductType({
  //           value: cafDetail?.Product,
  //           label: cafDetail?.Product,
  //         });
  //         setSelectPaymentMode({
  //           value: result.Response.paymentDetail.ModeOfPayment,
  //           label: result.Response.paymentDetail.ModeOfPayment,
  //         });
  //         const filterpaymentStatus = PaymentOpts.find((item) => item.value === String(result.Response.paymentDetail.PaymentStatus)).label;
  //         setpaymentStatus({
  //           label: filterpaymentStatus,
  //           value: result.Response.paymentDetail.PaymentStatus,
  //         })
  //         setPaymentMethod(result.Response.paymentDetail.PayInSlip);
  //         setPaymentDetails(result.Response.paymentDetail);
  //         setSecuritydep(result?.Response?.Data?.paymentsSAF?.SecurityDeposit);
  //         setIsGst(result.Response.cafDetail.IsGST);
  //         setTan(result.Response.cafDetail.TANNo);
  //         setPan(result.Response.cafDetail.PANNo);
  //         setSecuritydeptype(paymentDetails?.SecurityDepositType);
  //         console.log(result?.Response?.Data?.paymentsSAF?.IsPaymentLinkSendToCustomer);

  //         setIsPaymentLinkSendToCustomer(result?.Response?.Data?.paymentsSAF?.IsPaymentLinkSendToCustomer);


  //         // setUserData({
  //         //   billingAddress: billingAddress,
  //         //   totalAmount: paymentDetail?.Amount || "",
  //         //   OTCAmount: paymentDetail?.OTCAmount || "",
  //         //   SDAmount: paymentDetail?.SDAmount || "",
  //         //   RCAmount: paymentDetail?.RCAmount || "",
  //         //   IsPaymentLinkSendToCustomer: paymentDetail?.IsPaymentLinkSendToCustomer || "",
  //         //   UpfrontApprovedSDAmount: paymentDetail?.UpfrontApprovedSDAmount || "",
  //         //   UpfrontApprovedOTCAmount: paymentDetail?.UpfrontApprovedOTCAmount || "",
  //         //   UpfrontApprovedRCAmount: paymentDetail?.UpfrontApprovedRCAmount || "",
  //         //   UpfrontReqSDAmount: paymentDetail?.UpfrontRequestedSDAmount || "",
  //         //   UpfrontReqOTCAmount: paymentDetail?.UpfrontRequestedOTCAmountIncTax || "",
  //         //   UpfrontReqRCAmount: paymentDetail?.UpfrontRequestedRCAmountIncTax || "",
  //         //   ApprovedSDAmount: paymentDetail?.ApprovedSDAmount || "",
  //         //   ApprovedOTCAmount: result?.Response?.Data?.payments?.ApprovedOTCAmountIncTax || "",
  //         //   ApprovedRCAmount: result?.Response?.Data?.payments?.ApprovedRCAmountIncTax || "",
  //         //   dDupStatus: cafDetail?.DedupeDOAstatus ? cafDetail?.DedupeDOAstatus : "",
  //         //   paymentDoaStatus: cafDetail?.paymentDOAstatus ? cafDetail?.paymentDOAstatus : "",
  //         // });

  //         // setCafDigiHome(result.Response);

  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBussinessCAF();
  // }, [SafNo, cityAuthOption.length > 0, industrydropdetails]);

  // {/* *********** END ********* */ }

  // {/* ***********for getBank datA API ********* */ }

  // useEffect(() => {
  //   const fetchBussinessCAF = async () => {
  //     setLoading(true);
  //     try {
  //       if (!SafNo) return;

  //       const apiUrl = process.env.REACT_APP_API_URL;
  //       const requestData = {
  //         Action: "getDigitSaf",
  //         Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
  //         cafNo: "",
  //         oppid: "",
  //         safNo: SafNo,
  //         password: sessionStorage.getItem("password"),
  //         userName: sessionStorage.getItem("userName"),
  //       };

  //       const response = await fetch(apiUrl, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestData),
  //       });

  //       const result = await response.json();

  //       // Extract the first data object from the returned array.
  //       const data = result?.Response?.Data?.[0];

  //       console.log("firmtype:", data?.companyDetailSAF?.FirmType);
  //       sessionStorage.setItem("firmtype", data?.companyDetailSAF?.FirmType || "");

  //       // Safely extract KYC document name if it exists
  //       let KycDocName = "";
  //       if (data?.customerKYCdocument && data.customerKYCdocument.CustomerKYCfileNameWithExtension) {
  //         KycDocName = data.customerKYCdocument.CustomerKYCfileNameWithExtension
  //           .split("_")
  //           .pop()
  //           .split(".")[0];
  //       }
  //       setSelectDocument(optionDocument.find((item) => item.label === KycDocName));

  //       // Update request body state with images/documents
  //       setNewCafUpdateRequestBody((prevData) => ({
  //         ...prevData,
  //         customerImage: {
  //           fileNameWithExtension: data?.customerImage?.FileNameWithExtension,
  //           fileContent: data?.customerImage?.FileContent,
  //         },
  //         sellerImage: {
  //           sellerOTPAuthDate: "",
  //           sellerFileNameWithExtension: data?.sellerImage?.SellerFileNameWithExtension,
  //           sellerFileContent: data?.sellerImage?.SellerFileContent,
  //         },
  //         customerKYCdocument: {
  //           customerKYCAddress: "",
  //           customerKYCfileNameWithExtension: data?.customerKYCdocument?.CustomerKYCfileNameWithExtension,
  //           customerKYCfileContent: data?.customerKYCdocument?.CustomerKYCfileContent,
  //         },
  //       }));

  //       console.log(cityAuthOption, data?.billingAddressSAF?.Bill_City);

  //       // Set various state values based on the data
  //       setCustomerWorkingHours(
  //         custmrworkhrsoptions.find((item) => item.value == data?.CustomerWorkingHours)
  //       );
  //       setSelectedCommMode(
  //         CommModeOpts.find((item) => item.value == data?.PreferredCommMode)
  //       );
  //       setMonitorDays(MonitorDaysOpts.find((item) => item.value == data?.NtwMonitAlert));
  //       setBusinessDays(BusDaysOpts.find((item) => item.value == data?.BusinessDays));
  //       setBillType(
  //         billtypeOpts.find((item) => item.value == data?.installationAddressesSAF?.Inst_BillType)
  //       );
  //       setSelectVoip(
  //         voiOpts.find((item) => item.value == data?.installationAddressesSAF?.Inst_VoidPort)
  //       );
  //       setCusCategory(
  //         customercatOpts.find((item) => item.value == data?.installationAddressesSAF?.Inst_CategoryofCustomer)
  //       );
  //       setSelectAuthCity(
  //         cityAuthOption.find((item) => item.value == data?.authSigDetailsSAF?.Auth_City)
  //       );
  //       setSelectBillCity(
  //         cityAuthOption.find((item) => item.value == data?.billingAddressSAF?.Bill_City)
  //       );
  //       setSelectInstCity(
  //         cityAuthOption.find((item) => item.value == data?.installationAddressesSAF?.Inst_City)
  //       );
  //       setpaymentStatus(
  //         PaymentOpts.find((item) => item.value == data?.paymentsSAF?.PaymentStatus)
  //       );

  //       let stateOpt = optionAuthState?.map((item) => ({
  //         value: item.code,
  //         label: item.name,
  //       }));
  //       setSelectAuthState(
  //         stateOpt?.find((item) => item.value == data?.authSigDetailsSAF?.Auth_State)
  //       );
  //       setSelectBillState(
  //         stateOpt?.find((item) => item.value == data?.billingAddressSAF?.Bill_State)
  //       );
  //       setSelectInstState(
  //         stateOpt?.find((item) => item.value == data?.installationAddressesSAF?.Inst_State)
  //       );
  //       setSelectPaymentMode(
  //         optionPayment?.find((item) => item.value == data?.paymentsSAF?.ModeOfPayment)
  //       );

  //       // Safely set selected PaySlip option if available
  //       const selectedPaySlipOption = filteredPayslipOpts?.find(
  //         (item) => item.value == data?.paymentsSAF?.PayInSlip
  //       );
  //       if (selectedPaySlipOption) {
  //         setselectedPaySlipOption(selectedPaySlipOption.value);
  //       }
  //       console.log(filteredPayslipOpts, data?.paymentsSAF?.PayInSlip);

  //       // Adjust payslip options based on mode of payment
  //       if (data?.paymentsSAF?.ModeOfPayment === "Offline") {
  //         setFilteredPayslipOpts(
  //           payslipOpts.filter((option) => ["1", "2", "4", "5"].includes(option.value))
  //         );
  //       } else if (data?.paymentsSAF?.ModeOfPayment === "Online") {
  //         setFilteredPayslipOpts(
  //           payslipOpts.filter((option) => !["1", "2", "4", "5"].includes(option.value))
  //         );
  //       } else {
  //         setFilteredPayslipOpts(payslipOpts);
  //       }

  //       setCustomerDetails(data?.NetworkTechnology);
  //       setCafDetails(data);
  //       console.log("UpfrontRequestedOTCAmountIncTax", data?.paymentsSAF?.UpfrontRequestedOTCAmountIncTax);
  //       setOppId(data?.OpportunityId);
  //       // Retrieve area and building information
  //       let getAreaBill = await api.getArea({
  //         cityName: "",
  //         cityCode: data?.billingAddressSAF?.Bill_City,
  //       });
  //       let getAreaInst = await api.getArea({
  //         cityName: "",
  //         cityCode: data?.installationAddressesSAF?.Inst_City,
  //       });
  //       let getBuildingBill = await api.getBuilding({
  //         areaName: "",
  //         areaCode: data?.billingAddressSAF?.Bill_Area,
  //       });
  //       let getBuildingInst = await api.getBuilding({
  //         areaName: "",
  //         areaCode: data?.installationAddressesSAF?.Inst_Area,
  //       });

  //       let defaultBuildingBill = getBuildingBill?.Response?.Data?.find(
  //         (building) => building.BuildingCode == data?.billingAddressSAF?.Bill_BuildingName
  //       );
  //       let defaultBuildingInst = getBuildingInst?.Response?.Data?.find(
  //         (building) => building.BuildingCode == data?.installationAddressesSAF?.Inst_BuildingName
  //       );
  //       let defaultAreaBill = getAreaBill?.Response?.Data?.find(
  //         (area) => area.AreaCode == data?.billingAddressSAF?.Bill_Area
  //       );
  //       let defaultAreaInst = getAreaInst?.Response?.Data?.find(
  //         (area) => area.AreaCode == data?.installationAddressesSAF?.Inst_Area
  //       );
  //       console.log(defaultAreaInst);
  //       setBuildingBill(defaultBuildingBill);
  //       setAreaBill(defaultAreaBill);
  //       setAreaInst(defaultAreaInst);
  //       setBuildingInst(defaultBuildingInst);

  //       // Process additional data if the response was successful
  //       if (result.Status === "Success" && result.Response) {
  //         const responseData = data;
  //         setUserData({
  //           authorName: responseData?.authSigDetailsSAF?.Auth_Name,
  //           authorFather: responseData?.authSigDetailsSAF?.Auth_Father,
  //           authResidentialAddress: responseData?.authSigDetailsSAF?.Auth_Resadd,
  //           autherMobile: responseData?.authSigDetailsSAF?.Auth_MobileNo,
  //           autherEmail: responseData?.authSigDetailsSAF?.Auth_EmailId,
  //           autherPinCode: responseData?.authSigDetailsSAF?.Auth_PinCode,
  //           LastMileType: responseData?.LastMileType,
  //           BuildingNo: responseData?.installationAddressesSAF?.Inst_BuildingNo,
  //           InstPin: responseData?.installationAddressesSAF?.Inst_PinCode,
  //           StateId: responseData?.installationAddressesSAF?.Inst_State || "",
  //           CityId: responseData?.installationAddressesSAF?.Inst_City || "",
  //           AreaId: responseData?.installationAddressesSAF?.Inst_Area || "",
  //           BuildingId: responseData?.installationAddressesSAF?.Inst_BuildingName || "",
  //           Emailaddress: responseData?.installationAddressesSAF?.Inst_EmailId || "",
  //           Mobilephone: responseData?.authSigDetailsSAF?.Auth_MobileNo || "",
  //           Floor: responseData?.installationAddressesSAF?.Inst_InstallationFloor || "",
  //           Product: responseData?.Product || "",
  //           ProductSegment: responseData?.installationAddressesSAF?.ProductSegment || "",
  //           Companyname: responseData?.CompanyName || "",
  //           ContactPerson: responseData?.CustomerName || "",
  //           contactName: responseData?.billingAddressSAF?.Bill_ConatctName || "",
  //           billmail: responseData?.billingAddressSAF?.Bill_EmailId || "",
  //           billPhone: responseData?.billingAddressSAF?.Bill_MobileNo || "",
  //           billBuildingNo: responseData?.billingAddressSAF?.Bill_BuildingNo || "",
  //           billFloor: responseData?.billingAddressSAF?.Bill_Floor || "",
  //           billPin: responseData?.billingAddressSAF?.Bill_PinCode || "",
  //           techSupportEmail: responseData?.TechnicalSupportEmailID || "",
  //           UpTimesla: responseData?.otherinformations?.UptimeSLA || "",
  //           PoLock: yyyymmddFormat(responseData?.otherinformations?.PoLock) || "",
  //           PoNext: yyyymmddFormat(responseData?.otherinformations?.PoNext) || "",
  //         });

  //         const options = await fetchCompanyData("");
  //         let defaultCompanyGroupObj = options?.find((company) =>
  //           company.label.includes(responseData.Company)
  //         );
  //         let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value);

  //         setSelectedCompany({
  //           value: defaultCompanyGroupObj?.value,
  //           label: defaultCompanyGroupObj?.label,
  //         });

  //         setSelectGroup({
  //           value: defaultCompanyGroupObj?.groupId,
  //           label: defaultCompanyGroupObj?.group,
  //         });

  //         if (defaultRelationship.Response?.length > 0) {
  //           let defaultRelationshipObj = defaultRelationship.Response?.find((relationship) =>
  //             relationship.Relationship_Name.includes(responseData.Relationship)
  //           );
  //           setSelectRelationship({
  //             value: defaultRelationshipObj?.Relationship_ID,
  //             label: defaultRelationshipObj?.Relationship_Name,
  //           });
  //         }

  //         setCompanyOptions(options);
  //         setSelectedSubSegment({
  //           value: responseData?.SubBussinessSegment,
  //           label: responseData?.SubBussinessSegment,
  //         });
  //         setSelectIndustry(
  //           industrydropdetails.find(
  //             (item) => item.value == responseData?.companyDetailSAF?.IndustryType
  //           )
  //         );
  //         setSelectedProductType({
  //           value: responseData.Product,
  //           label: responseData.Product,
  //         });
  //         setOtherFirewall(
  //           firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall))
  //         );
  //         setServiceProvider(
  //           ServiceProviders.find(
  //             (item) => item.value == String(responseData?.otherinformations?.ExistingServiceProvider)
  //           )
  //         );

  //         const concatenatedAddress = `${responseData?.installationAddressesSAF?.Inst_BuildingNo || ''} ${responseData?.installationAddressesSAF?.Inst_InstallationFloor || ''} ${defaultAreaInst?.AreaName || ''} ${cityAuthOption?.find((item) => item.value == responseData.installationAddressesSAF.Inst_City)?.label || ''} ${stateOpt?.find((item) => item.value == responseData?.installationAddressesSAF?.Inst_State)?.label || ''} India`;
  //         fetchLatLong(concatenatedAddress);

  //         const filterOtherSelfpo = selfpoOpts.find(
  //           (item) => item.value === String(responseData?.otherinformations?.CompanySelfPo)
  //         )?.label;
  //         setSelectSelfpo({
  //           label: filterOtherSelfpo,
  //           value: responseData?.CompanySelf,
  //         });
  //         setPaymentButton(responseData?.paymentsSAF?.IsPaymentLinkSendToCustomer);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchBussinessCAF();
  // }, [SafNo, cityAuthOption.length > 0, industrydropdetails]);

  useEffect(() => {
    const fetchBussinessCAF = async () => {
      setLoading(true);
      try {
        if (!SafNo) return;

        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getDigitSaf",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: "",
          oppid: "",
          safNo: SafNo,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        const data = result?.Response?.Data?.[0];

        if (!data) {
          console.error("No data found in response.");
          return;
        }

        // Store firm type in session
        // console.log("firmtype:", data?.companyDetailSAF?.FirmType);
        sessionStorage.setItem("firmtype", data?.companyDetailSAF?.FirmType || "");

        // Safely extract KYC document name if available
        let KycDocName = "";
        if (data?.customerKYCdocument?.CustomerKYCfileNameWithExtension) {
          KycDocName = data.customerKYCdocument.CustomerKYCfileNameWithExtension
            .split("_")
            .pop()
            .split(".")[0];
          setSelectDocument(optionDocument.find((item) => item.label === KycDocName));
        } else {
          setSelectDocument(null);
        }

        // Update images/documents state with null checks
        setNewCafUpdateRequestBody((prevData) => ({
          ...prevData,
          customerImage: {
            fileNameWithExtension: data?.customerImage?.FileNameWithExtension,
            fileContent: data?.customerImage?.FileContent,
          },
          sellerImage: data?.sellerImage
            ? {
              sellerOTPAuthDate: "",
              sellerFileNameWithExtension: data?.sellerImage?.SellerFileNameWithExtension,
              sellerFileContent: data?.sellerImage?.SellerFileContent,
            }
            : null,
          customerKYCdocument: data?.customerKYCdocument
            ? {
              customerKYCAddress: "",
              customerKYCfileNameWithExtension: data?.customerKYCdocument?.CustomerKYCfileNameWithExtension,
              customerKYCfileContent: data?.customerKYCdocument?.CustomerKYCfileContent,
            }
            : null,
        }));

        // Set various state values based on data, using fallbacks where needed
        setCustomerWorkingHours(
          custmrworkhrsoptions.find((item) => item.value == data?.CustomerWorkingHours)
        );
        // If PreferredCommMode is missing, try using paymentsSAF.ModeOfPayment
        setSelectedCommMode(
          CommModeOpts.find((item) => item.value == (data?.PreferredCommMode || data?.paymentsSAF?.ModeOfPayment))
        );
        setMonitorDays(MonitorDaysOpts.find((item) => item.value == data?.NtwMonitAlert));
        setBusinessDays(BusDaysOpts.find((item) => item.value == data?.BusinessDays));
        setBillType(
          billtypeOpts.find((item) => item.label == data?.installationAddressesSAF?.Inst_BillType)
        );
        // For VoIP and Customer Category, if the keys do not exist the values will be undefined
        setSelectVoip(voiOpts.find((item) => item.value == data?.installationAddressesSAF?.Inst_VoidPort));
        setCusCategory(
          customercatOpts.find((item) => item.value == data?.installationAddressesSAF?.Inst_CategoryofCustomer)
        );
        setSelectAuthCity(
          cityAuthOption.find((item) => item.value == data?.authSigDetailsSAF?.Auth_City)
        );
        setSelectBillCity(
          cityAuthOption.find((item) => item.value == data?.billingAddressSAF?.Bill_City)
        );
        setSelectInstCity(
          cityAuthOption.find((item) => item.value == data?.installationAddressesSAF?.Inst_City)
        );
        setpaymentStatus(
          PaymentOpts.find((item) => item.label == data?.paymentsSAF?.PaymentStatus)
        );

        // Create state options for address states
        let stateOpt = optionAuthState?.map((item) => ({
          value: item.code,
          label: item.name,
        }));
        setSelectAuthState(
          stateOpt.find((item) => item.value == data?.authSigDetailsSAF?.Auth_State)
        );
        setSelectBillState(
          stateOpt.find((item) => item.value == data?.billingAddressSAF?.Bill_State)
        );
        setSelectInstState(
          stateOpt.find((item) => item.value == data?.installationAddressesSAF?.Inst_State)
        );
        setSelectPaymentMode(
          optionPayment.find((item) => item.value == data?.paymentsSAF?.ModeOfPayment)
        );

        // Handle PaySlip option extraction
        const selectedPaySlipOption = filteredPayslipOpts?.find(
          (item) => item.value == data?.paymentsSAF?.PaymentSlip
        );
        if (selectedPaySlipOption) {
          setselectedPaySlipOption(selectedPaySlipOption.value);
        }
        // Adjust payslip options based on ModeOfPayment
        if (data?.paymentsSAF?.ModeOfPayment === "Offline") {
          setFilteredPayslipOpts(
            payslipOpts.filter((option) => ["1", "2", "4", "5"].includes(option.value))
          );
        } else if (data?.paymentsSAF?.ModeOfPayment === "Online") {
          setFilteredPayslipOpts(
            payslipOpts.filter((option) => !["1", "2", "4", "5"].includes(option.value))
          );
        } else {
          setFilteredPayslipOpts(payslipOpts);
        }

        // Set details and opportunity ID (NetworkTechnology may be undefined)
        setCustomerDetails(data?.NetworkTechnology);
        setCafDetails(data);
        setOppId(data?.OpportunityId);

        // Retrieve area and building information
        let getAreaBill = await api.getArea({
          cityName: "",
          cityCode: data?.billingAddressSAF?.Bill_City,
        });
        let getAreaInst = await api.getArea({
          cityName: "",
          cityCode: data?.installationAddressesSAF?.Inst_City,
        });
        let getBuildingBill = await api.getBuilding({
          areaName: "",
          areaCode: data?.billingAddressSAF?.Bill_Area,
        });
        let getBuildingInst = await api.getBuilding({
          areaName: "",
          areaCode: data?.installationAddressesSAF?.Inst_Area,
        });

        let defaultBuildingBill = getBuildingBill?.Response?.Data?.find(
          (building) => building.BuildingCode == data?.billingAddressSAF?.Bill_BuildingName
        );
        let defaultBuildingInst = getBuildingInst?.Response?.Data?.find(
          (building) => building.BuildingCode == data?.installationAddressesSAF?.Inst_BuildingName
        );
        let defaultAreaBill = getAreaBill?.Response?.Data?.find(
          (area) => area.AreaCode == data?.billingAddressSAF?.Bill_Area
        );
        let defaultAreaInst = getAreaInst?.Response?.Data?.find(
          (area) => area.AreaCode == data?.installationAddressesSAF?.Inst_Area
        );
        setBuildingBill(defaultBuildingBill);
        setAreaBill(defaultAreaBill);
        setAreaInst(defaultAreaInst);
        setBuildingInst(defaultBuildingInst);

        // Process additional data if the response was successful
        if (result.Status === "Success" && result.Response) {
          const responseData = data;
          setUserData({
            authorName: responseData?.authSigDetailsSAF?.Auth_Name,
            authorFather: responseData?.authSigDetailsSAF?.Auth_Father,
            authResidentialAddress: responseData?.authSigDetailsSAF?.Auth_Resadd || "",
            autherMobile: responseData?.authSigDetailsSAF?.Auth_MobileNo,
            autherEmail: responseData?.authSigDetailsSAF?.Auth_EmailId,
            autherPinCode: responseData?.authSigDetailsSAF?.Auth_PinCode,
            LastMileType: responseData?.LastMileType || "",
            BuildingNo: responseData?.installationAddressesSAF?.Inst_BuildingNo,
            InstPin: responseData?.installationAddressesSAF?.Inst_PinCode,
            StateId: responseData?.installationAddressesSAF?.Inst_State || "",
            CityId: responseData?.installationAddressesSAF?.Inst_City || "",
            AreaId: responseData?.installationAddressesSAF?.Inst_Area || "",
            BuildingId: responseData?.installationAddressesSAF?.Inst_BuildingName || "",
            Emailaddress: responseData?.installationAddressesSAF?.Inst_EmailId || "",
            Mobilephone: responseData?.authSigDetailsSAF?.Auth_MobileNo || "",
            Floor: responseData?.installationAddressesSAF?.Inst_InstallationFloor || "",
            // If Product is not provided, you might consider using ProductSegment instead
            Product: responseData?.Product || "",
            ProductSegment: responseData?.ProductSegment || "",
            Companyname: responseData?.CompanyName || "",
            ContactPersonName: responseData?.ContactPersonName || "",
            contactName: responseData?.billingAddressSAF?.Bill_ConatctName || "",
            // Use Bill_PhoneNo from billingAddressSAF
            billPhone: responseData?.billingAddressSAF?.Bill_PhoneNo || "",
            billmail: responseData?.billingAddressSAF?.Bill_EmailId || "",
            billBuildingNo: responseData?.billingAddressSAF?.Bill_BuildingNo || "",
            billFloor: responseData?.billingAddressSAF?.Bill_Floor || "",
            billPin: responseData?.billingAddressSAF?.Bill_PinCode || "",
            // Notice the casing change: TechnicalsupportEmailid from JSON sample
            techSupportEmail: responseData?.TechnicalsupportEmailid || "",
            UpTimesla: responseData?.otherinformations?.UptimeSLA || "",
            PoLock: responseData?.otherinformations
              ? yyyymmddFormat(responseData?.otherinformations?.PoLock)
              : "",
            PoNext: responseData?.otherinformations
              ? yyyymmddFormat(responseData?.otherinformations?.PoNext)
              : "",
          });

          const options = await fetchCompanyData("");
          let defaultCompanyGroupObj = options?.find((company) =>
            company.label.includes(responseData.Company)
          );
          let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value);

          setSelectedCompany({
            value: defaultCompanyGroupObj?.value,
            label: defaultCompanyGroupObj?.label,
          });

          setSelectGroup({
            value: defaultCompanyGroupObj?.groupId,
            label: defaultCompanyGroupObj?.group,
          });

          if (defaultRelationship.Response?.Data) {
            let defaultRelationshipObj = defaultRelationship.Response?.Data.find((relationship) =>
              relationship.Relationship_Name.includes(responseData.Relationship)
            );
            setSelectRelationship({
              value: defaultRelationshipObj?.Relationship_ID,
              label: defaultRelationshipObj?.Relationship_Name,
            });
          }

          setCompanyOptions(options);
          setSelectedSubSegment({
            value: responseData?.SubBussinessSegment,
            label: responseData?.SubBussinessSegment,
          });
          setSelectIndustry(
            industrydropdetails.find(
              (item) => item.label == responseData?.companyDetailSAF?.IndustryType
            )
          );
          setSelectedProductType({
            value: responseData?.Product || "",
            label: responseData?.Product || "",
          });
          setOtherFirewall(
            firewallOpts.find((item) => item.value === String(responseData?.otherinformations?.FireWall))
          );
          setServiceProvider(
            ServiceProviders.find(
              (item) => item.value == String(responseData?.otherinformations?.ExistingServiceProvider)
            )
          );

          const concatenatedAddress = `${responseData?.installationAddressesSAF?.Inst_BuildingNo || ''} ${responseData?.installationAddressesSAF?.Inst_InstallationFloor || ''} ${defaultAreaInst?.AreaName || ''} ${cityAuthOption?.find((item) => item.value == responseData.installationAddressesSAF.Inst_City)?.label || ''} ${stateOpt?.find((item) => item.value == responseData?.installationAddressesSAF?.Inst_State)?.label || ''} India`;
          fetchLatLong(concatenatedAddress);

          const filterOtherSelfpo = selfpoOpts.find(
            (item) => item.value === String(responseData?.otherinformations?.CompanySelfPo)
          )?.label;
          setSelectSelfpo({
            label: filterOtherSelfpo || "",
            value: responseData?.CompanySelf || "",
          });
          setPaymentButton(responseData?.paymentsSAF?.IsPaymentLinkSendToCustomer);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBussinessCAF();
  }, [SafNo, cityAuthOption.length > 0, industrydropdetails]);


  useEffect(() => {
    const fetchGetBank = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;

        const requestData = {
          Action: "getBank",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          cafNo: "",
          oppid: "",
          safNo: SafNo,
          password: sessionStorage.getItem("password"),
          userName: sessionStorage.getItem("userName"),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        // console.log("API Response bank:", result);
        setBankDropDetails(result.Response.Data);
        // console.log("Bank", result.Response);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGetBank();
  }, []);

  // {/* ***********for getCompany datA API ********* */ }
  useEffect(() => {
    const fetchGetCompany = async () => {
      const storedUsername = sessionStorage.getItem("userName");
      // Concatenate 'IN\\' in front of the stored username
      const modifiedUsername = "IN\\" + storedUsername;
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL_1;

        const requestData = {
          Action: "getCompany",
          Authkey: "AdgT6SnjAkeLqlkE4",
          companyId: "",
          password: sessionStorage.getItem("password"),
          userName: modifiedUsername,
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        // console.log("API Response:", result);
        setCustomerdropdetails(result.Response);
        // console.log("companyget", result.Response);
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchGetCompany();
  }, []);


  useEffect(() => {
    const fetchGetProduct = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getProductlist",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          oppid: OppId,
          reason: "",
          siteId: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        // console.log("result.Response:", result.Response.Data);

        if (result.Response && Array.isArray(result.Response.Data)) {
          setProductdropdetails(result.Response.Data);
          // setSelectArea([]);
        } else {
          console.error(
            "product data structure not recognized:",
            result.Response
          );
          setProductdropdetails([]);
        }
        // if (result.Status == "Success") {
        //   const productType = result.Response.Data.map(
        //     (option) => ({
        //       label: option.ProductId,
        //       value: option.ProductCode,
        //     })
        //   );
        //   setProductdropdetails(productType);
        // }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchGetProduct();
  }, []);



  const fetchGetRelation = async (compID) => {
    const storedUsername = sessionStorage.getItem("userName");
    // Concatenate 'IN\\' in front of the stored username
    const modifiedUsername = "IN\\" + storedUsername;
    // console.log("compID", compID);
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_1;

      const requestData = {
        Action: "getRelationship",
        Authkey: "AdgT6SnjAkeLqlkE4",
        CompanyId: compID,
        password: sessionStorage.getItem("password"),
        userName: modifiedUsername,
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      // console.log("API Response Relation:", result);
      setReldropdetails(result.Response);
      // console.log("relationget", result.Response);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    } finally {
      setLoading(false);
    }
  };

  {
    /* *********** END ********* */
  }
  // STATE,CITY,AREA,SOCIETY API
  const fetchData = async () => {
    try {
      // First API request
      const url1 = "https://ffamwapi.spectra.co/index.php";
      const requestData1 = {
        Action: "getSpecState",
        Authkey: "AdgT6SnjAkeLqlkE4",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response1 = await fetch(url1, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData1),
      });

      if (!response1.ok) {
        throw new Error("Network response was not ok for request 1");
      }

      const responseData1 = await response1.json();
      // console.log("responseData1", responseData1);
      setOptionState(responseData1.Response);
      const SelectedApiState = responseData1.Response.find(
        (option) => option.StateCode == apiStateCode
      );
      // console.log("SelectedApiCity", SelectedApiState);
      setSelectState({
        value: SelectedApiState.StateCode,
        label: SelectedApiState.StateName,
      });

      // Second API request
      const url2 = "https://ffamwapi.spectra.co/index.php";
      const requestData2 = {
        Action: "getcity",
        Authkey: "AdgT6SnjAkeLqlkE4",
        stateCode: apiStateCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response2 = await fetch(url2, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData2),
      });

      if (!response2.ok) {
        throw new Error("Network response was not ok for request 2");
      }

      const responseData2 = await response2.json();
      // console.log("responseData2", responseData2.Response.CityCode);
      setOptionCity(responseData2.Response);
      const SelectedApiCity = responseData2.Response.find(
        (option) => option.CityCode == apiCityCode
      );
      // console.log("SelectedApiCity", SelectedApiCity);
      setSelectCity({
        value: SelectedApiCity.CityCode,
        label: SelectedApiCity.CityName,
      });
      // setupdateCityCode(SelectedApiCity.CityCode)

      // console.log("apicitycode", result.Response.Data[0].billingAddressSAF.Bill_City)
      const apicity = responseData2.Response.find(
        (option) => option.CityCode === apiCityCode
      );
      // console.log("apicity", apicity);
      setSelectCity({ value: apicity.CityCode, label: apicity.CityName });

      const apicityName = apicity.CityName;
      // Third API request
      const url3 = "https://ffamwapi.spectra.co/index.php";
      const requestData3 = {
        Action: "getarea",
        Authkey: "AdgT6SnjAkeLqlkE4",
        cityCode: apiCityCode,
        cityName: apicityName,
        restrictedarea: true,
        stateCode: "",
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response3 = await fetch(url3, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData3),
      });

      if (!response3.ok) {
        throw new Error("Network response was not ok for request 3");
      }

      const responseData3 = await response3.json();
      // console.log("responseData3", responseData3.Response);
      setOptionArea(responseData3.Response);
      const SelectedApiArea = responseData3.Response.find(
        (option) => option.AreaCode == apiAreaCode
      );
      // console.log("SelectedApiArea", SelectedApiArea);
      if (SelectedApiArea != apiAreaCode) {
        // toast.warning(responseData3.statusText || "Area is not Mapped", {
        //   position: toast.POSITION.BOTTOM_CENTER,
        //   autoClose: 1500,
        // });
      }
      setSelectArea({
        value: SelectedApiArea.AreaName,
        label: SelectedApiArea.AreaName,
      });
      const apiarea = responseData3.Response.find(
        (option) => option.AreaCode === apiAreaCode
      );
      setSelectArea({ value: apiarea.AreaCode, label: apiarea.AreaName });
      const url4 = "https://ffamwapi.spectra.co/index.php";
      const requestData4 = {
        Action: "getsociety",
        Authkey: "AdgT6SnjAkeLqlkE4",
        areaCode: apiAreaCode,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const response4 = await fetch(url4, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData4),
      });

      if (!response4.ok) {
        throw new Error("Network response was not ok for request 4");
      }

      const responseData4 = await response4.json();
      // console.log("responseData4.Status", responseData4.Status);
      if (responseData4.Status === "Failure" && apiAreaCode !== "") {

      } else {
        setOptionSociety(responseData4.Response);
        const apiSociety = responseData4.Response.find(
          (option) => option.SocietyCode === apiSocietyCode
        );
        // console.log("apiSociety", apiSociety);
        setSelectSociety({
          value: apiSociety.SocietyCode,
          label: apiSociety.SocietyName,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchData();
  }, [apiStateCode, apiCityCode, apiAreaCode]);


  const handleSendPaymentLink = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody =
      {
        Action: "sendPaymentLinkToCustomer",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        userName: sessionStorage.getItem('userName'),
        password: sessionStorage.getItem('password'),
        cafSafNo: SafNo,
        sendPaymentLink: "Yes"
      }
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responsedata = await response.json();
      // console.log("responsedata", responsedata);
      if (responsedata.Response.StatusCode == 200) {
        toast.success(responsedata.Response.Message, {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 1500,
        });
      }

    } catch (error) {
      // Handle fetch error
      console.error("Error fetching data:", error);
    }
  }


  // ================ NK =================
  const [selectedSubSegment, setSelectedSubSegment] = useState("");
  const [selectedCommMode, setSelectedCommMode] = useState("");
  const [businessDays, setBusinessDays] = useState();
  const [montiorDays, setMonitorDays] = useState();
  const [billType, setBillType] = useState("");

  const handleSelectSubSegment = (selected) => {
    // console.log("User selected sub business segment:", selected);
    setSelectedSubSegment(selected);
  };

  const handleSelectCommMode = (selected) => {
    // console.log("User selected mode:", selected);
    setSelectedCommMode(selected);
  };

  const handleSelectBDays = (selected) => {
    // console.log("User selected business days:", selected);
    setBusinessDays(selected);
  };

  const handleMonitor = (selected) => {
    // console.log("User selected network monitoring days:", selected);
    setMonitorDays(selected);
  };

  const handleBillType = (selected) => {
    setBillType(selected);
  };

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectBroadbandCafPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Business SAF</span>
          {/* {!statusNoCaf && (
            <button
              type="download"
              className="btn text-dark  mx-auto cstm-handler"
            >
              <i className="fa-solid fa-download"></i> Download
            </button>
          )} */}
        </div>
      </div>
      {/* ************Header end************ */}

      {loading && (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={load} alt="loading...."></img>
          </div>
        </div>
      )}

      <div className="container-fluid form-container">
        {/* **************Customer Details toggle******************* */}
        <div
          className="contact-toggle"
          onClick={() => handleIconClick("form1")}
        >
          <span className="toggle-text">Customer Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form1" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form1"
          >
            {/* *********Customer Details form******** */}

            <form className="contact-form p-2">
              {SafNo && (<div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="SAF"
                  name="SAF No"
                  value={SafNo}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>

                <label htmlFor="floatingInput" className="lock mt-2">
                  SAF No.
                </label>
              </div>)}

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1 "
                  id="Companyname"
                  name="Companyname"
                  value={userdata.Companyname}
                  readOnly={true}
                  style={{ background: "transparent" }}
                  onChange={formInputData}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock mt-2">
                  Company Name
                </label>
              </div>

              {/* <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="CustomerName"
                  name="ContactPersonName"
                  value={userdata.ContactPersonName}
                  onChange={formInputData}
                  style={{ background: "transparent" }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Customer Name
                </label>
              </div> */}

              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="ServiceId"
                  name="ServiceId"
                  value={userdata.ServiceId || "NA"}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="lock mt-2">
                  Service ID
                </label>
              </div>

              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="networkTechnology"
                  value={
                    customerDetails === "111260000"
                      ? "GPON"
                      : customerDetails === "111260001"
                        ? "NON-GPON"
                        : "NA"
                  }
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Network Technology
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Customer Working Hours*
                </label>
                <Select
                  name="customerWorkingHours"
                  className=" basic-single form-control form-control-sm p-1"
                  placeholder="Select Option"
                  options={custmrworkhrsoptions}
                  value={customerWorkingHours}
                  styles={style}
                  onChange={(selectedOption) =>
                    setCustomerWorkingHours(selectedOption)
                  }
                  aria-label="Floating label select example"
                  isDisabled={disableFileds}
                />
              </div>


              <div className="">
                <label className="select-search-label mt-1">Company*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="sssss"
                  name="Company"
                  isDisabled={true}
                  // value={compOptions.find(
                  //   (option) => option.label === selectedCompany
                  // )}
                  value={selectedCompany}
                  onChange={"handleCompChange"}
                  // options={companyOptions}
                  styles={style}
                  placeholder="Select Company"
                  isSearchable={true} // Add this line if you want to enable searching
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">Group*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="ssss"
                  name="ffff"
                  isDisabled={true}
                  // value={groupOptions.find(
                  //   (option) => option.label === selectGroup
                  // )}
                  value={selectGroup}
                  // onChange={"handleSelectGroup"}
                  options={groupOptions}
                  // styles={compcustomStyles}
                  styles={style}
                  placeholder="Select Group"
                  isSearchable={true} // Add this line if you want to enable searching
                />
              </div>



              {/* {console.log("selectRelationship",selectRelationship)} */}
              {/* <div className="">
                <label className="select-search-label mt-1">
                  Relationship*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Relationship"
                  // options={relationOptions}
                  value={selectRelationship}
                  // value={relationOptions.find((option) => option.label === selectRelationship)}
                  onChange={"handleSelectRelationship"}
                  styles={style}
                  isDisabled={true}
                />

              </div> */}




              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="networkTechnology"
                  value={"Business"}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Business Segement*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Sub Business Segment*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="segment"
                  styles={style}
                  value={selectedSubSegment}
                  onChange={handleSelectSubSegment}
                  options={segments}
                  isDisabled={disableFileds}
                />
              </div>


              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="networkTechnology"
                  name="Product"
                  value="India"
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="networkTechnology" className="lock mt-2">
                  Country
                </label>
              </div>

              {/* <div className="">
                <label className="select-search-label mt-1">
                  Preffered Communication Mode
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="PreferredCommMode"
                  value={selectedCommMode}
                  styles={style}
                  onChange={handleSelectCommMode}
                  options={CommModeOpts}
                  isDisabled={disableFileds}
                />
              </div> */}

              {/* <div
                className="form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="campaignName"
                  name="campaignName"
                  value={userdata.LastMileType}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingSelect" className="lock mt-2">
                  Last mile type
                </label>
              </div> */}

              {/* <div
                className="form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="campaignName"
                  name="Product"
                  value={userdata.Product}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingSelect" className="lock mt-2">
                  Product
                </label>
              </div> */}

              {/* <div className="">
                <label className="select-search-label mt-1">
                  Business Days*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="BusinessDays"
                  value={businessDays}
                  styles={style}
                  onChange={handleSelectBDays}
                  options={BusDaysOpts}
                  isDisabled={disableFileds}
                />
              </div> */}

              {/* <div className="">
                <label className="select-search-label mt-1">
                  Network Monitoring Alerts*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  aria-label="Floating label select example"
                  name="NetworkMonitoringDays"
                  value={montiorDays}
                  styles={style}
                  onChange={handleMonitor}
                  options={MonitorDaysOpts}
                  isDisabled={disableFileds}
                />
              </div> */}
              <div>
              <div
                className="input-box form-floating"
                style={{ position: "relative" }}
              >
                <input
                  id="cameraFileInputCustomer"
                  type="file"
                  accept="image/*"
                  capture="camera"
                  onChange={handleFileChangeCustomer}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="livePicture"
                  value={getCustomerPicture.fileNameWithExtension || getNewCafUpdateRequestBody?.customerImage?.fileNameWithExtension}
                  accept="image/*"
                  capture="camera"
                  style={{ background: "transparent" }}
                  onClick={OpenCameraCustomer}
                  readOnly
                />
                <i
                  className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                  onClick={OpenCameraCustomer}
                ></i>
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  Customer Live Picture*
                </label>
              </div>
              {/* ============ Validate Customer Live Picture ============= */}
              {userName2?.toLowerCase() == "manager1" && getCustomerImageStatus != null && (
                  <div>
                    {(getCustomerImageStatus?.status == "success") ? (
                      <div className="d-flex align-items-center text-sm text-gray-500">
                        <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                          Image validated Successfully
                        </div>
                        <span className="text-success" >
                          <i className="fas fa-check-circle"></i>
                        </span>
                      </div>
                    ) : (
                      <div className="" style={{ opacity: ".70", fontSize: "14px", fontWeight: "300" }}>
                        {/* Guidelines note */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm text-danger" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Note: Please follow the guidelines and try again.
                          </div>
                        </div>
                        {/* White Background Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500 mb-0">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            White Background Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "text-success" : "text-danger"}>
                            <i className={getCustomerImageStatus?.data?.white_background_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>

                        {/* Face Presence & Framing Check */}
                        <div className="d-flex align-items-center text-sm text-gray-500">
                          <div className="form-control-sm" style={{ fontSize: "12px", fontWeight: "400" }}>
                            Face Presence & Framing Check
                          </div>
                          <span className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "text-success" : "text-danger"} >
                            <i className={getCustomerImageStatus?.data?.face_presence_and_framing_check == "Pass" ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="select-search-label text-center">
                <div className="mt-3">OR</div>
              </div>

              <div className="container my-4">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 btn-sm rounded-pill"
                      onClick={SendLinkForCustomerLivePicture}
                      disabled={getCustomerPicture.fileNameWithExtension}
                    >
                      Send Link For Customer Live Picture
                    </button>
                  </div>
                </div>
              </div>

            </form>
          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form11")}
        >
          <span className="toggle-text">Seller Self Identification</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form11" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form11"
          >
            {/* *********Seller Self Identification ******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating mb-3">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="otp"
                  name="otp"
                  maxLength="6"
                  pattern="[0-9]{10}"
                  value={userdata.otp}
                  onChange={handleChange}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const isDigit = /\d/.test(e.key);
                    const sellerOtp = userdata.otp || "";
                    if (
                      isDigit ||
                      allowedKeys.includes(e.key) ||
                      (sellerOtp.length < 6 && e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}

                />
                <label htmlFor="floatingInput" className="mt-2">
                  Self Authentication Code*
                </label>

                {isOtpVerified !== null && (
                  <span
                    className={`position-absolute ${isOtpVerified ? "text-success" : "text-danger"}`}
                    style={{ top: "50%", right: "10px", transform: "translateY(-50%)" }}
                  >
                    <i className={isOtpVerified ? "fas fa-check-circle" : "fas fa-times-circle"}></i>
                  </span>
                )}
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative" }}
              >
                <input
                  id="cameraFileInputSeller"
                  type="file"
                  accept="image/*"
                  capture="camera"
                  onChange={handleFileChangeSeller}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  value={getSellerPicture?.sellerFileNameWithExtension || getNewCafUpdateRequestBody?.sellerImage?.sellerFileNameWithExtension}
                  accept="image/*"
                  capture="camera"
                  style={{ background: "transparent" }}
                  onClick={OpenCameraSeller}
                  readOnly
                  disabled={!isOtpVerified}
                />
                <i
                  className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                  onClick={OpenCameraSeller}
                ></i>
                <label htmlFor="floatingInput" className="paperclip mt-2">
                  Seller Live Picture*
                </label>
              </div>




              <div className="container my-4">
                <div className="row justify-content-center">
                  {/* Send/Resend Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleSendOtp}
                      disabled={isOtpVerified || isTimerActive} // Disable the button during the timer
                    >
                      {isTimerActive ? `Resend Code in ${timer}s` : getCodeFlag ? "Resend Code" : "Send Code"}
                    </button>
                  </div>

                  {/* Submit Code Button */}
                  <div className="col-12 col-md-3 text-center my-2">
                    <button
                      type="button"
                      className="btn btn-dark w-100 rounded-pill"
                      onClick={handleVerifyOtp}
                      disabled={!getCodeFlag || isOtpVerified}
                    >
                      Submit Code
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}



        <div
          className="wcr-toggle mt-3"
          onClick={() => handleIconClick("form12")}
        >
          <span className="toggle-text">KYC Verification</span>
          <span className="float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form12" && (
          <div
            className="container shadow mb-3 bg-body rounded mt-4"
            id="form12"
          >
            <form className="contact-form p-2">

              <div className="">
                <label className="select-search-label mt-1">
                  Select Document Type*
                </label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Salutation"
                  placeholder="Select Document Type"
                  styles={style}
                  value={selectDocument}
                  isSearchable={false}
                  onChange={handleSelectFile}
                  options={optionDocument.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                  isDisabled={SafNo}
                />
              </div>

              <div className="input-box form-floating mt-3" style={{ position: "relative" }}>
                <input
                  id="kycdoc"
                  type="file"
                  accept="image/*,application/pdf"
                  capture="environment"
                  onChange={handleFileChangekycDocOCR}
                  style={{ display: "none" }}
                />
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="picture"
                  name="picture"
                  // value={getNewCafUpdateRequestBody?.customerKYCdocument?.customerKYCfileNameWithExtension}
                  value={selectKycDoc || getNewCafUpdateRequestBody?.customerKYCdocument?.customerKYCfileNameWithExtension}
                  style={{ background: "transparent" }}
                  onClick={() => document.getElementById("kycdoc").click()}
                  readOnly
                  disabled={SafNo}
                />
                {kycDocStatus == "Success" ? <i className="fa-solid fa-check fa-paper-icon fa-locator" style={{ color: "#77c171" }} ></i> :
                  <i
                    className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                    onClick={() => document.getElementById("kycdoc").click()}
                  ></i>
                }

                <label htmlFor="floatingInput" className="paperclip mt-2">
                  KYC Document*
                </label>
              </div>





            </form>
          </div>
        )}


        {/* *********Company Details******** */}

        <div
          className="other-toggle mt-3"
          onClick={() => handleIconClick("CompanyDetails")}
        >
          <span className="toggle-text">Company Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "CompanyDetails" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form3"
          >
            {/* *********Other Information form******** */}
            <form className=" contact-form p-2">

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="Companyname"
                  value={userdata.Companyname || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Company Name
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">
                  Industry Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="IndustryType"
                  name="IndustryType"
                  styles={style}
                  value={selectIndustry}
                  // isDisabled={true}
                  onChange={handleIndustryChnage}
                  options={industrydropdetails.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}

                />
              </div>

              {/* {console.log("selectedProductType", selectedProductType)}
              <div className="">
                <label className="select-search-label mt-1">
                  Product Type*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="firmType"
                  name="firmType"
                  placeholder="Select Product"
                  styles={style}
                  value={selectedProductType}
                  onChange={handleProductTypeChange}
                  options={productdropdetails?.map((data) => ({
                    value: data.ProductCode,
                    label: data.ProductId,
                  }))}
                />
              </div> */}


              {/* {console.log("selectedFirmType", selectedFirmType)} */}



              <div className="">
                <label className="select-search-label mt-1">Firm Type*</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  id="firmType"
                  placeholder="Select Option"
                  name="firmType"
                  styles={style}
                  value={selectedFirmType}
                  onChange={handleFirmTypeChange} // Define the change handler function
                  options={firmTypes.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                // isDisabled = {disableFileds}
                />
              </div>

            </form>
          </div>
        )}


        {/* *********Installation Addresss toggle******** */}

        <div
          className="installation-toggle mt-3"
          onClick={() => handleIconClick("InstallationAddress")}
        >
          <span className="toggle-text">Installation Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "InstallationAddress" && (

          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/* *********Installation Addresss form******** */}
            <form className=" contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="fullName"
                  name="Emailaddress"
                  value={userdata.Emailaddress || ""}
                  onChange={formInputData}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Email ID*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="Mobilephone"
                  value={userdata.Mobilephone || getCafDetails?.installationAddressesSAF?.Inst_MobileNo || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Mobile Phone*
                </label>
              </div>
              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="lastName"
                  name="leadname"
                  value={userdata.leadname || getCafDetails?.installationAddressesSAF?.Inst_LeadName || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Lead Name
                </label>
              </div>
              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={userdata.LeadId || getCafDetails?.installationAddressesSAF?.Inst_LeadId || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Lead Id*
                </label>
              </div>

              <div className="">
                <label className="select-search-label mt-1">Bill Type*</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  id="billType"
                  name="billType"
                  value={billType}
                  onChange={handleBillType}
                  options={billtypeOpts}
                  styles={style}
                  isDisabled={disableFileds}
                />
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select State"
                  className=" form-control input-text form-control-sm mt-1"
                  id="State"
                  name="State"
                  value={userdata.State || selectInstState?.label}
                  readOnly={true}
                  style={{ background: "transparent" }}

                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  State*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select City"
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  // value={installationAddress.Inst_City.find from citydropdetails}
                  // value={
                  //   (
                  //     installcitydrop.find(
                  //       (option) =>
                  //         option.CityCode === installationAddress.Inst_City
                  //     ) || {}
                  //   ).CityName || ""
                  // }
                  value={userdata.City || selectInstCity?.label}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  City*
                </label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select Area"
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  // value={installationAddress.Inst_Area}
                  // value={areadetails}
                  value={userdata.Area || getAreaInst?.AreaName}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Area*
                </label>
              </div>



              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder="Select Building"
                  className=" form-control input-text form-control-sm mt-1"
                  id="BuildingId"
                  name="BuildingId"
                  // value={userdata.BuildingId}
                  value={userdata?.Buildingname || getBuildingBill?.BuildingName}

                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Building Name*
                </label>
              </div>

              {/* <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="firstName"
                  value={userdata.Building_BuildingStatus || getCafDetails?.installationAddressesSAF?.Inst_BuildingStatus || ""}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Building Status*
                </label>
              </div> */}

              {/* <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="BuildingCode"
                  value={userdata.BuildingCode}
                  readOnly={true}
                  style={{ background: "transparent" }}
                />
                <i
                  className="fa-solid fa-lock text-secondary"
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                ></i>
                <label htmlFor="floatingInput" className="leadId mt-2">
                  Building Code*
                </label>
              </div>

              <div
                className="input-box form-floating "
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-2"
                  id="firstName"
                  name="Building Address"
                  value={userdata.BuildingCode}
                  readOnly={true}
                  style={{ background: "transparent" }}
                onChange={handleChange}
                />
                <label htmlFor="floatingInput">Building Address</label>
              </div> */}


              {/* <div className=""> */}
              {/* <label className="select-search-label mt-1">
                  VOIP Port Activation*
                </label>

                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="firstName"
                  styles={style}
                  value={selectVoip}
                  onChange={handleVoipPort}
                  options={voiOpts}
                  isDisabled={disableFileds}
                />
              </div> */}

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="BuildingNo"
                  value={userdata.BuildingNo || ""}
                  onChange={handleChange}
                  style={{ background: "transparent" }}
                />

                {/* <i className="fa-solid fa-lock" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                <label htmlFor="floatingInput">Building No./Plot No.*</label>
              </div>

              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="Floor"
                  // value={buildFloor}
                  value={userdata.Floor || ""}
                  // readOnly={true}
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                {/* <i className="fa-solid fa-lock text-secondary" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                <label htmlFor="floatingInput">Floor*</label>
              </div>
              <div
                className="input-box form-floating"
                style={{ position: "relative", paddingTop: "4px" }}
              >
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="PostalCode"
                  name="InstPin"
                  value={userdata.InstPin || ""}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="[0-9]{10}"
                  // onKeyDown={(e) => {
                  //   const allowedKeys = [
                  //     "Backspace",
                  //     "Delete",
                  //     "ArrowLeft",
                  //     "ArrowRight",
                  //     "Tab",
                  //   ];
                  //   const isDigit = /\d/.test(e.key);
                  //   if (
                  //     (isDigit || allowedKeys.includes(e.key)) &&
                  //     (userdata.PostalCode.length < 6 || e.key === "Backspace")
                  //   ) {
                  //     return true;
                  //   } else {
                  //     e.preventDefault();
                  //   }
                  // }}
                  style={{ background: "transparent" }}
                />

                <label htmlFor="floatingInput">Pin Code*</label>
              </div>
              {/* <div className=""> */}
              {/* <label className="select-search-label mt-1">
                  Category of Customer*
                </label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  placeholder="Select Option"
                  name="customerCategory"
                  styles={style}
                  value={cusCategory}
                  onChange={handleCustomerCategoryChange}
                  options={customercatOpts}
                  isDisabled={disableFileds}
                />
              </div> */}

              {/* <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm"
                                    id="firstName"
                                    name="firstName"
                                    value={installationAddress.ProductSegment}
                                    readOnly
                                //   onChange={handleChange}
                                />
                                <label htmlFor="floatingInput">Product Segment*</label>
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm"
                                    id="firstName"
                                    name="firstName"
                                    value={installationAddress.CpeContactPersonName}
                                    readOnly
                                />
                                <label htmlFor="floatingInput">CPE Contact Person Name*</label>
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm"
                                    id="firstName"
                                    name="firstName"
                                    value={installationAddress.CpeContactPersonPhone}
                                    readOnly
                                />
                                <label htmlFor="floatingInput">CPE Contact Person Phone No.*</label>
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm"
                                    id="firstName"
                                    name="firstName"
                                    value={installationAddress.CpeDispatchAddress}
                                    readOnly
                                />
                                <label htmlFor="floatingInput">CPE Dispatch Address*</label>
                            </div>
                            <div className="input-box form-floating">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm"
                                    id="firstName"
                                    name="firstName"
                                    value={installationAddress.RemarkCPE}
                                    readOnly
                                />
                                <label htmlFor="floatingInput">CPE Remarks*</label>
                            </div> */}
            </form>
          </div>
        )}

        {/* ************* Billing Address ****************** */}

        <div
          className="billing-toggle mt-3"
          onClick={() => handleIconClick("BillingAddress")}
        >
          <span className="toggle-text">Billing Address</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "BillingAddress" && (
          <div className=" container-fluid">
            <div>
              <span>Same as Installation Address</span>
              <span className="" style={{ marginLeft: "40px" }}>
                <input
                  type="checkbox"
                  checked={useSameData}
                  onChange={handleCheckboxChange}
                />
              </span>
            </div>
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form5"
            >
              {/* *********Billing Addresss form******** */}
              <form className="contact-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="contactName"
                    name="contactName"
                    value={userdata.contactName || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Contact Name*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="techSupportEmail"
                    name="techSupportEmail"
                    value={userdata.techSupportEmail || ""}
                    onChange={handleChange}
                    // disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Technical Support Email ID*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billmail"
                    name="billmail"
                    value={userdata.billmail || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Billing Email ID*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billPhone"
                    name="billPhone"
                    value={userdata.billPhone || ""}
                    onChange={handleChange}
                    disabled={disableFileds}
                    maxLength="10"
                    pattern="[0-9]{10}"
                    // onKeyDown={(e) => {
                    //   const allowedKeys = [
                    //     "Backspace",
                    //     "Delete",
                    //     "ArrowLeft",
                    //     "ArrowRight",
                    //     "Tab",
                    //   ];
                    //   const isDigit = /\d/.test(e.key);
                    //   if (
                    //     (isDigit || allowedKeys.includes(e.key)) &&
                    //     (userdata.billPhone.length < 10 || e.key === "Backspace")
                    //   ) {
                    //     return true;
                    //   } else {
                    //     e.preventDefault();
                    //   }
                    // }}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Phone No.*
                  </label>
                </div>

                <div
                  className="input-box form-floating "
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="BillNationality"
                    name="BillNationality"
                    value={userdata.BillNationality || "Indian"}
                    onChange={handleChange}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Nationality
                  </label>
                </div>



                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select State"
                    className=" form-control input-text form-control-sm mt-1"
                    id="State"
                    name="billedState"
                    value={userdata.billedState || selectBillState?.label}
                    readOnly={true}
                    style={{ background: "transparent" }}

                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    State*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select City"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billCity"
                    name="billCity"
                    value={userdata.billCity || selectBillCity?.label}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    City*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select Area"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billArea"
                    name="billArea"
                    value={userdata.billArea || getAreaBill?.AreaName}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    Area*
                  </label>
                </div>

                <div
                  className="input-box form-floating "
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder="Select Building"
                    className=" form-control input-text form-control-sm mt-1"
                    id="billBuildingId"
                    name="billBuildingId"
                    // value={userdata.billBuildingId || getCafDetails?.billingAddress?.Bill_BuildingName}
                    value={userdata?.BillBuildingname || getBuildingInst?.BuildingName}

                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    Building Name*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billBuildingNo"
                    name="billBuildingNo"
                    value={userdata.billBuildingNo || ""}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />

                  {/* <i className="fa-solid fa-lock" style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}></i> */}
                  <label htmlFor="floatingInput">Building No./Plot No.*</label>
                </div>

                {/* <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    placeholder="select State"
                    id=""
                    name=""
                    value={userdata.billedState}
                    styles={style}
                    onChange={handleChange}
                    options={""}
                    isDisabled={disableFileds}
                  />
                </div> */}


                {/* prev */}
                {/* <div className="input-box form-floating">
                                   
                                    <Select
                                        className="form-select form-control input-text form-control-sm"
                                        id=""
                                        name=""
                                        value={billedcity ? billedcity : 'Select City'}
                                        styles={customStyles}
                                        onChange={handleCityChangeBill}
                                        options={billingCityDrop?.map((city) => ({
                                            label: city.CityName,
                                            value: city.CityCode,
                                        }))}
                                        isDisabled={!billingCityDrop}
                                    />
                                     
                                    <label htmlFor="floatingInput">City*</label>
                                </div> */}

                {/* prev */}
                {/* <div className="input-box form-floating">
                                    <Select
                                        className="form-select form-control input-text form-control-sm"
                                        id=""
                                        name=""
                                        value={billedarea ? billedarea : 'Select Area'}
                                        styles={customStyles}
                                        onChange={HandleAreaChangeBill}
                                        options={billingAreaDrop && billingAreaDrop?.map((area) => ({
                                            label: area.AreaName,
                                            value: area.AreaCode,
                                        }))}
                                        isDisabled={!billingAreaDrop}
                                    />
                                    <label htmlFor="floatingInput">Area*</label>
                                </div> */}

                {/* prev */}
                {/* <div className="input-box form-floating">
                                    <Select
                                        className="form-select form-control input-text form-control-sm"
                                        id=""
                                        name=""
                                        value={billedbuilding ? billedbuilding : 'Select Building'}
                                        styles={customStyles}
                                        onChange={handleBuildingChange}
                                        options={billingBuildingDrop && billingBuildingDrop.map((building) => ({
                                            label: building.BuildingName,
                                            value: building.BuildingCode,
                                        }))}
                                        isDisabled={!billingBuildingDrop}
                                    />
                                    <label htmlFor="floatingInput">Building/Society*</label>
                                </div> */}

                {/* <div className="">
                  <label className="select-search-label mt-1">
                    Building/Society*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    placeholder="Select Building"
                    id=""
                    name=""
                    value={billedbuilding ? billedbuilding : "Select Building"}
                    styles={style}
                  onChange={handleBuildingChange}
                  options={
                    billingBuildingDrop &&
                    billingBuildingDrop.map((building) => ({
                      label: building.BuildingName,
                      value: building.BuildingCode,
                    }))
                  }
                  isDisabled={!billingBuildingDrop || disableFileds}
                
                  />
                </div> */}

                {/* <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="firstName"
                    value={buildNo1}
                    disabled={disableFileds}
                    onChange={handleBillBuildNO}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Building No./Plot No.*
                  </label>
                </div> */}

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="billFloor"
                    name="billFloor"
                    value={userdata.billFloor || ""}
                    disabled={disableFileds}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Floor*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="billPin"
                    value={userdata.billPin || ""}
                    disabled={disableFileds}
                    onChange={handleChange}
                    style={{ background: "transparent" }}
                    maxLength="6"
                    pattern="[0-9]{10}"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      // if (
                      //   (isDigit || allowedKeys.includes(e.key)) &&
                      //   (buildPin1.length < 6 || e.key === "Backspace")
                      // ) {
                      //   return true;
                      // } else {
                      //   e.preventDefault();
                      // }
                    }}
                  />

                  <label htmlFor="floatingInput" className="mt-2">
                    Pin Code*
                  </label>
                </div>
              </form>
            </div>
          </div>

        )}


        {/* *********Authorised Signatory  toggle******** */}

        <div
          className="authSign-toggle mt-3"
          onClick={() => handleIconClick("AuthorisedSignatoryDetails")}
        >
          <span className="toggle-text">Authorised Signatory Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "AuthorisedSignatoryDetails" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form6"
          >
            {/* *********Authorised Signatory form******** */}
            <form className="contact-form p-2">
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authorName"
                  name="authorName"
                  value={userdata.authorName || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Name*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authorFather"
                  name="authorFather"
                  value={userdata.authorFather || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Father's/Husband's Name*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="authResidentialAddress"
                  name="authResidentialAddress"
                  value={userdata.authResidentialAddress || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Residential Address*
                </label>
              </div>
              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="autherMobile"
                  value={userdata.autherMobile || ""}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="[0-9]{10}"
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Delete",
                      "ArrowLeft",
                      "ArrowRight",
                      "Tab",
                    ];
                    const mobileNumber = userdata.autherMobile || "";
                    const isDigit = /\d/.test(e.key);
                    if (
                      (isDigit || allowedKeys.includes(e.key)) &&
                      (mobileNumber.length < 10 || e.key === "Backspace")
                    ) {
                      return true;
                    } else {
                      e.preventDefault();
                    }
                  }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Mobile No*
                </label>
              </div>

              <div className="input-box form-floating">
                <input
                  type="mail"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="autherEmail"
                  value={userdata.autherEmail || ""}
                  onChange={handleChange}
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Email ID*
                </label>
              </div>


              <div className="">
                <label className="select-search-label mt-1">Country</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select Country"
                  styles={style}
                  isSearchable={false}
                  value={selectAuthCountry || "Indian"}
                  onChange={handleSelectAuthCountry}
                  options={optionCountry.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">State</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="IndustrySeg"
                  placeholder="Select State"
                  isSearchable={false}
                  styles={style}
                  value={selectAuthState}
                  onChange={handleSelectAuthState}
                  options={optionAuthState.map((data) => ({
                    value: data.code,
                    label: data.name,
                  }))}
                />
              </div>

              <div className="">
                <label className="select-search-label mt-1">City</label>
                <Select
                  className="basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="City"
                  placeholder="Select City"
                  isSearchable
                  styles={style}
                  value={selectAuthCity}
                  onChange={handleSelectAuthCity}
                  options={cityAuthOption.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>



              <div className="">
                <label className="select-search-label mt-1">Nationality</label>
                <Select
                  className=" basic-single form-control form-control-sm p-1"
                  classNamePrefix="select"
                  name="Natinality"
                  placeholder="Select Natinality"
                  styles={style}
                  isSearchable={false}
                  value={selectAuthNatinality}
                  onChange={handleSelectAuthNatinality}
                  options={optionNatinality.map((data) => ({
                    value: data.value,
                    label: data.label,
                  }))}
                />
              </div>



              <div className="input-box form-floating">
                <input
                  type="tel"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="autherPinCode"
                  name="autherPinCode"
                  value={userdata.autherPinCode || ""}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="[0-9]{10}"
                  disabled={disableFileds}
                  style={{ background: "transparent" }}
                // onKeyDown={(e) => {
                //   const allowedKeys = [
                //     "Backspace",
                //     "Delete",
                //     "ArrowLeft",
                //     "ArrowRight",
                //     "Tab",
                //   ];
                //   const pinCode = userdata.autherPinCode || "";
                //   const isDigit = /\d/.test(e.key);
                //   if (
                //     (isDigit || allowedKeys.includes(e.key)) &&
                //     (pinCode.length < 6 || e.key === "Backspace")
                //   ) {
                //     return true;
                //   } else {
                //     e.preventDefault();
                //   }
                // }}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Pincode*
                </label>
              </div>
            </form>
          </div>
        )}



        {/* *********Other Information toggle******** */}


        {!SafNo &&
          <>
            <div
              className="other-toggle mt-3"
              onClick={() => handleIconClick("form2")}
            >
              <span className="toggle-text">Other Information</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>

            {activeForm === "form2" && (
              <div
                className=" container shadow mb-3 bg-body rounded mt-4"
                id="form2"
              >
                {/* *********Other Information form******** */}
                <form className=" contact-form p-2">
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="fullName"
                      name="UpTimesla"
                      value={userdata.UpTimesla}
                      onChange={handleChange}
                      style={{ background: "transparent" }}
                      disabled={disableFileds}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Uptime SLA Commited (%)*
                    </label>
                  </div>
                  <div className="input-box form-floating">
                    <input
                      type="date"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="PoLock"
                      name="PoLock"
                      value={yyyymmddFormat(userdata.PoLock)}
                      // min={getCurrentDate()}
                      onChange={handleChange}
                      disabled={disableFileds}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      PO Lock in Duration*
                    </label>
                  </div>


                  <div className="input-box form-floating">
                    <input
                      type="date"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="PoNext"
                      name="PoNext"
                      value={yyyymmddFormat(userdata.PoNext)}
                      onChange={handleChange}
                      disabled={disableFileds}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      PO Next Renewal Date*
                    </label>
                  </div>
                  <div className="">
                    <label htmlFor="floatingSelect" className="select-search-label mt-1">
                      Existing Service Provider*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="existingServiceProvider"
                      name="existingServiceProvider"
                      styles={style}
                      value={serviceProvider}
                      onChange={handleServiceProviderChange}
                      options={ServiceProviders}
                    // isDisabled={disableFileds}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Firewall (if Any)*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      name="firewall"
                      styles={style}
                      value={otherFirewall}
                      onChange={handleFirewall}
                      options={firewallOpts}
                    // isDisabled={disableFileds}
                    />
                  </div>

                  {otherFirewall && otherFirewall.value === "1" && (
                    <div className="input-box form-floating">
                      <input
                        type="date"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="FirewallSetToExpire"
                        name="FirewallSetToExpire"
                        value={yyyymmddFormat(userdata.FirewallSetToExpire)}
                        onChange={handleChange}
                        disabled={disableFileds}
                        style={{ background: 'transparent' }}


                      />
                      <label htmlFor="paymentDate" className="mt-2">
                        Firewall AMC Expiry Date
                      </label>
                    </div>
                  )}

                  <div className="">
                    <label className="select-search-label mt-1">
                      Company Self PO (ERP)*
                    </label>
                    <Select
                      className="basic-single form-control form-control-sm "
                      classNamePrefix="select"
                      id="floatingSelect"
                      placeholder="Select Option"
                      aria-label="Floating label select example"
                      name="selfpo"
                      value={selectSelfpo}
                      onChange={handleSelfPo}
                      styles={style}
                      options={selfpoOpts}
                      isDisabled={disableFileds}
                    />
                  </div>
                </form>
              </div>
            )}

          </>
        }



        {/* *********Payment Details  toggle******** */}

        <div
          className="paymentdetails-toggle mt-3"
          onClick={() => handleIconClick("form4")}
        >
          <span className="toggle-text">Payment Details</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>
        {activeForm === "form4" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form4"
          >
            {/* *********Payment Details  Form******** */}
            <form className="contact-form p-2">

              <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedRCAmount"
                  value={(SafNo ? getCafDetails?.paymentsSAF?.ApprovedRCAmountIncTax : userdata.ApprovedRCAmount) || "NA"}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved RC Amount(Inc Tax)
                </label>
              </div>

              {/* {console.log("getCafDigiHome?.paymentDetail?.ApprovedRCAmount", getCafDigiHome?.paymentDetail?.ApprovedRCAmount)} */}

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqRCAmount"
                  value={userdata.UpfrontReqRCAmount || (SafNo ? getCafDetails.paymentsSAF?.UpfrontRequestedRCAmountIncTax : "")}
                  onChange={handleChange}
                  // disabled={CafId}
                  disabled={getCafDetails?.paymentsSAF?.IsPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput" className="mt-2 upfont-textStyle">
                  Upfront Requested RC Amount(Inc Tax)
                </label>
              </div>

              {/* {console.log("userdata.UpfrontReqRCAmount", userdata.UpfrontReqRCAmount)} */}



              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedRCAmount"
                  value={SafNo ? getCafDetails?.paymentsSAF?.UpfrontApprovedRCAmount : ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved RC Amount(Inc Tax)
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedOTCAmount"
                  value={(SafNo ? getCafDetails?.paymentsSAF?.ApprovedOTCAmountIncTax : userdata.ApprovedOTCAmount) || ""}
                  // onChange={handleOTCChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Approved OTC Amount(Inc Tax)
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqOTCAmount"
                  value={userdata.UpfrontReqOTCAmount || getCafDetails?.paymentsSAF?.UpfrontRequestedOTCAmountIncTax || ""}
                  onChange={handleChange}
                  disabled={getCafDetails?.paymentsSAF?.IsPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Requested OTC Amount(Inc Tax)
                </label>
              </div>


              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={SafNo ? getCafDetails?.paymentsSAF?.UpfrontApprovedOTCAmount : ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2 upfont-textStyle">
                  Upfront Approved OTC Amount(Inc Tax)
                </label>
              </div>

              {SafNo &&
                <>
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="lastName"
                      name="lastName"
                      value={(SafNo ? getCafDetails.paymentsSAF?.TotalAmount : userdata.totalAmount) || ""}
                      onChange={handleTotalAmt}
                      disabled={true}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Total Amount*
                    </label>
                  </div>

                  {/* <div
                    className="input-box form-floating"
                    style={{ position: "relative", paddingTop: "4px" }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="fullName"
                      name="fullName"
                      value={paymentDetails.PaymentId || getCafDetails?.payments.PaymentId}
                      readOnly={true}
                      style={{ background: "transparent" }}
                    />
                    <i
                      className="fa-solid fa-lock text-secondary"
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                    <label htmlFor="floatingInput" className="lock">
                      Payment ID
                    </label>
                  </div> */}

                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Mode*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="Salutation"
                      placeholder="Select Option"
                      styles={style}
                      value={selectPaymentMode}
                      isSearchable={false}
                      onChange={handlePaymentMode}
                      options={optionPayment.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    // isDisabled={paymentLinkSentToCustomer=="Yes"}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">Pay-In-Slip*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="payslip"
                      name="payslipnethod"
                      styles={style}
                      value={filteredPayslipOpts.find(
                        (option) => option.value == (selectedPaySlipOption || getCafDetails?.paymentsSAF.PaymentSlip)
                      )}
                      onChange={handlePaySlipChange}
                      options={filteredPayslipOpts}
                      isDisabled={disableFileds}
                    />
                  </div>

                  {/* {console.log("selectedPaySlipOption",selectedPaySlipOption)} */}

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.paymentDoaStatus || getCafDetails.paymentDOAstatus || "NA"}
                      // onChange={handleGstNumber}
                      disabled={disableFileds}
                      maxLength="15"
                      readOnly
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Upfront Approval Status</label>
                  </div>

                  {/* <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={Securitydep || getCafDetails?.payments.SecurityDeposit}
                      onChange={handleSecurityDepo}
                      disabled={disableFileds}
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Security Deposit*
                    </label>
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">
                      Security Deposit Type*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      placeholder="Select Option"
                      id="securityType"
                      name="securityType"
                      styles={style}
                      value={SecuritypeOpts.find(
                        (option) => option.value === (Securitydeptype || getCafDetails?.payments.SecurityDepositType)
                      )}
                      onChange={handleSecType}
                      options={SecuritypeOpts}
                      isDisabled={disableFileds}
                    />
                  </div> */}

                  {/* new Paydetail nk */}
                  {/* {selectedPaySlipOption === "4" || selectedPaySlipOption === "5" || selectedPaySlipOption === "7" || selectedPaySlipOption === "8" || selectedPaySlipOption === "11" || selectedPaySlipOption === "12" || selectedPaySlipOption === "13" ? (
                  <div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="transactionReferenceID"
                        name="transactionReferenceID"
                        value={transactionrefid || getCafDetails?.payments.TransactionReferenceId}
                        onChange={handleTransactionRefID}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="transactionReferenceID" className="mt-2">
                        Transaction Reference ID*
                      </label>
                    </div>


                    <div className="input-box form-floating">
                      <input
                        // type="date"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={getCafDetails?.payments.PaymentDate}
                        // onChange={handleCardPaymentDate}
                        // min={getCurrentDate()}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="paymentDate" className="mt-2">
                        Payment Date*
                      </label>
                    </div>
                  </div>) : (
                  <div>
                    <div className="">
                      <select
                        className="form-select form-control input-text form-control-sm"
                        id="firstName"
                        name="firstName"
                        value={selectBank}
                        onChange={handleBankChange}
                      >
                        <option value="">Select Bank</option>

                        {BankDropDetails.map((bank, index) => (
                          <option key={index} value={bank.Bankname}>
                            {bank.Bankname}
                          </option>
                        ))
                        }

                      </select>
                      <label className="select-search-label mt-1">
                        Bank Name*
                      </label>
                      <Select
                        className="basic-single form-control form-control-sm p-1"
                        classNamePrefix="select"
                        id="firstName"
                        name="firstName"
                        placeholder="Select Bank Name"
                        styles={style}
                        value={bankOpts.find((option) => option.label === selectBank?.label)}
                        onChange={handleBankChange}
                        options={bankOpts}
                        isDisabled={disableFileds}
                      />
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={branchName}
                        onChange={handleBranchChange}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Branch*
                      </label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={chequeDDNo}
                        onChange={handleChequeNo}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Cheque/DD no.*
                      </label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="date"
                        placeholder=""
                        className=" form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={chequeDate}
                        onChange={handleChequeDate}
                        disabled={disableFileds}
                        // min={getCurrentDate()}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Cheque/DD Date.*
                      </label>
                    </div>
                  </div>
                )} */}

                  {/* {console.log(selectedPaySlipOption)} */}
                  {/* new Paydetail nk end*/}
                  {selectedPaySlipOption === "4" || selectedPaySlipOption === "5" || selectedPaySlipOption === "7" ||
                    selectedPaySlipOption === "8" || selectedPaySlipOption === "11" || selectedPaySlipOption === "12" ||
                    selectedPaySlipOption === "13" ? (
                    /* Render NEFT or RTGS section */
                    <div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid || getCafDetails?.paymentsSAF.TransactionReferenceId || ""}
                          onChange={handleTransactionRefID}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>


                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name="paymentDate"
                          value={userdata.paymentDate || yyyymmddFormat(getCafDetails?.paymentsSAF.PaymentDate)}
                          onChange={handleChange}
                          // min={getCurrentDate()}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate" className="mt-2">
                          Payment Date*
                        </label>
                      </div>
                    </div>
                  ) : selectedPaySlipOption === "7" || selectedPaySlipOption === "8" ? (
                    /* Render Credit Card, Debit Card, Ezetap section */
                    <div>

                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm"
                          id=""
                          name=""
                          // value={selectedDatePayment}
                          // onChange={handleCardPaymentDate}
                          // min={getCurrentDate()}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="paymentDate">Payment Date*</label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="approvalCode"
                          name="approvalCode"
                          value={approvalCode}
                          onChange={handleApprovalCode}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="approvalCode" className="mt-2">
                          Approval Code*
                        </label>
                      </div>
                      {selectedPaySlipOption === "7" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            value={creditDetails}
                            onChange={handleCreditdetails}
                            disabled={disableFileds}
                            style={{ background: "transparent" }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Credit Card Last 4 Digit No.*
                          </label>
                        </div>
                      )}
                      {selectedPaySlipOption === "8" && (
                        <div className="input-box form-floating">
                          <input
                            type="text"
                            placeholder=""
                            className="form-control input-text form-control-sm mt-1"
                            id="creditCardLast4Digits"
                            name="creditCardLast4Digits"
                            // value={debitDetails}
                            // onChange={handleDebditdetails}
                            disabled={disableFileds}
                            style={{ background: "transparent" }}
                          />
                          <label htmlFor="creditCardLast4Digits" className="mt-2">
                            Debit Card Last 4 Digit No.*
                          </label>
                        </div>
                      )}
                    </div>
                  ) : selectedPaySlipOption === "1" || selectedPaySlipOption === "2" || selectedPaySlipOption === "12" ? (
                    /* Render Cheque, DD, Ezetap Cheque section */
                    <div>
                      {/* <div className="">
                        <select
                          className="form-select form-control input-text form-control-sm"
                          id="firstName"
                          name="firstName"
                          value={selectBank}
                          onChange={handleBankChange}
                        >
                          <option value="">Select Bank</option>

                          {BankDropDetails.map((bank, index) => (
                            <option key={index} value={bank.Bankname}>
                              {bank.Bankname}
                            </option>
                          ))
                          }

                        </select>
                        <label className="select-search-label mt-1">
                          Bank Name*
                        </label>
                        <Select
                          className="basic-single form-control form-control-sm p-1"
                          classNamePrefix="select"
                          id="firstName"
                          name="firstName"
                          placeholder="Select Bank Name"
                          styles={style}
                          value={bankOpts.find((option) => option.label === selectBank?.label)}
                          onChange={handleBankChange}
                          options={bankOpts}
                          isDisabled={disableFileds}
                        />
                      </div> */}

                      <div>
                        <div className="">
                          <label className="select-search-label mt-1">
                            Bank Name*
                          </label>
                          <Select
                            className=" basic-single form-control form-control-sm p-1"
                            classNamePrefix="select"
                            id="firstName"
                            name="BankName"
                            placeholder="Select Bank Name"
                            styles={style}
                            value={bankOpts.find(
                              (option) => option.value == (selectBank?.value || (bankOpts.find((option) => option?.label == getCafDetails?.paymentsSAF?.BankName))?.value)
                            )} // Set the value based on your state
                            onChange={handleBankChange} // Define the change handler function
                            options={bankOpts}
                            isDisabled={disableFileds}
                          />
                        </div>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id=""
                          name=""
                          value={branchName || getCafDetails?.paymentsSAF?.Branch || ""}
                          onChange={handleBranchChange}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Branch*
                        </label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="chequeDDNo"
                          value={chequeDDNo || getCafDetails?.paymentsSAF?.ChequeDDNo || ""}
                          onChange={handleChequeNo}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Cheque/DD no.*
                        </label>
                      </div>
                      <div className="input-box form-floating">
                        <input
                          type="date"
                          placeholder=""
                          className=" form-control input-text form-control-sm mt-1"
                          id="firstName"
                          name="firstName"
                          value={chequeDate || yyyymmddFormat(getCafDetails?.paymentsSAF?.ChequeDDDate) || ""}
                          onChange={handleChequeDate}
                          disabled={disableFileds}
                          // min={getCurrentDate()}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Cheque/DD Date.*
                        </label>
                      </div>
                    </div>
                  ) : null}



                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Status*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="firstName"
                      name="firstName"
                      placeholder="Select Payment Status"
                      // value={PaymentOpts.find(
                      //   (option) => option.value === (paymentStatus || getCafDigiHome?.paymentDetail?.PaymentStatus || "NA")
                      // )}
                      value={paymentStatus}
                      styles={style}
                      onChange={handlePaymentStatus}
                      options={PaymentOpts.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                      isDisabled={true}
                    />
                  </div>


                </>}

              {/* {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="RCAmount"
                    value={userdata.RCAmount || getCafDigiHome?.paymentDetail?.RCAmount || "NA"}
                    onChange={handleChange}
                    disabled={disableFileds}

                    pattern="[0-9]{10}"
                    style={{ background: "transparent" }}
                    maxLength="10"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (RCAmount.length < 10 || allowedKeys.includes(e.key))
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    RC Amount*
                  </label>
                </div> } */}



              <>

                {/* {selectedPaySlipOption === "5" ||
                  selectedPaySlipOption === "4" ? (
                  <div>
                    <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="transactionReferenceID"
                          name="transactionReferenceID"
                          value={transactionrefid}
                          onChange={handleTransactionRefID}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="transactionReferenceID" className="mt-2">
                          Transaction Reference ID*
                        </label>
                      </div>

                    <div className="input-box form-floating">
                      <input
                        type="date"
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        value={selectedDate}
                        placeholder="Select Date"
                        onChange={handleDateChange}
                        // min={getCurrentDate()}
                        style={{ background: "transparent" }}
                        disabled={paymentLinkSentToCustomer == "Yes"}

                      />
                      <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                    </div>
                  </div>
                ) : selectedPaySlipOption === "7" ||
                  selectedPaySlipOption === "8" ||
                  selectedPaySlipOption === "11" ? (
                  <div>
                    <div className="input-box form-floating">
                      <input
                        type="date"
                        className=" form-control input-text form-control-sm mt-1"
                        id=""
                        name=""
                        placeholder="Select Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                        min={getCurrentDate()}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="paymentDate" className="mt-2">Payment Date*</label>
                    </div>
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="transactionReferenceID"
                        name="transactionReferenceID"
                        value={transactionrefid}
                        onChange={handleTransactionRefID}
                        disabled={disableFileds}
                        style={{ background: "transparent" }}
                      />
                      <label htmlFor="transactionReferenceID" className="mt-2">
                        Transaction Reference ID*
                      </label>
                    </div>
                    {selectedPaySlipOption !== "11" && (
                      <div className="input-box form-floating">
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="approvalCode"
                          name="approvalCode"
                          value={approvalCode}
                          onChange={handleApprovalCode}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}
                        />
                        <label htmlFor="approvalCode" className="mt-2">Approval Code*</label>
                      </div>
                    )}
                    {selectedPaySlipOption !== "11" && (
                      <div className="input-box form-floating">
                        <input
                          type="tel"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="creditCardLast4Digits"
                          name="creditCardLast4Digits"
                          value={creditDetails}
                          onChange={handleCreditdetails}
                          disabled={disableFileds}
                          style={{ background: "transparent" }}

                          pattern="[0-9]{10}"
                          maxLength="4"
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "ArrowLeft",
                              "ArrowRight",
                              "Tab",
                            ];
                            const isDigit = /\d/.test(e.key);
                            if (
                              (isDigit || allowedKeys.includes(e.key)) &&
                              (creditDetails.length < 4 ||
                                allowedKeys.includes(e.key))
                            ) {
                              return true;
                            } else {
                              e.preventDefault();
                            }
                          }}
                        />
                        <label htmlFor="creditCardLast4Digits" className="mt-2">
                          Card Last 4 Digit No*
                        </label>
                      </div>
                    )}
                  </div>
                ) : null} */}



                {/* <div className="">
                    <label className="select-search-label mt-1">GST*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      name="dnc"
                      styles={style}
                      placeholder="Select Option"
                      value={GstOpts.find((option) => option.value === isGst)}
                      onChange={(selectedOption) =>
                        handleIsGst(selectedOption.value)
                      }
                      options={GstOpts}
                      isDisabled={disableFileds}
                    />
                  </div> */}

                {/* Render GSTnumBER IF not no  */}
                {/* {isGst === "569480000" && (
                    <div className="input-box form-floating">
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="firstName"
                        name="firstName"
                        value={GstNumber}
                        onChange={handleGstNumber}
                        disabled={disableFileds}
                        maxLength="15"
                      />
                      <label htmlFor="floatingInput" className="mt-2">GST Number*</label>
                    </div>
                  )} */}

              </>


              {/* {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="tel"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="OTCAmount"
                    value={userdata.OTCAmount || getCafDigiHome?.paymentDetail?.OTCAmount || "NA"}
                    onChange={handleOTCChange}
                    disabled={disableFileds}

                    pattern="[0-9]{10}"
                    style={{ background: "transparent" }}
                    maxLength="10"
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (otc.length < 10 || allowedKeys.includes(e.key))
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    OTC Amount*
                  </label>
                </div>} */}





              {/* 
              {!CafId &&
                <div className="input-box form-floating ">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="firstName"
                    name="SDAmount"
                    value={userdata.SDAmount || getCafDigiHome?.paymentDetail?.SDAmount || "NA"}
                    onChange={handleChange}
                    disabled={disableFileds}
                    style={{ background: "transparent" }}
                  />
                  <label htmlFor="floatingInput cstm-otc" className="mt-2">
                    SD Amount*
                  </label>
                </div>} */}

              {/* <div className="input-box form-floating ">
                <input
                  type="tel"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="ApprovedSDAmount"
                  value={userdata.ApprovedSDAmount || getCafDigiHome?.paymentDetail?.ApprovedSDAmount || ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Approved SD Amount
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontReqSDAmount"
                  value={userdata.UpfrontReqSDAmount || getCafDigiHome?.paymentDetail?.UpfrontApprovedRCAmount || ""}
                  onChange={handleChange}
                  disabled={isPaymentLinkSendToCustomer == "Yes"}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Requested SD Amount
                </label>
              </div>

              <div className="input-box form-floating ">
                <input
                  type="text"
                  placeholder=""
                  className="form-control input-text form-control-sm mt-1"
                  id="firstName"
                  name="UpfrontApprovedOTCAmount"
                  value={userdata.UpfrontApprovedSDAmount || getCafDigiHome?.paymentDetail?.UpfrontApprovedSDAmount || ""}
                  onChange={handleChange}
                  disabled={true}
                  style={{ background: "transparent" }}
                />
                <label htmlFor="floatingInput cstm-otc" className="mt-2">
                  Upfront Approved SD Amount
                </label>
              </div> */}




              {SafNo &&
                <>
                  <div className="input-box form-floating ">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="IsPaymentLinkSendToCustomer"
                      value={getCafDetails?.paymentsSAF?.IsPaymentLinkSendToCustomer || ""}
                      onChange={handleChange}
                      disabled
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput cstm-otc" className="mt-2">
                      Is Payment LinkSend To Customer
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control input-text form-control-sm mt-1"
                      id="firstName"
                      name="firstName"
                      value={userdata.dDupStatus || getCafDetails.DedupeDOAstatus}
                      // onChange={handleGstNumber}
                      disabled={true}
                      maxLength="15"
                      readOnly
                      style={{ background: "transparent" }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">De-dupe Status </label>
                  </div>
                </>}


              {/* {console.log("paymentButton", paymentButton)} */}


              {paymentButton == "Yes" && paymentStatus?.label !== "Payment Received" && (
                <div className=" text-center mt-5 mb-3">
                  <button
                    type="button"
                    className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                    onClick={handleSendPaymentLink}
                  >
                    Send payment link
                  </button>
                </div>
              )}

            </form>
          </div>
        )}

        {/* *********Document  toggle******** */}

        {SafNo && (
          <div
            className="doc-toggle mt-3"
            hidden={docHide}
            onClick={manageDocClick}
          >
            <span className="toggle-text">Order Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        )}

        {/* *********WCR Details  toggle******** */}

        {/* {!wcrFlag && ( */}


        {/* *********Np Details  toggle******** */}

        {/* {!npFlag && ( */}


        {/* *********IR Details  toggle******** */}

        {/* {!irFlag && ( */}


        <div
          className="np-toggle mt-3"
          onClick={() => handleIconClick("form20")}
        >
          <span className="toggle-text">Work Order</span>
          <span className=" float-end">
            <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
          </span>
        </div>

        {activeForm === "form20" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form20"
          >
            {/* *********Work Order form******** */}
            {!workOrderHide && (
              <form className="contact-form p-2">
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.SiteId}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Site Id{" "}
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.SiteType}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Site Type :
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.WorkOrderID}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Work Order ID:
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.Owner}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Owner:
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.Owner}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Owner :
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.OrderStatus}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Order Status :
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.StateserviceActivation}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Order Accepted :
                  </label>
                </div>
                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="fullName"
                    name="fullName"
                    value={workOrderDetails.AcceptedByCustomerDate}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "60%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="lock">
                    Accepted By Customer Date :
                  </label>
                </div>
              </form>
            )}
          </div>
        )}


        {/* *********Document Details  toggle******** */}

        {/* {CafId && (
          <div
            className="doc-toggle mt-3"
            hidden={docHide}
            onClick={manageDocClick}
          >
            <span className="toggle-text">Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>
        )} */}

        {/* *********POA/POI Details  toggle******** */}



        {/* *********OTP  Form******** */}
        {/* {otpAuthStatus === "false" && (
            <div
              className="check-toggle mt-3"
              onClick={() => handleIconClick("form8")}
            >
              <span className="toggle-text">OTP</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div>
          )} */}

        {activeForm === "form8" && otpAuthStatus === "false" && (
          <div
            className=" container shadow mb-3 bg-body rounded mt-4"
            id="form8"
          ></div>
        )}

        {otpAuthStatus === "false" && (
          <div className="text-center mb-3 mt-3">
            {/* {!showOtpPage ? (
              <button
                type="submit"
                className="btn text-light  bg-dark mx-auto rounded-pill submit-btn "
                onClick={handleVerifyOtpClick}
              >
                Verify OTP
              </button>
            ) : (
              renderOtpVerificationForm()
            )} */}
          </div>
        )}

        <div className=" " style={{ marginTop: "50px", marginBottom: "40px" }}>
          {SafNo && (
            <div className="text-center">
              <button
                type="update"
                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                onClick={handleUpdate}

              >
                Update
              </button>
            </div>
          )}

          {kycDocStatus == "Success" && !SafNo && (
            <div className="text-center">
              <button
                type="button"
                className="btn text-light bg-dark mx-auto submit-btn rounded-pill"
                onClick={handleSave}
              // disabled={kycDocStatus !== "Success"}
              >
                Create
              </button>
            </div>
          )}
        </div>

      </div>

    </>
  );
};

export default BusinessSAFmanageForm;
